import { Component, RouteConfig as VueRouteConfig } from 'vue-router/types/router';

import {
	CollegesMostSuperBowlPlayers,
	ContentOverlapLp,
	CuratedList,
	ExpansionSeasonsMLS,
	NBAPlayoffs,
	New,
	Oscars2023,
	PlotRecommender,
	Popular,
	Search,
	ShareableLists,
	StreamGreen,
	SubscriberForm,
	Talent,
	TastyAds,
	Tesla,
	TitleDetail,
	TvRegistration,
	Upcoming,
	Valentine2023,
	Watchlist,
	WhatCulture,
} from '@/lazy-load-components';

import { WEB_LOCALES } from '@/constants/web-locales.constant';

import { CollectionType } from '@/enums/collection-type';
import { WebLocale } from '@/enums/web-locale';

import { TitleObjectType } from '@/interfaces/titles';

import { NewPageType } from '@/@types/graphql-types';
import { FilterCollection } from '@/stores/filter.store';

export interface RouterMeta {
	hasFilterBar?: boolean;
	collectionType?: CollectionType;
	// To distinguish different subpages of New
	newPageType?: NewPageType;
	// filters that will be implicitly loaded when the url initially loads
	initialRouteState?: Partial<FilterCollection>;
	contexts?: ('filter' | 'title')[]; // these route based contexts will be added additionally to every event
	tab:
		| 'coming-soon' // which target the route shall be loaded into
		| 'detail'
		| 'home'
		| 'landingpage'
		| 'leaving-soon'
		| 'lists'
		| 'new'
		| 'on-sale'
		| 'popular'
		| 'search'
		| 'sharedlist'
		| 'sports'
		| 'static'
		| 'talent'
		| 'tv'
		| 'upcoming'
		| 'watchlist';
	data?: any; // arbitrary data currently in use for <ion-tab>'s pages that share the same tab and need a way to distinguish them
}

interface RouteConfig {
	component?: Component;
	urls: Partial<Record<WebLocale, string>>;
	meta?: RouterMeta;
	redirect?: Partial<Record<WebLocale, string>>;
}

export type RouteNames = keyof typeof routeConfig;
export type ResolvedRouteConfig = Record<RouteNames, RouteConfig>;

export const routeConfig = {
	// export const routeConfig: Record<string, RouteConfig> = {
	// --- POPULAR ---
	'app.titles.popular.european': {
		component: Popular,
		urls: {
			ad: 'made-in-europe',
			ae: 'made-in-europe',
			ag: 'made-in-europe',
			al: 'made-in-europe',
			az: 'made-in-europe',
			ao: 'made-in-europe',
			ar: 'made-in-europe',
			at: 'made-in-europe',
			au: 'made-in-europe',
			ba: 'made-in-europe',
			bb: 'made-in-europe',
			be: 'made-in-europe',
			bf: 'made-in-europe',
			bg: 'made-in-europe',
			bh: 'made-in-europe',
			bm: 'made-in-europe',
			br: 'made-in-europe',
			bs: 'made-in-europe',
			by: 'made-in-europe',
			bz: 'made-in-europe',
			ca: 'made-in-europe',
			cd: 'made-in-europe',
			ch: 'made-in-europe',
			ci: 'made-in-europe',
			cl: 'made-in-europe',
			cm: 'made-in-europe',
			co: 'made-in-europe',
			cu: 'made-in-europe',
			cv: 'made-in-europe',
			cy: 'made-in-europe',
			cz: 'made-in-europe',
			de: 'made-in-europe',
			dk: 'made-in-europe',
			do: 'made-in-europe',
			dz: 'made-in-europe',
			ec: 'made-in-europe',
			ee: 'made-in-europe',
			eg: 'made-in-europe',
			es: 'made-in-europe',
			fi: 'made-in-europe',
			fj: 'made-in-europe',
			fr: 'made-in-europe',
			gf: 'made-in-europe',
			gg: 'made-in-europe',
			gh: 'made-in-europe',
			gi: 'made-in-europe',
			gq: 'made-in-europe',
			gr: 'made-in-europe',
			gy: 'made-in-europe',
			hk: 'made-in-europe',
			hr: 'made-in-europe',
			hu: 'made-in-europe',
			id: 'made-in-europe',
			ie: 'made-in-europe',
			il: 'made-in-europe',
			in: 'made-in-europe',
			iq: 'made-in-europe',
			is: 'made-in-europe',
			it: 'made-in-europe',
			jm: 'made-in-europe',
			jo: 'made-in-europe',
			jp: 'made-in-europe',
			ke: 'made-in-europe',
			kr: 'made-in-europe',
			kw: 'made-in-europe',
			lb: 'made-in-europe',
			lc: 'made-in-europe',
			li: 'made-in-europe',
			lt: 'made-in-europe',
			lu: 'made-in-europe',
			lv: 'made-in-europe',
			ly: 'made-in-europe',
			ma: 'made-in-europe',
			mc: 'made-in-europe',
			md: 'made-in-europe',
			me: 'made-in-europe',
			mg: 'made-in-europe',
			mk: 'made-in-europe',
			ml: 'made-in-europe',
			mt: 'made-in-europe',
			mu: 'made-in-europe',
			mw: 'made-in-europe',
			mx: 'made-in-europe',
			my: 'made-in-europe',
			mz: 'made-in-europe',
			ne: 'made-in-europe',
			ng: 'made-in-europe',
			ni: 'made-in-europe',
			nl: 'made-in-europe',
			no: 'made-in-europe',
			nz: 'made-in-europe',
			om: 'made-in-europe',
			pa: 'made-in-europe',
			pe: 'made-in-europe',
			pf: 'made-in-europe',
			pg: 'made-in-europe',
			ph: 'made-in-europe',
			pk: 'made-in-europe',
			pl: 'made-in-europe',
			ps: 'made-in-europe',
			pt: 'made-in-europe',
			qa: 'made-in-europe',
			ro: 'made-in-europe',
			rs: 'made-in-europe',
			ru: 'made-in-europe',
			sa: 'made-in-europe',
			sc: 'made-in-europe',
			se: 'made-in-europe',
			sg: 'made-in-europe',
			sk: 'made-in-europe',
			si: 'made-in-europe',
			sm: 'made-in-europe',
			sn: 'made-in-europe',
			sv: 'made-in-europe',
			tc: 'made-in-europe',
			td: 'made-in-europe',
			th: 'made-in-europe',
			tn: 'made-in-europe',
			tr: 'made-in-europe',
			tt: 'made-in-europe',
			tw: 'made-in-europe',
			tz: 'made-in-europe',
			ua: 'made-in-europe',
			ug: 'made-in-europe',
			uk: 'made-in-europe',
			us: 'made-in-europe',
			uy: 'made-in-europe',
			va: 'made-in-europe',
			ve: 'made-in-europe',
			xk: 'made-in-europe',
			ye: 'made-in-europe',
			za: 'made-in-europe',
			zm: 'made-in-europe',
			zw: 'made-in-europe',
		},
		meta: { hasFilterBar: true, collectionType: CollectionType.POPULAR, contexts: ['filter'], tab: 'popular' },
	},
	'app.titles.popular.list': {
		component: Popular,
		urls: Object.keys(WEB_LOCALES).reduce((root: any, webLocale) => {
			root[webLocale] = '';
			return root;
		}, {}),
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.POPULAR,
			initialRouteState: {},
			contexts: ['filter'],
			tab: 'popular',
		},
	},
	'app.titles.popular.movie': {
		component: Popular,
		urls: {
			ad: 'pellicules',
			ae: 'movies',
			ag: 'movies',
			al: 'filmat',
			az: 'filmlər',
			ao: 'filmes',
			ar: 'peliculas',
			at: 'Filme',
			au: 'movies',
			ba: 'film',
			bb: 'movies',
			be: 'films',
			bf: 'films',
			bg: 'филми',
			bh: 'movies',
			bm: 'movies',
			bo: 'peliculas',
			br: 'filmes',
			bs: 'movies',
			by: 'фільмы',
			bz: 'movies',
			ca: 'movies',
			cd: 'films',
			ch: 'Filme',
			ci: 'films',
			cl: 'peliculas',
			cm: 'movies',
			co: 'peliculas',
			cr: 'peliculas',
			cu: 'peliculas',
			cv: 'filmes',
			cy: 'ταινίες',
			cz: 'filmy',
			de: 'Filme',
			dk: 'movies',
			do: 'peliculas',
			dz: 'movies',
			ec: 'peliculas',
			ee: 'filmid',
			eg: 'movies',
			es: 'peliculas',
			fi: 'elokuvat',
			fj: 'movies',
			fr: 'films',
			gf: 'films',
			gg: 'movies',
			gh: 'movies',
			gi: 'movies',
			gq: 'peliculas',
			gr: 'ταινίες',
			gt: 'peliculas',
			gy: 'movies',
			hk: '電影',
			hn: 'peliculas',
			hr: 'filmovi',
			hu: 'filmek',
			id: 'movies',
			ie: 'movies',
			il: 'movies',
			in: 'movies',
			iq: 'movies',
			is: 'kvikmyndir',
			it: 'film',
			jm: 'movies',
			jo: 'movies',
			jp: '映画',
			ke: 'movies',
			kr: '영화',
			kw: 'movies',
			lb: 'movies',
			lc: 'movies',
			li: 'Filme',
			lt: 'filmai',
			lu: 'films',
			lv: 'filmas',
			ly: 'movies',
			ma: 'movies',
			mc: 'films',
			md: 'filme',
			me: 'filmovi',
			mg: 'films',
			mk: 'филмови',
			ml: 'films',
			mt: 'films',
			mu: 'films',
			mw: 'movies',
			mx: 'peliculas',
			my: 'movies',
			mz: 'filmes',
			ne: 'films',
			ng: 'movies',
			ni: 'peliculas',
			nl: 'movies',
			no: 'movies',
			nz: 'movies',
			om: 'movies',
			pa: 'peliculas',
			pe: 'peliculas',
			pf: 'films',
			pg: 'movies',
			ph: 'movies',
			pk: 'movies',
			pl: 'filmy',
			ps: 'movies',
			pt: 'filmes',
			py: 'peliculas',
			qa: 'movies',
			ro: 'filme',
			rs: 'filmovi',
			ru: 'фильмы',
			sa: 'movies',
			sc: 'films',
			se: 'filmer',
			sg: 'movies',
			sk: 'filmy',
			si: 'filmi',
			sm: 'film',
			sn: 'films',
			sv: 'peliculas',
			tc: 'movies',
			td: 'movies',
			th: 'movies',
			tn: 'movies',
			tr: 'filmler',
			tt: 'movies',
			tw: '電影',
			tz: 'filamu',
			ua: 'фільми',
			ug: 'movies',
			uk: 'movies',
			us: 'movies',
			uy: 'peliculas',
			va: 'film',
			ve: 'peliculas',
			xk: 'filmat',
			ye: 'movies',
			za: 'movies',
			zm: 'movies',
			zw: 'movies',
		},
		redirect: {
			dk: 'film',
			id: 'film',
			lt: 'filmai',
			lv: 'filmas',
			my: 'filem',
			no: 'filmer',
			se: 'filmer',
			th: 'ภาพยนต์',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.POPULAR,
			initialRouteState: { content_types: [TitleObjectType.MOVIE] },
			contexts: ['filter'],
			tab: 'popular',
		},
	},
	'app.titles.popular.show': {
		component: Popular,
		urls: {
			ad: 'series',
			ae: 'tv-shows',
			ag: 'tv-shows',
			al: 'seriale-televizive',
			az: 'televiziya-şouları',
			ao: 'series',
			ar: 'series',
			at: 'Serien',
			au: 'tv-shows',
			ba: 'tv-serije',
			bb: 'tv-shows',
			be: 'series',
			bf: 'series',
			bg: 'сериали',
			bh: 'tv-shows',
			bm: 'tv-shows',
			bo: 'series',
			br: 'series',
			bs: 'tv-shows',
			by: 'сезон',
			bz: 'tv-shows',
			ca: 'tv-shows',
			cd: 'series',
			ch: 'Serien',
			ci: 'series',
			cl: 'series',
			cm: 'tv-shows',
			co: 'series',
			cr: 'series',
			cu: 'series',
			cv: 'series',
			cy: 'τηλεοπτικές-σειρές',
			cz: 'serialy',
			de: 'Serien',
			dk: 'tv-series',
			do: 'series',
			dz: 'tv-shows',
			ec: 'series',
			ee: 'seriaalid',
			eg: 'tv-shows',
			es: 'series',
			fi: 'sarjat',
			fj: 'tv-shows',
			fr: 'series',
			gf: 'series',
			gg: 'tv-series',
			gh: 'movies',
			gi: 'tv-shows',
			gq: 'series',
			gr: 'τηλεοπτικές-σειρές',
			gt: 'series',
			gy: 'tv-shows',
			hk: '節目',
			hn: 'series',
			hr: 'serije',
			hu: 'tv-sorozat',
			id: 'tv-shows',
			ie: 'tv-series',
			il: 'tv-shows',
			in: 'tv-shows',
			iq: 'tv-shows',
			is: 'þættir',
			it: 'serie-tv',
			jm: 'tv-shows',
			jo: 'tv-shows',
			jp: 'テレビ番組',
			ke: 'tv-shows',
			kr: 'TV-프로그램',
			kw: 'tv-shows',
			lb: 'tv-shows',
			lc: 'tv-shows',
			li: 'Serien',
			lt: 'tv-laidos',
			lu: 'series',
			lv: 'tv-pārraide',
			ly: 'tv-shows',
			ma: 'tv-shows',
			mc: 'series',
			md: 'seriale',
			me: 'tv-programi',
			mg: 'series',
			mk: 'тв-серии',
			ml: 'series',
			mt: 'serje-televiżivi',
			mu: 'series',
			mw: 'tv-shows',
			mx: 'series',
			my: 'tv-shows',
			mz: 'series',
			ne: 'series',
			ng: 'tv-shows',
			ni: 'series',
			nl: 'tv-series',
			no: 'tv-series',
			nz: 'tv-shows',
			om: 'tv-shows',
			pa: 'series',
			pe: 'series',
			pf: 'series',
			pg: 'tv-shows',
			ph: 'tv-shows',
			pk: 'tv-shows',
			pl: 'seriale',
			ps: 'tv-shows',
			pt: 'series',
			py: 'series',
			qa: 'tv-shows',
			ro: 'seriale',
			rs: 'tv-programi',
			ru: 'сериалы',
			sc: 'series',
			sa: 'tv-shows',
			se: 'tv-serier',
			sg: 'tv-shows',
			sk: 'seriály',
			si: 'serije',
			sm: 'serie-tv',
			sn: 'series',
			sv: 'series',
			tc: 'tv-shows',
			td: 'tv-shows',
			th: 'tv-shows',
			tn: 'tv-shows',
			tr: 'tv-dizileri',
			tt: 'tv-shows',
			tw: '節目',
			tz: 'maonyesho-ya-tv',
			ua: 'телесеріали',
			ug: 'tv-shows',
			uk: 'tv-series',
			us: 'tv-shows',
			uy: 'series',
			va: 'serie-tv',
			ve: 'series',
			xk: 'seriale-televizive',
			ye: 'tv-shows',
			za: 'tv-series',
			zm: 'tv-series',
			zw: 'tv-shows',
		},
		redirect: {
			dk: 'tv-serier',
			id: 'acara-tv',
			lt: 'tv-laidos',
			lv: 'tv-pārraide',
			my: 'rancangan-tv',
			no: 'tv-serier',
			se: 'tv-serier',
			th: 'รายการทีวี',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.POPULAR,
			initialRouteState: { content_types: [TitleObjectType.SHOW] },
			contexts: ['filter'],
			tab: 'popular',
		},
	},
	'app.titles.popular.provider': {
		component: Popular,
		urls: {
			ad: 'plataforma/:provider',
			ae: 'provider/:provider',
			ag: 'provider/:provider',
			al: 'ofruesi/:provider',
			az: 'provayder/:provider',
			ao: 'provedor/:provider',
			ar: 'proveedor/:provider',
			at: 'Anbieter/:provider',
			au: 'provider/:provider',
			ba: 'provajder/:provider',
			bb: 'provider/:provider',
			be: 'plateforme/:provider',
			bf: 'plateforme/:provider',
			bg: 'доставчик/:provider',
			bh: 'provider/:provider',
			bm: 'provider/:provider',
			bo: 'proveedor/:provider',
			br: 'provedor/:provider',
			bs: 'provider/:provider',
			by: 'правайдэр/:provider',
			bz: 'provider/:provider',
			ca: 'provider/:provider',
			cd: 'plateforme/:provider',
			ch: 'Anbieter/:provider',
			ci: 'plateforme/:provider',
			cl: 'proveedor/:provider',
			cm: 'provider/:provider',
			co: 'proveedor/:provider',
			cr: 'proveedor/:provider',
			cu: 'proveedor/:provider',
			cv: 'provedor/:provider',
			cy: 'πάροχος/:provider',
			cz: 'poskytovatel/:provider',
			de: 'Anbieter/:provider',
			dk: 'provider/:provider',
			do: 'proveedor/:provider',
			dz: 'provider/:provider',
			ec: 'proveedor/:provider',
			ee: 'teenusepakkuja/:provider',
			eg: 'provider/:provider',
			es: 'proveedor/:provider',
			fi: 'palvelu/:provider',
			fj: 'provider/:provider',
			fr: 'plateforme/:provider',
			gf: 'plateforme/:provider',
			gg: 'provider/:provider',
			gh: 'provider/:provider',
			gi: 'provider/:provider',
			gq: 'proveedor/:provider',
			gr: 'πάροχος/:provider',
			gt: 'proveedor/:provider',
			gy: 'provider/:provider',
			hk: '供應商/:provider',
			hn: 'proveedor/:provider',
			hr: 'pružatelj-usluge/:provider',
			hu: 'szolgaltato/:provider',
			id: 'provider/:provider',
			ie: 'provider/:provider',
			il: 'provider/:provider',
			in: 'provider/:provider',
			iq: 'provider/:provider',
			is: 'veita/:provider',
			it: 'provider/:provider',
			jm: 'provider/:provider',
			jo: 'provider/:provider',
			jp: '動画配信サービス/:provider',
			ke: 'provider/:provider',
			kr: '동영상서비스/:provider',
			kw: 'provider/:provider',
			lb: 'provider/:provider',
			lc: 'provider/:provider',
			li: 'Anbieter/:provider',
			lt: 'tiekėjas/:provider',
			lu: 'plateforme/:provider',
			lv: 'apgādātājs/:provider',
			ly: 'provider/:provider',
			ma: 'provider/:provider',
			mc: 'plateforme/:provider',
			md: 'furnizor/:provider',
			me: 'provajder/:provider',
			mg: 'plateforme/:provider',
			mk: 'провајдер/:provider',
			ml: 'plateforme/:provider',
			mt: 'fornitur/:provider',
			mu: 'plateforme/:provider',
			mw: 'provider/:provider',
			mx: 'proveedor/:provider',
			my: 'provider/:provider',
			mz: 'provedor/:provider',
			ne: 'plateforme/:provider',
			ng: 'provider/:provider',
			ni: 'proveedor/:provider',
			nl: 'provider/:provider',
			no: 'provider/:provider',
			nz: 'provider/:provider',
			om: 'provider/:provider',
			pa: 'proveedor/:provider',
			pe: 'proveedor/:provider',
			pf: 'plateforme/:provider',
			pg: 'provider/:provider',
			ph: 'provider/:provider',
			pk: 'provider/:provider',
			pl: 'serwis-streamingowy/:provider',
			ps: 'provider/:provider',
			pt: 'provedor/:provider',
			py: 'proveedor/:provider',
			qa: 'provider/:provider',
			ro: 'furnizor/:provider',
			rs: 'provajder/:provider',
			ru: 'провайдер/:provider',
			sa: 'provider/:provider',
			sc: 'plateforme/:provider',
			se: 'leverantör/:provider',
			sg: 'provider/:provider',
			sk: 'poskytovateľ/:provider',
			si: 'ponudnik/:provider',
			sm: 'provider/:provider',
			sn: 'plateforme/:provider',
			sv: 'proveedor/:provider',
			tc: 'provider/:provider',
			td: 'provider/:provider',
			th: 'provider/:provider',
			tn: 'provider/:provider',
			tr: 'saglayici/:provider',
			tt: 'provider/:provider',
			tw: '平台/:provider',
			tz: 'mtoa-huduma/:provider',
			ua: 'провайдер/:provider',
			ug: 'provider/:provider',
			uk: 'provider/:provider',
			us: 'provider/:provider',
			uy: 'proveedor/:provider',
			va: 'provider/:provider',
			ve: 'proveedor/:provider',
			xk: 'ofruesi/:provider',
			ye: 'provider/:provider',
			za: 'provider/:provider',
			zm: 'provider/:provider',
			zw: 'provider/:provider',
		},
		redirect: {
			dk: 'udbyder/:provider',
			id: 'penyedia/:provider',
			lt: 'tiekėjas/:provider',
			lv: 'apgādātājs/:provider',
			my: 'pemberi/:provider',
			no: 'tjeneste/:provider',
			se: 'leverantör/:provider',
			th: 'ผู้ให้บริการ/:provider',
		},
		meta: { hasFilterBar: true, collectionType: CollectionType.POPULAR, contexts: ['filter'], tab: 'popular' },
	},

	'app.titles.popular.provider-movie': {
		component: Popular,
		urls: {
			ad: 'plataforma/:provider/pellicules',
			ae: 'provider/:provider/movies',
			ag: 'provider/:provider/movies',
			al: 'ofruesi/:provider/filmat',
			az: 'provayder/:provider/filmlər',
			ao: 'provedor/:provider/filmes',
			ar: 'proveedor/:provider/peliculas',
			at: 'Anbieter/:provider/Filme',
			au: 'provider/:provider/movies',
			ba: 'provajder/:provider/filmovi',
			bb: 'provider/:provider/movies',
			be: 'plateforme/:provider/films',
			bf: 'plateforme/:provider/films',
			bg: 'доставчик/:provider/филми',
			bh: 'provider/:provider/movies',
			bm: 'provider/:provider/movies',
			bo: 'proveedor/:provider/peliculas',
			br: 'provedor/:provider/filmes',
			bs: 'provider/:provider/movies',
			by: 'правайдэр/:provider/фільмы',
			bz: 'provider/:provider/movies',
			ca: 'provider/:provider/movies',
			cd: 'plateforme/:provider/films',
			ch: 'Anbieter/:provider/Filme',
			ci: 'plateforme/:provider/films',
			cl: 'proveedor/:provider/peliculas',
			cm: 'provider/:provider/movies',
			co: 'proveedor/:provider/peliculas',
			cr: 'proveedor/:provider/peliculas',
			cu: 'proveedor/:provider/peliculas',
			cv: 'provedor/:provider/filmes',
			cy: 'πάροχος/:provider/ταινίες',
			cz: 'poskytovatel/:provider/filmy',
			de: 'Anbieter/:provider/Filme',
			dk: 'provider/:provider/movies',
			do: 'proveedor/:provider/peliculas',
			dz: 'provider/:provider/movies',
			ec: 'proveedor/:provider/peliculas',
			ee: 'teenusepakkuja/:provider/filmid',
			eg: 'provider/:provider/movies',
			es: 'proveedor/:provider/peliculas',
			fi: 'palvelu/:provider/elokuvat',
			fj: 'provider/:provider/movies',
			fr: 'plateforme/:provider/films',
			gf: 'plateforme/:provider/films',
			gg: 'provider/:provider/movies',
			gh: 'provider/:provider/movies',
			gi: 'provider/:provider/movies',
			gq: 'proveedor/:provider/peliculas',
			gr: 'πάροχος/:provider/ταινίες',
			gt: 'proveedor/:provider/peliculas',
			gy: 'provider/:provider/movies',
			hk: '供應商/:provider/電影',
			hn: 'proveedor/:provider/peliculas',
			hr: 'pružatelj-usluge/:provider/filmovi',
			hu: 'szolgaltato/:provider/filmek',
			id: 'provider/:provider/movies',
			ie: 'provider/:provider/movies',
			il: 'provider/:provider/movies',
			in: 'provider/:provider/movies',
			iq: 'provider/:provider/movies',
			is: 'veita/:provider/kvikmyndir',
			it: 'provider/:provider/film',
			jm: 'provider/:provider/movies',
			jo: 'provider/:provider/movies',
			jp: '動画配信サービス/:provider/映画',
			ke: 'provider/:provider/movies',
			kr: '동영상서비스/:provider/영화',
			kw: 'provider/:provider/movies',
			lb: 'provider/:provider/movies',
			lc: 'provider/:provider/movies',
			li: 'Anbieter/:provider/Filme',
			lt: 'tiekėjas/:provider/filmai',
			lu: 'plateforme/:provider/films',
			lv: 'apgādātājs/:provider/filmas',
			ly: 'provider/:provider/movies',
			ma: 'provider/:provider/movies',
			mc: 'plateforme/:provider/films',
			md: 'furnizor/:provider/filme',
			me: 'provajder/:provider/filmovi',
			mg: 'plateforme/:provider/films',
			mk: 'провајдер/:provider/филмови',
			ml: 'plateforme/:provider/films',
			mt: 'fornitur/:provider/films',
			mu: 'plateforme/:provider/films',
			mw: 'provider/:provider/movies',
			mx: 'proveedor/:provider/peliculas',
			my: 'provider/:provider/movies',
			mz: 'provedor/:provider/filmes',
			ne: 'plateforme/:provider/films',
			ng: 'provider/:provider/movies',
			ni: 'proveedor/:provider/peliculas',
			nl: 'provider/:provider/movies',
			no: 'provider/:provider/movies',
			nz: 'provider/:provider/movies',
			om: 'provider/:provider/movies',
			pa: 'proveedor/:provider/peliculas',
			pe: 'proveedor/:provider/peliculas',
			pf: 'plateforme/:provider/films',
			pg: 'provider/:provider/movies',
			ph: 'provider/:provider/movies',
			pk: 'provider/:provider/movies',
			pl: 'serwis-streamingowy/:provider/filmy',
			ps: 'provider/:provider/movies',
			pt: 'provedor/:provider/filmes',
			py: 'proveedor/:provider/peliculas',
			qa: 'provider/:provider/movies',
			ro: 'furnizor/:provider/filme',
			rs: 'provajder/:provider/filmovi',
			ru: 'провайдер/:provider/фильмы',
			sa: 'provider/:provider/movies',
			sc: 'plateforme/:provider/films',
			se: 'leverantör/:provider/filmer',
			sg: 'provider/:provider/movies',
			sk: 'poskytovateľ/:provider/filmy',
			si: 'ponudnik/:provider/filmi',
			sm: 'provider/:provider/film',
			sn: 'plateforme/:provider/films',
			sv: 'proveedor/:provider/peliculas',
			tc: 'provider/:provider/movies',
			td: 'provider/:provider/movies',
			th: 'provider/:provider/movies',
			tn: 'provider/:provider/movies',
			tr: 'saglayici/:provider/filmler',
			tt: 'provider/:provider/movies',
			tw: '平台/:provider/電影',
			tz: 'mtoa-huduma/:provider/filamu',
			ua: 'провайдер/:provider/фільми',
			ug: 'provider/:provider/movies',
			uk: 'provider/:provider/movies',
			us: 'provider/:provider/movies',
			uy: 'proveedor/:provider/peliculas',
			va: 'provider/:provider/film',
			ve: 'proveedor/:provider/peliculas',
			xk: 'ofruesi/:provider/filmat',
			ye: 'provider/:provider/movies',
			za: 'provider/:provider/movies',
			zm: 'provider/:provider/movies',
			zw: 'provider/:provider/movies',
		},
		redirect: {
			dk: 'udbyder/:provider/film',
			id: 'penyedia/:provider/film',
			lt: 'tiekėjas/:provider/filmai',
			lv: 'apgādātājs/:provider/filmas',
			my: 'pemberi/:provider/filem',
			no: 'tjeneste/:provider/filmer',
			se: 'leverantör/:provider/filmer',
			th: 'ผู้ให้บริการ/:provider/ภาพยนต์',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.POPULAR,
			initialRouteState: { content_types: [TitleObjectType.MOVIE] },
			contexts: ['filter'],
			tab: 'popular',
		},
	},
	'app.titles.popular.provider-show': {
		component: Popular,
		urls: {
			ad: 'plataforma/:provider/series',
			ae: 'provider/:provider/tv-shows',
			ag: 'provider/:provider/tv-shows',
			al: 'ofruesi/:provider/seriale-televizive',
			az: 'provayder/:provider/televiziya-şouları',
			ao: 'provedor/:provider/series',
			ar: 'proveedor/:provider/series',
			at: 'Anbieter/:provider/Serien',
			au: 'provider/:provider/tv-shows',
			ba: 'provajder/:provider/tv-serije',
			bb: 'provider/:provider/tv-shows',
			be: 'plateforme/:provider/series',
			bf: 'plateforme/:provider/series',
			bg: 'доставчик/:provider/сериали',
			bh: 'provider/:provider/tv-shows',
			bm: 'provider/:provider/tv-shows',
			bo: 'proveedor/:provider/series',
			br: 'provedor/:provider/series',
			bs: 'provider/:provider/tv-shows',
			by: 'правайдэр/:provider/сезон',
			bz: 'provider/:provider/tv-shows',
			ca: 'provider/:provider/tv-shows',
			cd: 'plateforme/:provider/series',
			ch: 'Anbieter/:provider/Serien',
			ci: 'plateforme/:provider/series',
			cl: 'proveedor/:provider/series',
			cm: 'provider/:provider/tv-shows',
			co: 'proveedor/:provider/series',
			cr: 'proveedor/:provider/series',
			cu: 'proveedor/:provider/series',
			cv: 'provedor/:provider/series',
			cy: 'πάροχος/:provider/τηλεοπτικές-σειρές',
			cz: 'poskytovatel/:provider/serialy',
			de: 'Anbieter/:provider/Serien',
			dk: 'provider/:provider/tv-series',
			do: 'proveedor/:provider/series',
			dz: 'provider/:provider/tv-shows',
			ec: 'proveedor/:provider/series',
			ee: 'teenusepakkuja/:provider/seriaalid',
			eg: 'provider/:provider/tv-shows',
			es: 'proveedor/:provider/series',
			fi: 'palvelu/:provider/sarjat',
			fj: 'provider/:provider/tv-shows',
			fr: 'plateforme/:provider/series',
			gf: 'plateforme/:provider/series',
			gg: 'provider/:provider/tv-series',
			gh: 'provider/:provider/tv-shows',
			gi: 'provider/:provider/tv-shows',
			gq: 'proveedor/:provider/series',
			gr: 'πάροχος/:provider/τηλεοπτικές-σειρές',
			gt: 'proveedor/:provider/series',
			gy: 'provider/:provider/tv-shows',
			hk: '供應商/:provider/節目',
			hn: 'proveedor/:provider/series',
			hr: 'pružatelj-usluge/:provider/serije',
			hu: 'szolgaltato/:provider/tv-sorozat',
			id: 'provider/:provider/tv-shows',
			ie: 'provider/:provider/tv-series',
			il: 'provider/:provider/tv-shows',
			in: 'provider/:provider/tv-shows',
			iq: 'provider/:provider/tv-shows',
			is: 'veita/:provider/þættir',
			it: 'provider/:provider/serie-tv',
			jm: 'provider/:provider/tv-shows',
			jo: 'provider/:provider/tv-shows',
			jp: '動画配信サービス/:provider/テレビ番組',
			ke: 'provider/:provider/tv-shows',
			kr: '동영상서비스/:provider/TV-프로그램',
			kw: 'provider/:provider/tv-shows',
			lb: 'provider/:provider/tv-shows',
			lc: 'provider/:provider/tv-shows',
			li: 'Anbieter/:provider/Serien',
			lt: 'tiekėjas/:provider/tv-laidos',
			lu: 'plateforme/:provider/series',
			lv: 'apgādātājs/:provider/tv-pārraide',
			ly: 'provider/:provider/tv-shows',
			ma: 'provider/:provider/tv-shows',
			mc: 'plateforme/:provider/series',
			md: 'furnizor/:provider/seriale',
			me: 'provajder/:provider/tv-programi',
			mg: 'plateforme/:provider/series',
			mk: 'провајдер/:provider/тв-серии',
			ml: 'plateforme/:provider/series',
			mt: 'fornitur/:provider/serje-televiżivi',
			mu: 'plateforme/:provider/series',
			mw: 'provider/:provider/tv-shows',
			mx: 'proveedor/:provider/series',
			my: 'provider/:provider/tv-shows',
			mz: 'provedor/:provider/series',
			ne: 'plateforme/:provider/series',
			ng: 'provider/:provider/tv-shows',
			ni: 'proveedor/:provider/series',
			nl: 'provider/:provider/tv-series',
			no: 'provider/:provider/tv-series',
			nz: 'provider/:provider/tv-shows',
			om: 'provider/:provider/tv-shows',
			pa: 'proveedor/:provider/series',
			pe: 'proveedor/:provider/series',
			pf: 'plateforme/:provider/series',
			pg: 'provider/:provider/tv-shows',
			ph: 'provider/:provider/tv-shows',
			pk: 'provider/:provider/tv-shows',
			pl: 'serwis-streamingowy/:provider/seriale',
			ps: 'provider/:provider/tv-shows',
			pt: 'provedor/:provider/series',
			py: 'proveedor/:provider/series',
			qa: 'provider/:provider/tv-shows',
			ro: 'furnizor/:provider/seriale',
			rs: 'provajder/:provider/tv-programi',
			ru: 'провайдер/:provider/сериалы',
			sa: 'provider/:provider/tv-shows',
			sc: 'plateforme/:provider/series',
			se: 'leverantör/:provider/tv-serier',
			sg: 'provider/:provider/tv-shows',
			sk: 'poskytovateľ/:provider/seriály',
			si: 'ponudnik/:provider/serije',
			sm: 'provider/:provider/serie-tv',
			sn: 'plateforme/:provider/series',
			sv: 'proveedor/:provider/series',
			tc: 'provider/:provider/tv-shows',
			td: 'provider/:provider/tv-shows',
			th: 'provider/:provider/tv-shows',
			tn: 'provider/:provider/tv-shows',
			tr: 'saglayici/:provider/tv-dizileri',
			tt: 'provider/:provider/tv-shows',
			tw: '平台/:provider/節目',
			tz: 'mtoa-huduma/:provider/maonyesho-ya-tv',
			ua: 'провайдер/:provider/телесеріали',
			ug: 'provider/:provider/tv-shows',
			uk: 'provider/:provider/tv-series',
			us: 'provider/:provider/tv-shows',
			uy: 'proveedor/:provider/series',
			va: 'provider/:provider/serie-tv',
			ve: 'proveedor/:provider/series',
			xk: 'ofruesi/:provider/seriale-televizive',
			ye: 'provider/:provider/tv-shows',
			za: 'provider/:provider/tv-series',
			zm: 'provider/:provider/tv-series',
			zw: 'provider/:provider/tv-shows',
		},
		redirect: {
			dk: 'udbyder/:provider/tv-serier',
			id: 'penyedia/:provider/acara-tv',
			lt: 'tiekėjas/:provider/tv-laidos',
			lv: 'apgādātājs/:provider/tv-pārraide',
			my: 'pemberi/:provider/rancangan-tv',
			no: 'tjeneste/:provider/tv-serier',
			se: 'leverantör/:provider/tv-serier',
			th: 'ผู้ให้บริการ/:provider/รายการทีวี',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.POPULAR,
			initialRouteState: { content_types: [TitleObjectType.SHOW] },
			contexts: ['filter'],
			tab: 'popular',
		},
	},

	'app.titles.popular.provider-plans': {
		component: Popular,
		urls: {
			us: 'provider/:provider/plans',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.POPULAR,
			initialRouteState: { content_types: [TitleObjectType.DEALS_SUBSCRIPTION] },
			contexts: ['filter'],
			tab: 'popular',
		},
	},

	// --- NEW ---
	'app.titles.new.list': {
		component: New,
		urls: {
			ad: 'nou',
			ae: 'new',
			ag: 'new',
			al: 'risitë',
			az: 'yeni',
			ao: 'novo',
			ar: 'nuevo',
			at: 'Neu',
			au: 'new',
			ba: 'novo',
			bb: 'new',
			be: 'nouveau',
			bf: 'nouveau',
			bg: 'нови',
			bh: 'new',
			bm: 'new',
			bo: 'nuevo',
			br: 'novo',
			bs: 'new',
			by: 'новыя',
			bz: 'new',
			ca: 'new',
			cd: 'nouveau',
			ch: 'Neu',
			ci: 'nouveau',
			cl: 'nuevo',
			cm: 'new',
			co: 'nuevo',
			cr: 'nuevo',
			cu: 'nuevo',
			cv: 'novo',
			cy: 'νέα',
			cz: 'novinky',
			de: 'Neu',
			dk: 'new',
			do: 'nuevo',
			dz: 'new',
			ec: 'nuevo',
			ee: 'uus',
			eg: 'new',
			es: 'nuevo',
			fi: 'uudet',
			fj: 'new',
			fr: 'nouveau',
			gf: 'nouveau',
			gg: 'new',
			gh: 'new',
			gi: 'new',
			gq: 'nuevo',
			gr: 'νέα',
			gt: 'nuevo',
			gy: 'new',
			hk: '最新',
			hn: 'nuevo',
			hr: 'novo',
			hu: 'uj',
			id: 'new',
			ie: 'new',
			il: 'new',
			in: 'new',
			iq: 'new',
			is: 'ný',
			it: 'novità',
			jm: 'new',
			jo: 'new',
			jp: '新作',
			ke: 'new',
			kr: '최신',
			kw: 'new',
			lb: 'new',
			lc: 'new',
			li: 'Neu',
			lt: 'nauji',
			lu: 'nouveau',
			lv: 'jauns',
			ly: 'new',
			ma: 'new',
			mc: 'nouveau',
			md: 'nou',
			me: 'novo',
			mg: 'nouveau',
			mk: 'ново',
			ml: 'nouveau',
			mt: 'ġdid',
			mu: 'nouveau',
			mw: 'new',
			mx: 'nuevo',
			my: 'new',
			mz: 'novo',
			ne: 'nouveau',
			ng: 'new',
			ni: 'nuevo',
			nl: 'new',
			no: 'new',
			nz: 'new',
			om: 'new',
			pa: 'nuevo',
			pe: 'nuevo',
			pf: 'nouveau',
			pg: 'new',
			ph: 'new',
			pk: 'new',
			pl: 'nowe',
			ps: 'new',
			pt: 'novo',
			py: 'nuevo',
			qa: 'new',
			ro: 'nou',
			rs: 'novo',
			ru: 'новое',
			sa: 'new',
			sc: 'nouveau',
			se: 'nya',
			sg: 'new',
			sk: 'nový',
			si: 'novo',
			sm: 'novità',
			sn: 'nouveau',
			sv: 'nuevo',
			tc: 'new',
			td: 'new',
			th: 'new',
			tn: 'new',
			tr: 'yeni',
			tt: 'new',
			tw: '最新',
			tz: 'mpya',
			ua: 'новинки',
			ug: 'new',
			uk: 'new',
			us: 'new',
			uy: 'nuevo',
			va: 'novità',
			ve: 'nuevo',
			xk: 'risitë',
			ye: 'new',
			za: 'new',
			zm: 'new',
			zw: 'new',
		},
		redirect: {
			dk: 'nyt',
			id: 'baru',
			lt: 'nauji',
			lv: 'jauns',
			my: 'terkini',
			no: 'nyheter',
			se: 'nya',
			th: 'ใหม่',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.New,
			contexts: ['filter'],
			tab: 'new',
		},
	},
	'app.titles.new.movie': {
		component: New,
		urls: {
			ad: 'pellicules/nou',
			ae: 'movies/new',
			ag: 'movies/new',
			al: 'filmat/risitë',
			az: 'filmlər/yeni',
			ao: 'filmes/novo',
			ar: 'peliculas/nuevo',
			at: 'Filme/Neu',
			au: 'movies/new',
			ba: 'filmovi/novo',
			bb: 'movies/new',
			be: 'films/nouveau',
			bf: 'films/nouveau',
			bg: 'филми/нови',
			bh: 'movies/new',
			bm: 'movies/new',
			bo: 'peliculas/nuevo',
			br: 'filmes/novo',
			bs: 'movies/new',
			by: 'фільмы/новыя',
			bz: 'movies/new',
			ca: 'movies/new',
			cd: 'films/nouveau',
			ch: 'Filme/Neu',
			ci: 'films/nouveau',
			cl: 'peliculas/nuevo',
			cm: 'movies/new',
			co: 'peliculas/nuevo',
			cr: 'peliculas/nuevo',
			cu: 'peliculas/nuevo',
			cv: 'filmes/novo',
			cy: 'ταινίες/νέα',
			cz: 'filmy/novinky',
			de: 'Filme/Neu',
			dk: 'movies/new',
			do: 'peliculas/nuevo',
			dz: 'movies/new',
			ec: 'peliculas/nuevo',
			ee: 'filmid/uus',
			eg: 'movies/new',
			es: 'peliculas/nuevo',
			fi: 'elokuvat/uudet',
			fj: 'movies/new',
			fr: 'films/nouveau',
			gf: 'films/nouveau',
			gg: 'movies/new',
			gh: 'movies/new',
			gi: 'movies/new',
			gq: 'peliculas/nuevo',
			gr: 'ταινίες/νέα',
			gt: 'peliculas/nuevo',
			gy: 'movies/new',
			hk: '電影/最新',
			hn: 'peliculas/nuevo',
			hr: 'filmovi/novo',
			hu: 'filmek/uj',
			id: 'movies/new',
			ie: 'movies/new',
			il: 'movies/new',
			in: 'movies/new',
			iq: 'movies/new',
			is: 'kvikmyndir/ný',
			it: 'film/novità',
			jm: 'movies/new',
			jo: 'movies/new',
			jp: '映画/新作',
			ke: 'movies/new',
			kr: '영화/최신',
			kw: 'movies/new',
			lb: 'movies/new',
			lc: 'movies/new',
			li: 'Filme/Neu',
			lt: 'filmai/nauji',
			lu: 'films/nouveau',
			lv: 'filmas/jauns',
			ly: 'movies/new',
			ma: 'movies/new',
			mc: 'films/nouveau',
			md: 'filme/nou',
			me: 'filmovi/novo',
			mg: 'films/nouveau',
			mk: 'филмови/ново',
			ml: 'films/nouveau',
			mt: 'films/ġdid',
			mu: 'films/nouveau',
			mw: 'movies/new',
			mx: 'peliculas/nuevo',
			my: 'movies/new',
			mz: 'filmes/novo',
			ne: 'films/nouveau',
			ng: 'movies/new',
			ni: 'peliculas/nuevo',
			nl: 'movies/new',
			no: 'movies/new',
			nz: 'movies/new',
			om: 'movies/new',
			pa: 'peliculas/nuevo',
			pe: 'peliculas/nuevo',
			pf: 'films/nouveau',
			pg: 'movies/new',
			ph: 'movies/new',
			pk: 'movies/new',
			pl: 'filmy/nowe',
			ps: 'movies/new',
			pt: 'filmes/novo',
			py: 'peliculas/nuevo',
			qa: 'movies/new',
			ro: 'filme/nou',
			rs: 'filmovi/novo',
			ru: 'фильмы/новые',
			sa: 'movies/new',
			sc: 'films/nouveau',
			se: 'filmer/nya',
			sg: 'movies/new',
			sk: 'filmy/nový',
			si: 'filmi/novo',
			sm: 'film/novità',
			sn: 'films/nouveau',
			sv: 'peliculas/nuevo',
			tc: 'movies/new',
			td: 'movies/new',
			th: 'movies/new',
			tn: 'movies/new',
			tr: 'filmler/yeni',
			tt: 'movies/new',
			tw: '電影/最新',
			tz: 'filamu/mpya',
			ua: 'фільми/новинки',
			ug: 'movies/new',
			uk: 'movies/new',
			us: 'movies/new',
			uy: 'peliculas/nuevo',
			va: 'film/novità',
			ve: 'peliculas/nuevo',
			xk: 'filmat/risitë',
			ye: 'movies/new',
			za: 'movies/new',
			zm: 'movies/new',
			zw: 'movies/new',
		},
		redirect: {
			dk: 'film/nye',
			id: 'film/baru',
			lt: 'filmai/nauji',
			lv: 'filmas/jauns',
			my: 'filem/terbaru',
			no: 'filmer/nyheter',
			se: 'filmer/nya',
			th: 'ภาพยนต์/ใหม่',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.New,
			initialRouteState: { content_types: [TitleObjectType.MOVIE] },
			contexts: ['filter'],
			tab: 'new',
		},
	},
	'app.titles.new.show': {
		component: New,
		urls: {
			ad: 'series/nou',
			ae: 'tv-shows/new',
			ag: 'tv-shows/new',
			al: 'seriale-televizive/risitë',
			az: 'televiziya-şouları/yeni',
			ao: 'series/novo',
			ar: 'series/nuevo',
			at: 'Serien/Neu',
			au: 'tv-shows/new',
			ba: 'tv-serije/novo',
			bb: 'tv-shows/new',
			be: 'series/nouveau',
			bf: 'series/nouveau',
			bg: 'сериали/нови',
			bh: 'tv-shows/new',
			bm: 'tv-shows/new',
			bo: 'series/nuevo',
			br: 'series/novo',
			bs: 'tv-shows/new',
			by: 'сезон/новыя',
			bz: 'tv-shows/new',
			ca: 'tv-shows/new',
			cd: 'series/nouveau',
			ch: 'Serien/Neu',
			ci: 'series/nouveau',
			cl: 'series/nuevo',
			cm: 'tv-shows/new',
			co: 'series/nuevo',
			cr: 'series/nuevo',
			cu: 'series/nuevo',
			cv: 'series/novo',
			cy: 'τηλεοπτικές-σειρές/νέα',
			cz: 'serialy/novinky',
			de: 'Serien/Neu',
			dk: 'tv-series/new',
			do: 'series/nuevo',
			dz: 'tv-shows/new',
			ec: 'series/nuevo',
			ee: 'seriaalid/uus',
			eg: 'tv-shows/new',
			es: 'series/nuevo',
			fi: 'sarjat/uudet',
			fj: 'tv-shows/new',
			fr: 'series/nouveau',
			gf: 'series/nouveau',
			gg: 'tv-series/new',
			gh: 'tv-shows/new',
			gi: 'tv-shows/new',
			gq: 'series/nuevo',
			gr: 'τηλεοπτικές-σειρές/νέα',
			gt: 'series/nuevo',
			gy: 'tv-shows/new',
			hk: '節目/最新',
			hn: 'series/nuevo',
			hr: 'serije/novo',
			hu: 'tv-sorozat/uj',
			id: 'tv-shows/new',
			ie: 'tv-series/new',
			il: 'tv-shows/new',
			in: 'tv-shows/new',
			iq: 'tv-shows/new',
			is: 'þættir/ný',
			it: 'serie-tv/novità',
			jm: 'tv-shows/new',
			jo: 'tv-shows/new',
			jp: 'テレビ番組/新作',
			ke: 'tv-shows/new',
			kr: 'TV-프로그램/최신',
			kw: 'tv-shows/new',
			lb: 'tv-shows/new',
			lc: 'tv-shows/new',
			li: 'Serien/Neu',
			lt: 'tv-laidos/nauji',
			lu: 'series/nouveau',
			lv: 'tv-pārraide/jauns',
			ly: 'tv-shows/new',
			ma: 'tv-shows/new',
			mc: 'series/nouveau',
			md: 'seriale/nou',
			me: 'tv-programi/novo',
			mg: 'series/nouveau',
			mk: 'тв-серии/ново',
			ml: 'series/nouveau',
			mt: 'serje-televiżivi/ġdid',
			mu: 'series/nouveau',
			mw: 'tv-shows/new',
			mx: 'series/nuevo',
			my: 'tv-shows/new',
			mz: 'series/novo',
			ne: 'series/nouveau',
			ng: 'tv-shows/new',
			ni: 'series/nuevo',
			nl: 'tv-series/new',
			no: 'tv-series/new',
			nz: 'tv-shows/new',
			om: 'tv-shows/new',
			pa: 'series/nuevo',
			pe: 'series/nuevo',
			pf: 'series/nouveau',
			pg: 'tv-shows/new',
			ph: 'tv-shows/new',
			pk: 'tv-shows/new',
			pl: 'seriale/nowe',
			ps: 'tv-shows/new',
			pt: 'series/novo',
			py: 'series/nuevo',
			qa: 'tv-shows/new',
			ro: 'seriale/nou',
			rs: 'tv-programi/novo',
			ru: 'сериалы/новые',
			sa: 'tv-shows/new',
			sc: 'series/nouveau',
			se: 'tv-serier/nya',
			sg: 'tv-shows/new',
			sk: 'seriály/nový',
			si: 'serije/novo',
			sm: 'serie-tv/novità',
			sn: 'series/nouveau',
			sv: 'series/nuevo',
			tc: 'tv-shows/new',
			td: 'tv-shows/new',
			th: 'tv-shows/new',
			tn: 'tv-shows/new',
			tr: 'tv-dizileri/yeni',
			tt: 'tv-shows/new',
			tw: '節目/最新',
			tz: 'maonyesho-ya-tv/mpya',
			ua: 'телесеріали/новинки',
			ug: 'tv-shows/new',
			uk: 'tv-series/new',
			us: 'tv-shows/new',
			uy: 'series/nuevo',
			va: 'serie-tv/novità',
			ve: 'series/nuevo',
			xk: 'seriale-televizive/risitë',
			ye: 'tv-shows/new',
			za: 'tv-series/new',
			zm: 'tv-series/new',
			zw: 'tv-shows/new',
		},
		redirect: {
			dk: 'tv-serier/nye',
			id: 'acara-tv/baru',
			lt: 'tv-laidos/nauji',
			lv: 'tv-pārraide/jauns',
			my: 'rancangan-tv/terbaru',
			no: 'tv-serier/nyheter',
			se: 'tv-serier/nya',
			th: 'รายการทีวี/ใหม่',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.New,
			initialRouteState: { content_types: [TitleObjectType.SHOW] },
			contexts: ['filter'],
			tab: 'new',
		},
	},
	'app.titles.new.provider': {
		component: New,
		urls: {
			ad: 'plataforma/:provider/nou',
			ae: 'provider/:provider/new',
			ag: 'provider/:provider/new',
			al: 'ofruesi/:provider/risitë',
			az: 'provayder/:provider/yeni',
			ao: 'provedor/:provider/novo',
			ar: 'proveedor/:provider/nuevo',
			at: 'Anbieter/:provider/Neu',
			au: 'provider/:provider/new',
			ba: 'provajder/:provider/novo',
			bb: 'provider/:provider/new',
			be: 'plateforme/:provider/nouveau',
			bf: 'plateforme/:provider/nouveau',
			bg: 'доставчик/:provider/нови',
			bh: 'provider/:provider/new',
			bm: 'provider/:provider/new',
			bo: 'proveedor/:provider/nuevo',
			br: 'provedor/:provider/novo',
			bs: 'provider/:provider/new',
			by: 'правайдэр/:provider/новыя',
			bz: 'provider/:provider/new',
			ca: 'provider/:provider/new',
			cd: 'plateforme/:provider/nouveau',
			ch: 'Anbieter/:provider/Neu',
			ci: 'plateforme/:provider/nouveau',
			cl: 'proveedor/:provider/nuevo',
			cm: 'provider/:provider/new',
			co: 'proveedor/:provider/nuevo',
			cr: 'proveedor/:provider/nuevo',
			cu: 'proveedor/:provider/nuevo',
			cv: 'provedor/:provider/novo',
			cy: 'πάροχος/:provider/νέα',
			cz: 'poskytovatel/:provider/novinky',
			de: 'Anbieter/:provider/Neu',
			dk: 'provider/:provider/new',
			do: 'proveedor/:provider/nuevo',
			dz: 'provider/:provider/new',
			ec: 'proveedor/:provider/nuevo',
			ee: 'teenusepakkuja/:provider/uus',
			eg: 'provider/:provider/new',
			es: 'proveedor/:provider/nuevo',
			fi: 'palvelu/:provider/uudet',
			fj: 'provider/:provider/new',
			fr: 'plateforme/:provider/nouveau',
			gf: 'plateforme/:provider/nouveau',
			gg: 'provider/:provider/new',
			gh: 'provider/:provider/new',
			gi: 'provider/:provider/new',
			gq: 'proveedor/:provider/nuevo',
			gr: 'πάροχος/:provider/νέα',
			gt: 'proveedor/:provider/nuevo',
			gy: 'provider/:provider/new',
			hk: '供應商/:provider/最新',
			hn: 'proveedor/:provider/nuevo',
			hr: 'pružatelj-usluge/:provider/novo',
			hu: 'szolgaltato/:provider/uj',
			id: 'provider/:provider/new',
			ie: 'provider/:provider/new',
			il: 'provider/:provider/new',
			in: 'provider/:provider/new',
			iq: 'provider/:provider/new',
			is: 'veita/:provider/ný',
			it: 'provider/:provider/novità',
			jm: 'provider/:provider/new',
			jo: 'provider/:provider/new',
			jp: '動画配信サービス/:provider/新作',
			ke: 'provider/:provider/new',
			kr: '동영상서비스/:provider/최신',
			kw: 'provider/:provider/new',
			lb: 'provider/:provider/new',
			lc: 'provider/:provider/new',
			li: 'Anbieter/:provider/Neu',
			lt: 'tiekėjas/:provider/nauji',
			lu: 'plateforme/:provider/nouveau',
			lv: 'apgādātājs/:provider/jauns',
			ly: 'provider/:provider/new',
			ma: 'provider/:provider/new',
			mc: 'plateforme/:provider/nouveau',
			md: 'furnizor/:provider/nou',
			me: 'provajder/:provider/novo',
			mg: 'plateforme/:provider/nouveau',
			mk: 'провајдер/:provider/ново',
			ml: 'plateforme/:provider/nouveau',
			mt: 'fornitur/:provider/ġdid',
			mu: 'plateforme/:provider/nouveau',
			mw: 'provider/:provider/new',
			mx: 'proveedor/:provider/nuevo',
			my: 'provider/:provider/new',
			mz: 'provedor/:provider/novo',
			ne: 'plateforme/:provider/nouveau',
			ng: 'provider/:provider/new',
			ni: 'proveedor/:provider/nuevo',
			nl: 'provider/:provider/new',
			no: 'provider/:provider/new',
			nz: 'provider/:provider/new',
			om: 'provider/:provider/new',
			pa: 'proveedor/:provider/nuevo',
			pe: 'proveedor/:provider/nuevo',
			pf: 'plateforme/:provider/nouveau',
			pg: 'provider/:provider/new',
			ph: 'provider/:provider/new',
			pk: 'provider/:provider/new',
			pl: 'serwis-streamingowy/:provider/nowe',
			ps: 'provider/:provider/new',
			pt: 'provedor/:provider/novo',
			py: 'proveedor/:provider/nuevo',
			qa: 'provider/:provider/new',
			ro: 'furnizor/:provider/nou',
			rs: 'provajder/:provider/novo',
			ru: 'провайдер/:provider/новые',
			sa: 'provider/:provider/new',
			sc: 'plateforme/:provider/nouveau',
			se: 'leverantör/:provider/nya',
			sg: 'provider/:provider/new',
			sk: 'poskytovateľ/:provider/nový',
			si: 'ponudnik/:provider/novo',
			sm: 'provider/:provider/novità',
			sn: 'plateforme/:provider/nouveau',
			sv: 'proveedor/:provider/nuevo',
			tt: 'provider/:provider/new',
			tc: 'provider/:provider/new',
			td: 'provider/:provider/new',
			th: 'provider/:provider/new',
			tn: 'provider/:provider/new',
			tr: 'saglayici/:provider/yeni',
			tw: '平台/:provider/最新',
			tz: 'mtoa-huduma/:provider/mpya',
			ua: 'провайдер/:provider/новинки',
			ug: 'provider/:provider/new',
			uk: 'provider/:provider/new',
			us: 'provider/:provider/new',
			uy: 'proveedor/:provider/nuevo',
			va: 'provider/:provider/novità',
			ve: 'proveedor/:provider/nuevo',
			xk: 'ofruesi/:provider/risitë',
			ye: 'provider/:provider/new',
			za: 'provider/:provider/new',
			zm: 'provider/:provider/new',
			zw: 'provider/:provider/new',
		},
		redirect: {
			dk: 'udbyder/:provider/nye',
			id: 'penyedia/:provider/baru',
			lt: 'tiekėjas/:provider/nauji',
			lv: 'apgādātājs/:provider/jauns',
			my: 'pemberi/:provider/baru',
			no: 'tjeneste/:provider/nyheter',
			se: 'leverantör/:provider/nya',
			th: 'ผู้ให้บริการ/:provider/ใหม่',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.New,
			contexts: ['filter'],
			tab: 'new',
		},
	},
	'app.titles.new.provider-movie': {
		component: New,
		urls: {
			ad: 'plataforma/:provider/nou/pellicules',
			ae: 'provider/:provider/new/movies',
			ag: 'provider/:provider/new/movies',
			al: 'ofruesi/:provider/risitë/filmat',
			az: 'provayder/:provider/yeni/filmlər',
			ao: 'provedor/:provider/novo/filmes',
			ar: 'proveedor/:provider/nuevo/peliculas',
			at: 'Anbieter/:provider/Neu/Filme',
			au: 'provider/:provider/new/movies',
			ba: 'provajder/:provider/novo/filmovi',
			bb: 'provider/:provider/new/movies',
			be: 'plateforme/:provider/nouveau/films',
			bf: 'plateforme/:provider/nouveau/films',
			bg: 'доставчик/:provider/нови/филми',
			bh: 'provider/:provider/new/movies',
			bm: 'provider/:provider/new/movies',
			bo: 'proveedor/:provider/nuevo/peliculas',
			br: 'provedor/:provider/novo/filmes',
			bs: 'provider/:provider/new/movies',
			by: 'правайдэр/:provider/новыя/фільмы',
			bz: 'provider/:provider/new/movies',
			ca: 'provider/:provider/new/movies',
			cd: 'plateforme/:provider/nouveau/films',
			ch: 'Anbieter/:provider/Neu/Filme',
			ci: 'plateforme/:provider/nouveau/films',
			cl: 'proveedor/:provider/nuevo/peliculas',
			cm: 'provider/:provider/new/movies',
			co: 'proveedor/:provider/nuevo/peliculas',
			cr: 'proveedor/:provider/nuevo/peliculas',
			cu: 'proveedor/:provider/nuevo/peliculas',
			cv: 'provedor/:provider/novo/filmes',
			cy: 'πάροχος/:provider/νέα/ταινίες',
			cz: 'poskytovatel/:provider/novinky/filmy',
			de: 'Anbieter/:provider/Neu/Filme',
			dk: 'provider/:provider/new/movies',
			do: 'proveedor/:provider/nuevo/peliculas',
			dz: 'provider/:provider/new/movies',
			ec: 'proveedor/:provider/nuevo/peliculas',
			ee: 'teenusepakkuja/:provider/uus/filmid',
			eg: 'provider/:provider/new/movies',
			es: 'proveedor/:provider/nuevo/peliculas',
			fi: 'palvelu/:provider/uudet/elokuvat',
			fj: 'provider/:provider/new/movies',
			fr: 'plateforme/:provider/nouveau/films',
			gf: 'plateforme/:provider/nouveau/films',
			gg: 'provider/:provider/new/movies',
			gh: 'provider/:provider/new/movies',
			gi: 'provider/:provider/new/movies',
			gq: 'proveedor/:provider/nuevo/peliculas',
			gr: 'πάροχος/:provider/νέα/ταινίες',
			gt: 'proveedor/:provider/nuevo/peliculas',
			gy: 'provider/:provider/new/movies',
			hk: '供應商/:provider/最新/電影',
			hn: 'proveedor/:provider/nuevo/peliculas',
			hr: 'pružatelj-usluge/:provider/novo/filmovi',
			hu: 'szolgaltato/:provider/uj/filmek',
			id: 'provider/:provider/new/movies',
			ie: 'provider/:provider/new/movies',
			il: 'provider/:provider/new/movies',
			in: 'provider/:provider/new/movies',
			iq: 'provider/:provider/new/movies',
			is: 'veita/:provider/ný/kvikmyndir',
			it: 'provider/:provider/novità/film',
			jm: 'provider/:provider/new/movies',
			jo: 'provider/:provider/new/movies',
			jp: '動画配信サービス/:provider/新作/映画',
			ke: 'provider/:provider/new/movies',
			kr: '동영상서비스/:provider/최신/영화',
			kw: 'provider/:provider/new/movies',
			lb: 'provider/:provider/new/movies',
			lc: 'provider/:provider/new/movies',
			li: 'Anbieter/:provider/Neu/Filme',
			lt: 'tiekėjas/:provider/nauji/filmai',
			lu: 'plateforme/:provider/nouveau/films',
			lv: 'apgādātājs/:provider/jauns/filmas',
			ly: 'provider/:provider/new/movies',
			ma: 'provider/:provider/new/movies',
			mc: 'plateforme/:provider/nouveau/films',
			md: 'провајдер/:provider/ново/филмови',
			me: 'provajder/:provider/novo/filmovi',
			mg: 'plateforme/:provider/nouveau/films',
			mk: 'furnizor/:provider/nou/filme',
			ml: 'plateforme/:provider/nouveau/films',
			mt: 'fornitur/:provider/ġdid/films',
			mu: 'plateforme/:provider/nouveau/films',
			mw: 'provider/:provider/new/movies',
			mx: 'proveedor/:provider/nuevo/peliculas',
			my: 'provider/:provider/new/movies',
			mz: 'provedor/:provider/novo/filmes',
			ne: 'plateforme/:provider/nouveau/films',
			ng: 'provider/:provider/new/movies',
			ni: 'proveedor/:provider/nuevo/peliculas',
			nl: 'provider/:provider/new/movies',
			no: 'provider/:provider/new/movies',
			nz: 'provider/:provider/new/movies',
			om: 'provider/:provider/new/movies',
			pa: 'proveedor/:provider/nuevo/peliculas',
			pe: 'proveedor/:provider/nuevo/peliculas',
			pf: 'plateforme/:provider/nouveau/films',
			pg: 'provider/:provider/new/movies',
			ph: 'provider/:provider/new/movies',
			pk: 'provider/:provider/new/movies',
			pl: 'serwis-streamingowy/:provider/nowe/filmy',
			ps: 'provider/:provider/new/movies',
			pt: 'provedor/:provider/novo/filmes',
			py: 'proveedor/:provider/nuevo/peliculas',
			qa: 'provider/:provider/new/movies',
			ro: 'furnizor/:provider/nou/filme',
			rs: 'provajder/:provider/novo/filmovi',
			ru: 'провайдер/:provider/новые/фильмы',
			sa: 'provider/:provider/new/movies',
			sc: 'plateforme/:provider/nouveau/films',
			se: 'leverantör/:provider/nya/filmer',
			sg: 'provider/:provider/new/movies',
			sk: 'poskytovateľ/:provider/nový/filmy',
			si: 'ponudnik/:provider/novo/filmi',
			sm: 'provider/:provider/novità/film',
			sn: 'plateforme/:provider/nouveau/films',
			sv: 'proveedor/:provider/nuevo/peliculas',
			tc: 'provider/:provider/new/movies',
			td: 'provider/:provider/new/movies',
			th: 'provider/:provider/new/movies',
			tn: 'provider/:provider/new/movies',
			tr: 'saglayici/:provider/yeni/filmler',
			tt: 'provider/:provider/new/movies',
			tw: '平台/:provider/最新/電影',
			tz: 'mtoa-huduma/:provider/mpya/filamu',
			ua: 'провайдер/:provider/новинки/фільми',
			ug: 'provider/:provider/new/movies',
			uk: 'provider/:provider/new/movies',
			us: 'provider/:provider/new/movies',
			uy: 'proveedor/:provider/nuevo/peliculas',
			va: 'provider/:provider/new/movies',
			ve: 'proveedor/:provider/nuevo/peliculas',
			xk: 'ofruesi/:provider/risitë/filmat',
			ye: 'provider/:provider/new/movies',
			za: 'provider/:provider/new/movies',
			zm: 'provider/:provider/new/movies',
			zw: 'provider/:provider/new/movies',
		},
		redirect: {
			dk: 'udbyder/:provider/nye/film',
			id: 'penyedia/:provider/baru/film',
			lt: 'tiekėjas/:provider/nauji/filmai',
			lv: 'apgādātājs/:provider/jauns/filmas',
			my: 'pemberi/:provider/baru/filem',
			no: 'tjeneste/:provider/nyheter/filmer',
			se: 'leverantör/:provider/nya/filmer',
			th: 'ผู้ให้บริการ/:provider/ใหม่/ภาพยนต์',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.New,
			initialRouteState: { content_types: [TitleObjectType.MOVIE] },
			contexts: ['filter'],
			tab: 'new',
		},
	},
	'app.titles.new.provider-show': {
		component: New,
		urls: {
			ad: 'plataforma/:provider/nou/series',
			ae: 'provider/:provider/new/tv-shows',
			ag: 'provider/:provider/new/tv-shows',
			al: 'ofruesi/:provider/risitë/seriale-televizive',
			az: 'provayder/:provider/yeni/televiziya-şouları',
			ao: 'provedor/:provider/novo/series',
			ar: 'proveedor/:provider/nuevo/series',
			at: 'Anbieter/:provider/Neu/Serien',
			au: 'provider/:provider/new/tv-shows',
			ba: 'provajder/:provider/novo/tv-serije',
			bb: 'provider/:provider/new/tv-shows',
			be: 'plateforme/:provider/nouveau/series',
			bf: 'plateforme/:provider/nouveau/series',
			bg: 'доставчик/:provider/нови/сериали',
			bh: 'provider/:provider/new/tv-shows',
			bm: 'provider/:provider/new/tv-shows',
			bo: 'proveedor/:provider/nuevo/series',
			br: 'provedor/:provider/novo/series',
			bs: 'provider/:provider/new/tv-shows',
			by: 'правайдэр/:provider/новыя/сезон',
			bz: 'provider/:provider/new/tv-shows',
			ca: 'provider/:provider/new/tv-shows',
			cd: 'plateforme/:provider/nouveau/series',
			ch: 'Anbieter/:provider/Neu/Serien',
			ci: 'plateforme/:provider/nouveau/series',
			cl: 'proveedor/:provider/nuevo/series',
			cm: 'provider/:provider/new/tv-shows',
			co: 'proveedor/:provider/nuevo/series',
			cr: 'proveedor/:provider/nuevo/series',
			cu: 'proveedor/:provider/nuevo/series',
			cv: 'provedor/:provider/novo/series',
			cy: 'πάροχος/:provider/νέα/τηλεοπτικές-σειρές',
			cz: 'poskytovatel/:provider/novinky/serialy',
			de: 'Anbieter/:provider/Neu/Serien',
			dk: 'provider/:provider/new/tv-series',
			do: 'proveedor/:provider/nuevo/series',
			dz: 'provider/:provider/new/tv-shows',
			ec: 'proveedor/:provider/nuevo/series',
			ee: 'teenusepakkuja/:provider/uus/seriaalid',
			eg: 'provider/:provider/new/tv-shows',
			es: 'proveedor/:provider/nuevo/series',
			fi: 'palvelu/:provider/uudet/sarjat',
			fj: 'provider/:provider/new/tv-shows',
			fr: 'plateforme/:provider/nouveau/series',
			gf: 'plateforme/:provider/nouveau/series',
			gg: 'provider/:provider/new/tv-series',
			gh: 'provider/:provider/new/tv-shows',
			gi: 'provider/:provider/new/tv-shows',
			gq: 'proveedor/:provider/nuevo/series',
			gr: 'πάροχος/:provider/νέα/τηλεοπτικές-σειρές',
			gt: 'proveedor/:provider/nuevo/series',
			gy: 'provider/:provider/new/tv-shows',
			hk: '供應商/:provider/最新/節目',
			hn: 'proveedor/:provider/nuevo/series',
			hr: 'pružatelj-usluge/:provider/novo/serije',
			hu: 'szolgaltato/:provider/uj/tv-sorozat',
			id: 'provider/:provider/new/tv-shows',
			ie: 'provider/:provider/new/tv-series',
			il: 'provider/:provider/new/tv-shows',
			in: 'provider/:provider/new/tv-shows',
			iq: 'provider/:provider/new/tv-shows',
			is: 'veita/:provider/ný/þættir',
			it: 'provider/:provider/novità/serie-tv',
			jm: 'provider/:provider/new/tv-shows',
			jo: 'provider/:provider/new/tv-shows',
			jp: '動画配信サービス/:provider/新作/テレビ番組',
			ke: 'provider/:provider/new/tv-shows',
			kr: '동영상서비스/:provider/최신/TV-프로그램',
			kw: 'provider/:provider/new/tv-shows',
			lb: 'provider/:provider/new/tv-shows',
			lc: 'provider/:provider/new/tv-shows',
			li: 'Anbieter/:provider/Neu/Serien',
			lt: 'tiekėjas/:provider/nauji/tv-laidos',
			lu: 'plateforme/:provider/nouveau/series',
			lv: 'apgādātājs/:provider/jauns/tv-pārraide',
			ly: 'provider/:provider/new/tv-shows',
			ma: 'provider/:provider/new/tv-shows',
			mc: 'plateforme/:provider/nouveau/series',
			md: 'furnizor/:provider/nou/seriale',
			me: 'provajder/:provider/novo/tv-programi',
			mg: 'plateforme/:provider/nouveau/series',
			mk: 'провајдер/:provider/ново/тв-серии',
			ml: 'plateforme/:provider/nouveau/series',
			mt: 'fornitur/:provider/ġdid/serje-televiżivi',
			mu: 'plateforme/:provider/nouveau/series',
			mw: 'provider/:provider/new/tv-shows',
			mx: 'proveedor/:provider/nuevo/series',
			my: 'provider/:provider/new/tv-shows',
			mz: 'provedor/:provider/novo/series',
			ne: 'plateforme/:provider/nouveau/series',
			ng: 'provider/:provider/new/tv-shows',
			ni: 'proveedor/:provider/nuevo/series',
			nl: 'provider/:provider/new/tv-series',
			no: 'provider/:provider/new/tv-series',
			nz: 'provider/:provider/new/tv-shows',
			om: 'provider/:provider/new/tv-shows',
			pa: 'proveedor/:provider/nuevo/series',
			pe: 'proveedor/:provider/nuevo/series',
			pf: 'plateforme/:provider/nouveau/series',
			pg: 'provider/:provider/new/tv-shows',
			ph: 'provider/:provider/new/tv-shows',
			pk: 'provider/:provider/new/tv-shows',
			pl: 'serwis-streamingowy/:provider/nowe/seriale',
			ps: 'provider/:provider/new/tv-shows',
			pt: 'provedor/:provider/novo/series',
			py: 'proveedor/:provider/nuevo/series',
			qa: 'provider/:provider/new/tv-shows',
			ro: 'furnizor/:provider/nou/seriale',
			rs: 'provajder/:provider/novo/tv-programi',
			ru: 'провайдер/:provider/новые/сериалы',
			sa: 'provider/:provider/new/tv-shows',
			sc: 'plateforme/:provider/nouveau/series',
			se: 'leverantör/:provider/nya/tv-serier',
			sg: 'provider/:provider/new/tv-shows',
			sk: 'poskytovateľ/:provider/nový/seriály',
			si: 'ponudnik/:provider/novo/serije',
			sm: 'provider/:provider/novità/serie-tv',
			sn: 'plateforme/:provider/nouveau/series',
			sv: 'proveedor/:provider/nuevo/series',
			tc: 'provider/:provider/new/tv-shows',
			td: 'provider/:provider/new/tv-shows',
			th: 'provider/:provider/new/tv-shows',
			tn: 'provider/:provider/new/tv-shows',
			tr: 'saglayici/:provider/yeni/tv-dizileri',
			tt: 'provider/:provider/new/tv-shows',
			tw: '平台/:provider/最新/節目',
			tz: 'mtoa-huduma/:provider/mpya/maonyesho-ya-tv',
			ua: 'провайдер/:provider/новинки/телесеріали',
			ug: 'provider/:provider/new/tv-shows',
			uk: 'provider/:provider/new/tv-series',
			us: 'provider/:provider/new/tv-shows',
			uy: 'proveedor/:provider/nuevo/series',
			va: 'provider/:provider/new/tv-shows',
			ve: 'proveedor/:provider/nuevo/series',
			xk: 'ofruesi/:provider/risitë/seriale-televizive',
			ye: 'provider/:provider/new/tv-shows',
			za: 'provider/:provider/new/tv-series',
			zm: 'provider/:provider/new/tv-series',
			zw: 'provider/:provider/new/tv-shows',
		},
		redirect: {
			dk: 'udbyder/:provider/nye/tv-serier',
			id: 'penyedia/:provider/baru/acara-tv',
			lt: 'tiekėjas/:provider/nauji/tv-laidos',
			lv: 'apgādātājs/:provider/jauns/tv-pārraide',
			my: 'pemberi/:provider/baru/rancangan-tv',
			no: 'tjeneste/:provider/nyheter/tv-serier',
			se: 'leverantör/:provider/nya/tv-serier',
			th: 'ผู้ให้บริการ/:provider/ใหม่/รายการทีวี',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.New,
			initialRouteState: { content_types: [TitleObjectType.SHOW] },
			contexts: ['filter'],
			tab: 'new',
		},
	},

	// --- NEW / ON SALE ---
	'app.titles.pricedrops.list': {
		component: New,
		urls: {
			ad: 'on-sale',
			ae: 'on-sale',
			ag: 'on-sale',
			al: 'on-sale',
			az: 'on-sale',
			ao: 'on-sale',
			ar: 'on-sale',
			at: 'heute-im-sale',
			au: 'on-sale',
			ba: 'on-sale',
			bb: 'on-sale',
			be: 'on-sale',
			bf: 'on-sale',
			bg: 'в-разпродажба',
			bh: 'on-sale',
			bm: 'on-sale',
			bo: 'on-sale',
			br: 'on-sale',
			bs: 'on-sale',
			by: 'on-sale',
			bz: 'on-sale',
			ca: 'on-sale',
			cd: 'on-sale',
			ch: 'on-sale',
			ci: 'on-sale',
			cl: 'on-sale',
			cm: 'on-sale',
			co: 'on-sale',
			cr: 'on-sale',
			cu: 'on-sale',
			cv: 'on-sale',
			cy: 'on-sale',
			cz: 'on-sale',
			de: 'heute-im-sale',
			dk: 'on-sale',
			do: 'on-sale',
			dz: 'on-sale',
			ec: 'on-sale',
			ee: 'on-sale',
			eg: 'on-sale',
			es: 'ofertas',
			fi: 'tarjouksessa',
			fj: 'on-sale',
			fr: 'promos',
			gf: 'on-sale',
			gg: 'on-sale',
			gh: 'on-sale',
			gi: 'on-sale',
			gq: 'on-sale',
			gr: 'on-sale',
			gt: 'on-sale',
			gy: 'on-sale',
			hk: 'on-sale',
			hn: 'on-sale',
			hr: 'promotivna-ponuda',
			hu: 'eladó',
			id: 'on-sale',
			ie: 'on-sale',
			il: 'on-sale',
			in: 'on-sale',
			iq: 'on-sale',
			is: 'útsala',
			it: 'offerte',
			jm: 'on-sale',
			jo: 'on-sale',
			jp: 'on-sale',
			ke: 'on-sale',
			kr: 'on-sale',
			kw: 'on-sale',
			lb: 'on-sale',
			lc: 'on-sale',
			li: 'on-sale',
			lt: 'išpardavimas',
			lu: 'on-sale',
			lv: 'izpārdošanā',
			ly: 'on-sale',
			ma: 'on-sale',
			mc: 'on-sale',
			md: 'on-sale',
			me: 'on-sale',
			mg: 'on-sale',
			mk: 'on-sale',
			ml: 'on-sale',
			mt: 'on-sale',
			mu: 'on-sale',
			mw: 'on-sale',
			mx: 'on-sale',
			my: 'on-sale',
			mz: 'on-sale',
			ne: 'on-sale',
			ng: 'on-sale',
			ni: 'on-sale',
			nl: 'aanbieding',
			no: 'salg',
			nz: 'on-sale',
			om: 'on-sale',
			pa: 'on-sale',
			pe: 'on-sale',
			pf: 'on-sale',
			pg: 'on-sale',
			ph: 'on-sale',
			pk: 'on-sale',
			pl: 'na-wyprzedaży',
			ps: 'on-sale',
			pt: 'ofertas',
			py: 'on-sale',
			qa: 'on-sale',
			ro: 'la-reducere',
			rs: 'on-sale',
			ru: 'продается',
			sa: 'on-sale',
			sc: 'on-sale',
			se: 'on-sale',
			sg: 'on-sale',
			sk: 'v-zľave',
			si: 'on-sale',
			sm: 'on-sale',
			sn: 'on-sale',
			sv: 'rabatterat-pris',
			tc: 'on-sale',
			td: 'on-sale',
			th: 'on-sale',
			tn: 'on-sale',
			tr: 'indirimde',
			tt: 'on-sale',
			tw: 'on-sale',
			tz: 'on-sale',
			ua: 'on-sale',
			ug: 'on-sale',
			uk: 'on-sale',
			us: 'on-sale',
			uy: 'on-sale',
			va: 'on-sale',
			ve: 'on-sale',
			xk: 'on-sale',
			ye: 'on-sale',
			za: 'on-sale',
			zm: 'on-sale',
			zw: 'on-sale',
		},
		redirect: {
			dk: 'on-sale',
			id: 'on-sale',
			lt: 'išpardavimas',
			lv: 'izpārdošanā',
			my: 'on-sale',
			no: 'salg',
			se: 'on-sale',
			th: 'on-sale',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.PriceDrop,
			contexts: ['filter'],
			tab: 'on-sale',
		},
	},
	'app.titles.pricedrops.movie': {
		component: New,
		urls: {
			ad: 'on-sale/pellicules',
			ae: 'on-sale/movies',
			ag: 'on-sale/movies',
			al: 'on-sale/filmat',
			az: 'on-sale/filmlər',
			ao: 'on-sale/filmes',
			ar: 'on-sale/peliculas',
			at: 'heute-im-sale/Filme',
			au: 'on-sale/movies',
			ba: 'on-sale/filmovi',
			bb: 'on-sale/movies',
			be: 'on-sale/films',
			bf: 'on-sale/films',
			bg: 'в-разпродажба/филми',
			bh: 'on-sale/movies',
			bm: 'on-sale/movies',
			bo: 'on-sale/peliculas',
			br: 'on-sale/filmes',
			bs: 'on-sale/movies',
			by: 'on-sale/фільмы',
			bz: 'on-sale/movies',
			ca: 'on-sale/movies',
			cd: 'on-sale/films',
			ch: 'on-sale/Filme',
			ci: 'on-sale/films',
			cl: 'on-sale/peliculas',
			cm: 'on-sale/movies',
			co: 'on-sale/peliculas',
			cr: 'on-sale/peliculas',
			cu: 'on-sale/peliculas',
			cv: 'on-sale/filmes',
			cy: 'on-sale/ταινίες',
			cz: 'on-sale/filmy',
			de: 'heute-im-sale/Filme',
			dk: 'on-sale/movies',
			do: 'on-sale/peliculas',
			dz: 'on-sale/movies',
			ec: 'on-sale/peliculas',
			ee: 'on-sale/filmid',
			eg: 'on-sale/movies',
			es: 'ofertas/peliculas',
			fi: 'tarjouksessa/elokuvat',
			fj: 'on-sale/movies',
			fr: 'promos/films',
			gf: 'on-sale/films',
			gg: 'on-sale/movies',
			gh: 'on-sale/movies',
			gi: 'on-sale/movies',
			gq: 'on-sale/peliculas',
			gr: 'on-sale/ταινίες',
			gt: 'on-sale/peliculas',
			gy: 'on-sale/movies',
			hk: 'on-sale/電影',
			hn: 'on-sale/peliculas',
			hr: 'promotivna-ponuda/filmovi',
			hu: 'eladó/filmek',
			id: 'on-sale/movies',
			ie: 'on-sale/movies',
			il: 'on-sale/movies',
			in: 'on-sale/movies',
			iq: 'on-sale/movies',
			is: 'útsala/kvikmyndir',
			it: 'offerte/film',
			jm: 'on-sale/movies',
			jo: 'on-sale/movies',
			jp: 'on-sale/映画',
			ke: 'on-sale/movies',
			kr: 'on-sale/영화',
			kw: 'on-sale/movies',
			lb: 'on-sale/movies',
			lc: 'on-sale/movies',
			li: 'on-sale/Filme',
			lt: 'išpardavimas/filmai',
			lu: 'on-sale/films',
			lv: 'izpārdošanā/filmas',
			ly: 'on-sale/movies',
			ma: 'on-sale/movies',
			mc: 'on-sale/films',
			md: 'on-sale/filme',
			me: 'on-sale/filmovi',
			mg: 'on-sale/films',
			mk: 'on-sale/филмови',
			ml: 'on-sale/films',
			mt: 'on-sale/films',
			mu: 'on-sale/films',
			mw: 'on-sale/movies',
			mx: 'on-sale/peliculas',
			my: 'on-sale/movies',
			mz: 'on-sale/filmes',
			ne: 'on-sale/films',
			ng: 'on-sale/movies',
			ni: 'on-sale/peliculas',
			nl: 'aanbieding/movies',
			no: 'salg/movies',
			nz: 'on-sale/movies',
			om: 'on-sale/movies',
			pa: 'on-sale/peliculas',
			pe: 'on-sale/peliculas',
			pf: 'on-sale/films',
			pg: 'on-sale/movies',
			ph: 'on-sale/movies',
			pk: 'on-sale/movies',
			pl: 'na-wyprzedaży/filmy',
			ps: 'on-sale/movies',
			pt: 'ofertas/filmes',
			py: 'on-sale/peliculas',
			qa: 'on-sale/movies',
			ro: 'la-reducere/filme',
			rs: 'on-sale/filmovi',
			ru: 'продается/фильмы',
			sa: 'on-sale/movies',
			sc: 'on-sale/films',
			se: 'on-sale/filmer',
			sg: 'on-sale/movies',
			sk: 'v-zľave/filmy',
			si: 'on-sale/filmi',
			sm: 'on-sale/film',
			sn: 'on-sale/films',
			sv: 'rabatterat-pris/peliculas',
			tc: 'on-sale/movies',
			td: 'on-sale/movies',
			th: 'on-sale/movies',
			tn: 'on-sale/movies',
			tr: 'indirimde/filmler',
			tt: 'on-sale/movies',
			tw: 'on-sale/電影',
			tz: 'on-sale/filamu',
			ua: 'on-sale/фільми',
			ug: 'on-sale/movies',
			uk: 'on-sale/movies',
			us: 'on-sale/movies',
			uy: 'on-sale/peliculas',
			va: 'on-sale/film',
			ve: 'on-sale/peliculas',
			xk: 'on-sale/filmat',
			ye: 'on-sale/movies',
			za: 'on-sale/movies',
			zm: 'on-sale/movies',
			zw: 'on-sale/movies',
		},
		redirect: {
			dk: 'on-sale/film',
			id: 'on-sale/film',
			lt: 'išpardavimas/filmai',
			lv: 'izpārdošanā/filmas',
			my: 'on-sale/filem',
			no: 'salg/filmer',
			se: 'on-sale/filmer',
			th: 'on-sale/ภาพยนต์',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.PriceDrop,
			initialRouteState: { content_types: [TitleObjectType.MOVIE] },
			contexts: ['filter'],
			tab: 'on-sale',
		},
	},
	'app.titles.pricedrops.show': {
		component: New,
		urls: {
			ad: 'on-sale/series',
			ae: 'on-sale/tv-shows',
			ag: 'on-sale/tv-shows',
			al: 'on-sale/seriale-televizive',
			az: 'on-sale/televiziya-şouları',
			ao: 'on-sale/series',
			ar: 'on-sale/series',
			at: 'heute-im-sale/Serien',
			au: 'on-sale/tv-shows',
			ba: 'on-sale/tv-serije',
			bb: 'on-sale/tv-shows',
			be: 'on-sale/series',
			bf: 'on-sale/series',
			bg: 'в-разпродажба/сериали',
			bh: 'on-sale/tv-shows',
			bm: 'on-sale/tv-shows',
			bo: 'on-sale/series',
			br: 'on-sale/series',
			bs: 'on-sale/tv-shows',
			by: 'on-sale/сезон',
			bz: 'on-sale/tv-shows',
			ca: 'on-sale/tv-shows',
			cd: 'on-sale/series',
			ch: 'on-sale/Serien',
			ci: 'on-sale/series',
			cl: 'on-sale/series',
			cm: 'on-sale/tv-shows',
			co: 'on-sale/series',
			cr: 'on-sale/series',
			cu: 'on-sale/series',
			cv: 'on-sale/series',
			cy: 'on-sale/τηλεοπτικές-σειρές',
			cz: 'on-sale/serialy',
			de: 'heute-im-sale/Serien',
			dk: 'on-sale/tv-series',
			do: 'on-sale/series',
			dz: 'on-sale/tv-shows',
			ec: 'on-sale/series',
			ee: 'on-sale/seriaalid',
			eg: 'on-sale/tv-shows',
			es: 'ofertas/series',
			fi: 'tarjouksessa/sarjat',
			fj: 'on-sale/tv-shows',
			fr: 'promos/series',
			gf: 'on-sale/series',
			gg: 'on-sale/tv-series',
			gh: 'on-sale/tv-shows',
			gi: 'on-sale/tv-shows',
			gq: 'on-sale/series',
			gr: 'on-sale/τηλεοπτικές-σειρές',
			gt: 'on-sale/series',
			gy: 'on-sale/tv-shows',
			hk: 'on-sale/節目',
			hn: 'on-sale/series',
			hr: 'promotivna-ponuda/serije',
			hu: 'eladó/tv-sorozat',
			id: 'on-sale/tv-shows',
			ie: 'on-sale/tv-series',
			il: 'on-sale/tv-shows',
			in: 'on-sale/tv-shows',
			iq: 'on-sale/tv-shows',
			is: 'útsala/þættir',
			it: 'offerte/serie-tv',
			jm: 'on-sale/tv-shows',
			jo: 'on-sale/tv-shows',
			jp: 'on-sale/テレビ番組',
			ke: 'on-sale/tv-shows',
			kr: 'on-sale/TV-프로그램',
			kw: 'on-sale/tv-shows',
			lb: 'on-sale/tv-shows',
			lc: 'on-sale/tv-shows',
			li: 'on-sale/Serien',
			lt: 'išpardavimas/tv-laidos',
			lu: 'on-sale/series',
			lv: 'izpārdošanā/tv-pārraide',
			ly: 'on-sale/tv-shows',
			ma: 'on-sale/tv-shows',
			mc: 'on-sale/series',
			md: 'on-sale/seriale',
			me: 'on-sale/tv-programi',
			mg: 'on-sale/series',
			mk: 'on-sale/тв-серии',
			ml: 'on-sale/series',
			mt: 'on-sale/serje-televiżivi',
			mu: 'on-sale/series',
			mw: 'on-sale/tv-shows',
			mx: 'on-sale/series',
			my: 'on-sale/tv-shows',
			mz: 'on-sale/series',
			ne: 'on-sale/series',
			ng: 'on-sale/tv-shows',
			ni: 'on-sale/series',
			nl: 'aanbieding/tv-series',
			no: 'salg/tv-series',
			nz: 'on-sale/tv-shows',
			om: 'on-sale/tv-shows',
			pa: 'on-sale/series',
			pe: 'on-sale/series',
			pf: 'on-sale/series',
			pg: 'on-sale/tv-shows',
			ph: 'on-sale/tv-shows',
			pk: 'on-sale/tv-shows',
			pl: 'na-wyprzedaży/seriale',
			ps: 'on-sale/tv-shows',
			pt: 'ofertas/series',
			py: 'on-sale/series',
			qa: 'on-sale/tv-shows',
			ro: 'la-reducere/seriale',
			rs: 'on-sale/tv-programi',
			ru: 'продается/сериалы',
			sa: 'on-sale/tv-shows',
			sc: 'on-sale/series',
			se: 'on-sale/tv-serier',
			sg: 'on-sale/tv-shows',
			sk: 'v-zľave/seriály',
			si: 'on-sale/serije',
			sm: 'on-sale/serie-tv',
			sn: 'on-sale/series',
			sv: 'rabatterat-pris/series',
			tc: 'on-sale/tv-shows',
			td: 'on-sale/tv-shows',
			th: 'on-sale/tv-shows',
			tn: 'on-sale/tv-shows',
			tr: 'indirimde/tv-dizileri',
			tt: 'on-sale/tv-shows',
			tw: 'on-sale/節目',
			tz: 'on-sale/maonyesho-ya-tv',
			ua: 'on-sale/телесеріали',
			ug: 'on-sale/tv-shows',
			uk: 'on-sale/tv-series',
			us: 'on-sale/tv-shows',
			uy: 'on-sale/series',
			va: 'on-sale/serie-tv',
			ve: 'on-sale/series',
			xk: 'on-sale/seriale-televizive',
			ye: 'on-sale/tv-shows',
			za: 'on-sale/tv-series',
			zm: 'on-sale/tv-series',
			zw: 'on-sale/tv-shows',
		},
		redirect: {
			dk: 'on-sale/tv-serier',
			id: 'on-sale/acara-tv',
			lt: 'išpardavimas/tv-laidos',
			lv: 'izpārdošanā/tv-pārraide',
			my: 'on-sale/rancangan-tv',
			no: 'salg/tv-serier',
			se: 'on-sale/tv-serier',
			th: 'on-sale/รายการทีวี',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.PriceDrop,
			initialRouteState: { content_types: [TitleObjectType.SHOW] },
			contexts: ['filter'],
			tab: 'on-sale',
		},
	},
	'app.titles.pricedrops.provider': {
		component: New,
		urls: {
			ad: 'plataforma/:provider/on-sale',
			ae: 'provider/:provider/on-sale',
			ag: 'provider/:provider/on-sale',
			al: 'ofruesi/:provider/on-sale',
			az: 'provayder/:provider/on-sale',
			ao: 'provedor/:provider/on-sale',
			ar: 'proveedor/:provider/on-sale',
			at: 'Anbieter/:provider/heute-im-sale',
			au: 'provider/:provider/on-sale',
			ba: 'provajder/:provider/on-sale',
			bb: 'provider/:provider/on-sale',
			be: 'plateforme/:provider/on-sale',
			bf: 'plateforme/:provider/on-sale',
			bg: 'доставчик/:provider/в-разпродажба',
			bh: 'provider/:provider/on-sale',
			bm: 'provider/:provider/on-sale',
			bo: 'proveedor/:provider/on-sale',
			br: 'provedor/:provider/on-sale',
			bs: 'provider/:provider/on-sale',
			by: 'правайдэр/:provider/on-sale',
			bz: 'provider/:provider/on-sale',
			ca: 'provider/:provider/on-sale',
			cd: 'plateforme/:provider/on-sale',
			ch: 'Anbieter/:provider/on-sale',
			ci: 'plateforme/:provider/on-sale',
			cl: 'proveedor/:provider/on-sale',
			cm: 'provider/:provider/on-sale',
			co: 'proveedor/:provider/on-sale',
			cr: 'proveedor/:provider/on-sale',
			cu: 'proveedor/:provider/on-sale',
			cv: 'provedor/:provider/on-sale',
			cy: 'πάροχος/:provider/on-sale',
			cz: 'poskytovatel/:provider/on-sale',
			de: 'Anbieter/:provider/heute-im-sale',
			dk: 'provider/:provider/on-sale',
			do: 'proveedor/:provider/on-sale',
			dz: 'provider/:provider/on-sale',
			ec: 'proveedor/:provider/on-sale',
			ee: 'teenusepakkuja/:provider/on-sale',
			eg: 'provider/:provider/on-sale',
			es: 'proveedor/:provider/ofertas',
			fi: 'palvelu/:provider/tarjouksessa',
			fj: 'provider/:provider/on-sale',
			fr: 'plateforme/:provider/promos',
			gf: 'plateforme/:provider/on-sale',
			gg: 'provider/:provider/on-sale',
			gh: 'provider/:provider/on-sale',
			gi: 'provider/:provider/on-sale',
			gq: 'proveedor/:provider/on-sale',
			gr: 'πάροχος/:provider/on-sale',
			gt: 'proveedor/:provider/on-sale',
			gy: 'provider/:provider/on-sale',
			hk: '供應商/:provider/on-sale',
			hn: 'proveedor/:provider/on-sale',
			hr: 'pružatelj-usluge/:provider/promotivna-ponuda',
			hu: 'szolgaltato/:provider/eladó',
			id: 'provider/:provider/on-sale',
			ie: 'provider/:provider/on-sale',
			il: 'provider/:provider/on-sale',
			in: 'provider/:provider/on-sale',
			iq: 'provider/:provider/on-sale',
			is: 'veita/:provider/útsala',
			it: 'provider/:provider/offerte',
			jm: 'provider/:provider/on-sale',
			jo: 'provider/:provider/on-sale',
			jp: '動画配信サービス/:provider/on-sale',
			ke: 'provider/:provider/on-sale',
			kr: '동영상서비스/:provider/on-sale',
			kw: 'provider/:provider/on-sale',
			lb: 'provider/:provider/on-sale',
			lc: 'provider/:provider/on-sale',
			li: 'Anbieter/:provider/on-sale',
			lt: 'tiekėjas/:provider/išpardavimas',
			lu: 'plateforme/:provider/on-sale',
			lv: 'apgādātājs/:provider/izpārdošanā',
			ly: 'provider/:provider/on-sale',
			ma: 'provider/:provider/on-sale',
			mc: 'plateforme/:provider/on-sale',
			md: 'furnizor/:provider/on-sale',
			me: 'provajder/:provider/on-sale',
			mg: 'plateforme/:provider/on-sale',
			mk: 'провајдер/:provider/on-sale',
			ml: 'plateforme/:provider/on-sale',
			mt: 'fornitur/:provider/on-sale',
			mu: 'plateforme/:provider/on-sale',
			mw: 'provider/:provider/on-sale',
			mx: 'proveedor/:provider/on-sale',
			my: 'provider/:provider/on-sale',
			mz: 'provedor/:provider/on-sale',
			ne: 'plateforme/:provider/on-sale',
			ng: 'provider/:provider/on-sale',
			ni: 'proveedor/:provider/on-sale',
			nl: 'provider/:provider/aanbieding',
			no: 'provider/:provider/salg',
			nz: 'provider/:provider/on-sale',
			om: 'provider/:provider/on-sale',
			pa: 'proveedor/:provider/on-sale',
			pe: 'proveedor/:provider/on-sale',
			pf: 'plateforme/:provider/on-sale',
			pg: 'provider/:provider/on-sale',
			ph: 'provider/:provider/on-sale',
			pk: 'provider/:provider/on-sale',
			pl: 'serwis-streamingowy/:provider/na-wyprzedaży',
			ps: 'provider/:provider/on-sale',
			pt: 'provedor/:provider/ofertas',
			py: 'proveedor/:provider/on-sale',
			qa: 'provider/:provider/on-sale',
			ro: 'furnizor/:provider/la-reducere',
			rs: 'provajder/:provider/on-sale',
			ru: 'провайдер/:provider/продается',
			sa: 'provider/:provider/on-sale',
			sc: 'plateforme/:provider/on-sale',
			se: 'leverantör/:provider/on-sale',
			sg: 'provider/:provider/on-sale',
			sk: 'poskytovateľ/:provider/v-zľave',
			si: 'ponudnik/:provider/on-sale',
			sm: 'provider/:provider/on-sale',
			sn: 'plateforme/:provider/on-sale',
			sv: 'proveedor/:provider/rabatterat-pris',
			tt: 'provider/:provider/on-sale',
			tc: 'provider/:provider/on-sale',
			td: 'provider/:provider/on-sale',
			th: 'provider/:provider/on-sale',
			tn: 'provider/:provider/on-sale',
			tr: 'saglayici/:provider/indirimde',
			tw: '平台/:provider/on-sale',
			tz: 'mtoa-huduma/:provider/on-sale',
			ua: 'провайдер/:provider/on-sale',
			ug: 'provider/:provider/on-sale',
			uk: 'provider/:provider/on-sale',
			us: 'provider/:provider/on-sale',
			uy: 'proveedor/:provider/on-sale',
			va: 'provider/:provider/on-sale',
			ve: 'proveedor/:provider/on-sale',
			xk: 'ofruesi/:provider/on-sale',
			ye: 'provider/:provider/on-sale',
			za: 'provider/:provider/on-sale',
			zm: 'provider/:provider/on-sale',
			zw: 'provider/:provider/on-sale',
		},
		redirect: {
			dk: 'udbyder/:provider/on-sale',
			id: 'penyedia/:provider/on-sale',
			lt: 'tiekėjas/:provider/išpardavimas',
			lv: 'apgādātājs/:provider/izpārdošanā',
			my: 'pemberi/:provider/on-sale',
			no: 'tjeneste/:provider/salg',
			se: 'leverantör/:provider/on-sale',
			th: 'ผู้ให้บริการ/:provider/on-sale',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.PriceDrop,
			contexts: ['filter'],
			tab: 'on-sale',
		},
	},
	'app.titles.pricedrops.provider-movie': {
		component: New,
		urls: {
			ad: 'plataforma/:provider/on-sale/pellicules',
			ae: 'provider/:provider/on-sale/movies',
			ag: 'provider/:provider/on-sale/movies',
			al: 'ofruesi/:provider/on-sale/filmat',
			az: 'provayder/:provider/on-sale/filmlər',
			ao: 'provedor/:provider/on-sale/filmes',
			ar: 'proveedor/:provider/on-sale/peliculas',
			at: 'Anbieter/:provider/heute-im-sale/Filme',
			au: 'provider/:provider/on-sale/movies',
			ba: 'provajder/:provider/on-sale/filmovi',
			bb: 'provider/:provider/on-sale/movies',
			be: 'plateforme/:provider/on-sale/films',
			bf: 'plateforme/:provider/on-sale/films',
			bg: 'доставчик/:provider/в-разпродажба/филми',
			bh: 'provider/:provider/on-sale/movies',
			bm: 'provider/:provider/on-sale/movies',
			bo: 'proveedor/:provider/on-sale/peliculas',
			br: 'provedor/:provider/on-sale/filmes',
			bs: 'provider/:provider/on-sale/movies',
			by: 'правайдэр/:provider/on-sale/сезон',
			bz: 'provider/:provider/on-sale/movies',
			ca: 'provider/:provider/on-sale/movies',
			cd: 'plateforme/:provider/on-sale/films',
			ch: 'Anbieter/:provider/on-sale/Filme',
			ci: 'plateforme/:provider/on-sale/films',
			cl: 'proveedor/:provider/on-sale/peliculas',
			cm: 'provider/:provider/on-sale/movies',
			co: 'proveedor/:provider/on-sale/peliculas',
			cr: 'proveedor/:provider/on-sale/peliculas',
			cu: 'proveedor/:provider/on-sale/peliculas',
			cv: 'provedor/:provider/on-sale/filmes',
			cy: 'πάροχος/:provider/on-sale/ταινίες',
			cz: 'poskytovatel/:provider/on-sale/filmy',
			de: 'Anbieter/:provider/heute-im-sale/Filme',
			dk: 'provider/:provider/on-sale/movies',
			do: 'proveedor/:provider/on-sale/peliculas',
			dz: 'provider/:provider/on-sale/movies',
			ec: 'proveedor/:provider/on-sale/peliculas',
			ee: 'teenusepakkuja/:provider/on-sale/filmid',
			eg: 'provider/:provider/on-sale/movies',
			es: 'proveedor/:provider/ofertas/peliculas',
			fi: 'palvelu/:provider/tarjouksessa/elokuvat',
			fj: 'provider/:provider/on-sale/movies',
			fr: 'plateforme/:provider/promos/films',
			gf: 'plateforme/:provider/on-sale/films',
			gg: 'provider/:provider/on-sale/movies',
			gh: 'provider/:provider/on-sale/movies',
			gi: 'provider/:provider/on-sale/movies',
			gq: 'proveedor/:provider/on-sale/peliculas',
			gr: 'πάροχος/:provider/on-sale/ταινίες',
			gt: 'proveedor/:provider/on-sale/peliculas',
			gy: 'provider/:provider/on-sale/movies',
			hk: '供應商/:provider/on-sale/電影',
			hn: 'proveedor/:provider/on-sale/peliculas',
			hr: 'pružatelj-usluge/:provider/promotivna-ponuda/filmovi',
			hu: 'szolgaltato/:provider/eladó/filmek',
			id: 'provider/:provider/on-sale/movies',
			ie: 'provider/:provider/on-sale/movies',
			il: 'provider/:provider/on-sale/movies',
			in: 'provider/:provider/on-sale/movies',
			iq: 'provider/:provider/on-sale/movies',
			is: 'veita/:provider/útsala/kvikmyndir',
			it: 'provider/:provider/offerte/film',
			jm: 'provider/:provider/on-sale/movies',
			jo: 'provider/:provider/on-sale/movies',
			jp: '動画配信サービス/:provider/on-sale/映画',
			ke: 'provider/:provider/on-sale/movies',
			kr: '동영상서비스/:provider/on-sale/영화',
			kw: 'provider/:provider/on-sale/movies',
			lb: 'provider/:provider/on-sale/movies',
			lc: 'provider/:provider/on-sale/movies',
			li: 'Anbieter/:provider/on-sale/Filme',
			lt: 'tiekėjas/:provider/išpardavimas/filmai',
			lu: 'plateforme/:provider/on-sale/films',
			lv: 'apgādātājs/:provider/izpārdošanā/filmas',
			ly: 'provider/:provider/on-sale/movies',
			ma: 'provider/:provider/on-sale/movies',
			mc: 'plateforme/:provider/on-sale/films',
			md: 'провајдер/:provider/on-sale/филмови',
			me: 'provajder/:provider/on-sale/filmovi',
			mg: 'plateforme/:provider/on-sale/films',
			mk: 'furnizor/:provider/on-sale/filme',
			ml: 'plateforme/:provider/on-sale/films',
			mt: 'fornitur/:provider/on-sale/films',
			mu: 'plateforme/:provider/on-sale/films',
			mw: 'provider/:provider/on-sale/movies',
			mx: 'proveedor/:provider/on-sale/peliculas',
			my: 'provider/:provider/on-sale/movies',
			mz: 'provedor/:provider/on-sale/filmes',
			ne: 'plateforme/:provider/on-sale/films',
			ng: 'provider/:provider/on-sale/movies',
			ni: 'proveedor/:provider/on-sale/peliculas',
			nl: 'provider/:provider/aanbieding/movies',
			no: 'provider/:provider/salg/movies',
			nz: 'provider/:provider/on-sale/movies',
			om: 'provider/:provider/on-sale/movies',
			pa: 'proveedor/:provider/on-sale/peliculas',
			pe: 'proveedor/:provider/on-sale/peliculas',
			pf: 'plateforme/:provider/on-sale/films',
			pg: 'provider/:provider/on-sale/movies',
			ph: 'provider/:provider/on-sale/movies',
			pk: 'provider/:provider/on-sale/movies',
			pl: 'serwis-streamingowy/:provider/na-wyprzedaży/filmy',
			ps: 'provider/:provider/on-sale/movies',
			pt: 'provedor/:provider/ofertas/filmes',
			py: 'proveedor/:provider/on-sale/peliculas',
			qa: 'provider/:provider/on-sale/movies',
			ro: 'furnizor/:provider/la-reducere/filme',
			rs: 'provajder/:provider/on-sale/filmovi',
			ru: 'провайдер/:provider/продается/фильмы',
			sa: 'provider/:provider/on-sale/movies',
			sc: 'plateforme/:provider/on-sale/films',
			se: 'leverantör/:provider/on-sale/filmer',
			sg: 'provider/:provider/on-sale/movies',
			sk: 'poskytovateľ/:provider/v-zľave/filmy',
			si: 'ponudnik/:provider/on-sale/filmi',
			sm: 'provider/:provider/on-sale/film',
			sn: 'plateforme/:provider/on-sale/films',
			sv: 'proveedor/:provider/rabatterat-pris/peliculas',
			tc: 'provider/:provider/on-sale/movies',
			td: 'provider/:provider/on-sale/movies',
			th: 'provider/:provider/on-sale/movies',
			tn: 'provider/:provider/on-sale/movies',
			tr: 'saglayici/:provider/indirimde/filmler',
			tt: 'provider/:provider/on-sale/movies',
			tw: '平台/:provider/on-sale/電影',
			tz: 'mtoa-huduma/:provider/on-sale/filamu',
			ua: 'провайдер/:provider/on-sale/фільми',
			ug: 'provider/:provider/on-sale/movies',
			uk: 'provider/:provider/on-sale/movies',
			us: 'provider/:provider/on-sale/movies',
			uy: 'proveedor/:provider/on-sale/peliculas',
			va: 'provider/:provider/on-sale/movies',
			ve: 'proveedor/:provider/on-sale/peliculas',
			xk: 'ofruesi/:provider/on-sale/filmat',
			ye: 'provider/:provider/on-sale/movies',
			za: 'provider/:provider/on-sale/movies',
			zm: 'provider/:provider/on-sale/movies',
			zw: 'provider/:provider/on-sale/movies',
		},
		redirect: {
			dk: 'udbyder/:provider/on-sale/film',
			id: 'penyedia/:provider/on-sale/film',
			lt: 'tiekėjas/:provider/išpardavimas/filmai',
			lv: 'apgādātājs/:provider/izpārdošanā/filmas',
			my: 'pemberi/:provider/on-sale/filem',
			no: 'tjeneste/:provider/salg/filmer',
			se: 'leverantör/:provider/on-sale/filmer',
			th: 'ผู้ให้บริการ/:provider/on-sale/ภาพยนต์',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.PriceDrop,
			initialRouteState: { content_types: [TitleObjectType.MOVIE] },
			contexts: ['filter'],
			tab: 'on-sale',
		},
	},
	'app.titles.pricedrops.provider-show': {
		component: New,
		urls: {
			ad: 'plataforma/:provider/on-sale/series',
			ae: 'provider/:provider/on-sale/tv-shows',
			ag: 'provider/:provider/on-sale/tv-shows',
			al: 'ofruesi/:provider/on-sale/seriale-televizive',
			az: 'provayder/:provider/on-sale/televiziya-şouları',
			ao: 'provedor/:provider/on-sale/series',
			ar: 'proveedor/:provider/on-sale/series',
			at: 'Anbieter/:provider/heute-im-sale/Serien',
			au: 'provider/:provider/on-sale/tv-shows',
			ba: 'provajder/:provider/on-sale/tv-serije',
			bb: 'provider/:provider/on-sale/tv-shows',
			be: 'plateforme/:provider/on-sale/series',
			bf: 'plateforme/:provider/on-sale/series',
			bg: 'доставчик/:provider/в-разпродажба/сериали',
			bh: 'provider/:provider/on-sale/tv-shows',
			bm: 'provider/:provider/on-sale/tv-shows',
			bo: 'proveedor/:provider/on-sale/series',
			br: 'provedor/:provider/on-sale/series',
			bs: 'provider/:provider/on-sale/tv-shows',
			by: 'правайдэр/:provider/on-sale/сезон',
			bz: 'provider/:provider/on-sale/tv-shows',
			ca: 'provider/:provider/on-sale/tv-shows',
			cd: 'plateforme/:provider/on-sale/series',
			ch: 'Anbieter/:provider/on-sale/Serien',
			ci: 'plateforme/:provider/on-sale/series',
			cl: 'proveedor/:provider/on-sale/series',
			cm: 'provider/:provider/on-sale/tv-shows',
			co: 'proveedor/:provider/on-sale/series',
			cr: 'proveedor/:provider/on-sale/series',
			cu: 'proveedor/:provider/on-sale/series',
			cv: 'provedor/:provider/on-sale/series',
			cy: 'πάροχος/:provider/on-sale/τηλεοπτικές-σειρές',
			cz: 'poskytovatel/:provider/on-sale/serialy',
			de: 'Anbieter/:provider/heute-im-sale/Serien',
			dk: 'provider/:provider/on-sale/tv-series',
			do: 'proveedor/:provider/on-sale/series',
			dz: 'provider/:provider/on-sale/tv-shows',
			ec: 'proveedor/:provider/on-sale/series',
			ee: 'teenusepakkuja/:provider/on-sale/seriaalid',
			eg: 'provider/:provider/on-sale/tv-shows',
			es: 'proveedor/:provider/ofertas/series',
			fi: 'palvelu/:provider/tarjouksessa/sarjat',
			fj: 'provider/:provider/on-sale/tv-shows',
			fr: 'plateforme/:provider/promos/series',
			gf: 'plateforme/:provider/on-sale/series',
			gg: 'provider/:provider/on-sale/tv-series',
			gh: 'provider/:provider/on-sale/tv-shows',
			gi: 'provider/:provider/on-sale/tv-shows',
			gq: 'proveedor/:provider/on-sale/series',
			gr: 'πάροχος/:provider/on-sale/τηλεοπτικές-σειρές',
			gt: 'proveedor/:provider/on-sale/series',
			gy: 'provider/:provider/on-sale/tv-shows',
			hk: '供應商/:provider/on-sale/節目',
			hn: 'proveedor/:provider/on-sale/series',
			hr: 'pružatelj-usluge/:provider/promotivna-ponuda/serije',
			hu: 'szolgaltato/:provider/eladó/tv-sorozat',
			id: 'provider/:provider/on-sale/tv-shows',
			ie: 'provider/:provider/on-sale/tv-series',
			il: 'provider/:provider/on-sale/tv-shows',
			in: 'provider/:provider/on-sale/tv-shows',
			iq: 'provider/:provider/on-sale/tv-shows',
			is: 'veita/:provider/útsala/þættir',
			it: 'provider/:provider/offerte/serie-tv',
			jm: 'provider/:provider/on-sale/tv-shows',
			jo: 'provider/:provider/on-sale/tv-shows',
			jp: '動画配信サービス/:provider/on-sale/テレビ番組',
			ke: 'provider/:provider/on-sale/tv-shows',
			kr: '동영상서비스/:provider/on-sale/TV-프로그램',
			kw: 'provider/:provider/on-sale/tv-shows',
			lb: 'provider/:provider/on-sale/tv-shows',
			lc: 'provider/:provider/on-sale/tv-shows',
			li: 'Anbieter/:provider/on-sale/Serien',
			lt: 'tiekėjas/:provider/išpardavimas/tv-laidos',
			lu: 'plateforme/:provider/on-sale/series',
			lv: 'apgādātājs/:provider/izpārdošanā/tv-pārraide',
			ly: 'provider/:provider/on-sale/tv-shows',
			ma: 'provider/:provider/on-sale/tv-shows',
			mc: 'plateforme/:provider/on-sale/series',
			md: 'furnizor/:provider/on-sale/seriale',
			me: 'provajder/:provider/on-sale/tv-programi',
			mg: 'plateforme/:provider/on-sale/series',
			mk: 'провајдер/:provider/on-sale/тв-серии',
			ml: 'plateforme/:provider/on-sale/series',
			mt: 'fornitur/:provider/on-sale/serje-televiżivi',
			mu: 'plateforme/:provider/on-sale/series',
			mw: 'provider/:provider/on-sale/tv-shows',
			mx: 'proveedor/:provider/on-sale/series',
			my: 'provider/:provider/on-sale/tv-shows',
			mz: 'provedor/:provider/on-sale/series',
			ne: 'plateforme/:provider/on-sale/series',
			ng: 'provider/:provider/on-sale/tv-shows',
			ni: 'proveedor/:provider/on-sale/series',
			nl: 'provider/:provider/aanbieding/tv-series',
			no: 'provider/:provider/salg/tv-series',
			nz: 'provider/:provider/on-sale/tv-shows',
			om: 'provider/:provider/on-sale/tv-shows',
			pa: 'proveedor/:provider/on-sale/series',
			pe: 'proveedor/:provider/on-sale/series',
			pf: 'plateforme/:provider/on-sale/series',
			pg: 'provider/:provider/on-sale/tv-shows',
			ph: 'provider/:provider/on-sale/tv-shows',
			pk: 'provider/:provider/on-sale/tv-shows',
			pl: 'serwis-streamingowy/:provider/na-wyprzedaży/seriale',
			ps: 'provider/:provider/on-sale/tv-shows',
			pt: 'provedor/:provider/ofertas/series',
			py: 'proveedor/:provider/on-sale/series',
			qa: 'provider/:provider/on-sale/tv-shows',
			ro: 'furnizor/:provider/la-reducere/seriale',
			rs: 'provajder/:provider/on-sale/tv-programi',
			ru: 'провайдер/:provider/продается/сериалы',
			sa: 'provider/:provider/on-sale/tv-shows',
			sc: 'plateforme/:provider/on-sale/series',
			se: 'leverantör/:provider/on-sale/tv-serier',
			sg: 'provider/:provider/on-sale/tv-shows',
			sk: 'poskytovateľ/:provider/v-zľave/seriály',
			si: 'ponudnik/:provider/on-sale/serije',
			sm: 'provider/:provider/on-sale/serie-tv',
			sn: 'plateforme/:provider/on-sale/series',
			sv: 'proveedor/:provider/rabatterat-pris/series',
			tc: 'provider/:provider/on-sale/tv-shows',
			td: 'provider/:provider/on-sale/tv-shows',
			th: 'provider/:provider/on-sale/tv-shows',
			tn: 'provider/:provider/on-sale/tv-shows',
			tr: 'saglayici/:provider/indirimde/tv-dizileri',
			tt: 'provider/:provider/on-sale/tv-shows',
			tw: '平台/:provider/on-sale/節目',
			tz: 'mtoa-huduma/:provider/on-sale/maonyesho-ya-tv',
			ua: 'провайдер/:provider/on-sale/телесеріали',
			ug: 'provider/:provider/on-sale/tv-shows',
			uk: 'provider/:provider/on-sale/tv-series',
			us: 'provider/:provider/on-sale/tv-shows',
			uy: 'proveedor/:provider/on-sale/series',
			va: 'provider/:provider/on-sale/tv-shows',
			ve: 'proveedor/:provider/on-sale/series',
			xk: 'ofruesi/:provider/on-sale/seriale-televizive',
			ye: 'provider/:provider/on-sale/tv-shows',
			za: 'provider/:provider/on-sale/tv-series',
			zm: 'provider/:provider/on-sale/tv-series',
			zw: 'provider/:provider/on-sale/tv-shows',
		},
		redirect: {
			dk: 'udbyder/:provider/on-sale/tv-serier',
			id: 'penyedia/:provider/on-sale/acara-tv',
			lt: 'tiekėjas/:provider/išpardavimas/tv-laidos',
			lv: 'apgādātājs/:provider/izpārdošanā/tv-pārraide',
			my: 'pemberi/:provider/on-sale/rancangan-tv',
			no: 'tjeneste/:provider/salg/tv-serier',
			se: 'leverantör/:provider/on-sale/tv-serier',
			th: 'ผู้ให้บริการ/:provider/on-sale/รายการทีวี',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.PriceDrop,
			initialRouteState: { content_types: [TitleObjectType.SHOW] },
			contexts: ['filter'],
			tab: 'on-sale',
		},
	},

	// --- NEW / LEAVING SOON ---
	'app.titles.leaving-soon.list': {
		component: New,
		urls: {
			ad: 'leaving-soon',
			ae: 'leaving-soon',
			ag: 'leaving-soon',
			al: 'leaving-soon',
			az: 'leaving-soon',
			ao: 'leaving-soon',
			ar: 'leaving-soon',
			at: 'letzte-chance',
			au: 'leaving-soon',
			ba: 'leaving-soon',
			bb: 'leaving-soon',
			be: 'leaving-soon',
			bf: 'leaving-soon',
			bg: 'отпадащи-скоро',
			bh: 'leaving-soon',
			bm: 'leaving-soon',
			bo: 'leaving-soon',
			br: 'leaving-soon',
			bs: 'leaving-soon',
			by: 'leaving-soon',
			bz: 'leaving-soon',
			ca: 'leaving-soon',
			cd: 'leaving-soon',
			ch: 'leaving-soon',
			ci: 'leaving-soon',
			cl: 'leaving-soon',
			cm: 'leaving-soon',
			co: 'leaving-soon',
			cr: 'leaving-soon',
			cu: 'leaving-soon',
			cv: 'leaving-soon',
			cy: 'leaving-soon',
			cz: 'leaving-soon',
			de: 'letzte-chance',
			dk: 'leaving-soon',
			do: 'leaving-soon',
			dz: 'leaving-soon',
			ec: 'leaving-soon',
			ee: 'leaving-soon',
			eg: 'leaving-soon',
			es: 'ultimos-dias',
			fi: 'poistumassa',
			fj: 'leaving-soon',
			fr: 'bientot-retire',
			gf: 'leaving-soon',
			gg: 'leaving-soon',
			gh: 'leaving-soon',
			gi: 'leaving-soon',
			gq: 'leaving-soon',
			gr: 'leaving-soon',
			gt: 'leaving-soon',
			gy: 'leaving-soon',
			hk: 'leaving-soon',
			hn: 'leaving-soon',
			hr: 'jos-kratko-u-ponudi',
			hu: 'hamarosan-kifut',
			id: 'leaving-soon',
			ie: 'leaving-soon',
			il: 'leaving-soon',
			in: 'leaving-soon',
			iq: 'leaving-soon',
			is: 'haettir-bratt',
			it: 'in-scadenza',
			jm: 'leaving-soon',
			jo: 'leaving-soon',
			jp: 'leaving-soon',
			ke: 'leaving-soon',
			kr: 'leaving-soon',
			kw: 'leaving-soon',
			lb: 'leaving-soon',
			lc: 'leaving-soon',
			li: 'leaving-soon',
			lt: 'netrukus-nebeliks',
			lu: 'leaving-soon',
			lv: 'pedeja-iespeja',
			ly: 'leaving-soon',
			ma: 'leaving-soon',
			mc: 'leaving-soon',
			md: 'leaving-soon',
			me: 'leaving-soon',
			mg: 'leaving-soon',
			mk: 'leaving-soon',
			ml: 'leaving-soon',
			mt: 'leaving-soon',
			mu: 'leaving-soon',
			mw: 'leaving-soon',
			mx: 'leaving-soon',
			my: 'leaving-soon',
			mz: 'leaving-soon',
			ne: 'leaving-soon',
			ng: 'leaving-soon',
			ni: 'leaving-soon',
			nl: 'binnenkort-verwijderd',
			no: 'blir-snart-borte',
			nz: 'leaving-soon',
			om: 'leaving-soon',
			pa: 'leaving-soon',
			pe: 'leaving-soon',
			pf: 'leaving-soon',
			pg: 'leaving-soon',
			ph: 'leaving-soon',
			pk: 'leaving-soon',
			pl: 'wkrotce-znikna',
			ps: 'leaving-soon',
			pt: 'de-saida',
			py: 'leaving-soon',
			qa: 'leaving-soon',
			ro: 'nu-vor-mai-fi-disponibile-in-curand',
			rs: 'leaving-soon',
			ru: 'скоро-пропадет',
			sa: 'leaving-soon',
			sc: 'leaving-soon',
			se: 'leaving-soon',
			sg: 'leaving-soon',
			sk: 'coskoro-odide',
			si: 'leaving-soon',
			sm: 'leaving-soon',
			sn: 'leaving-soon',
			sv: 'utgår-snart',
			tc: 'leaving-soon',
			td: 'leaving-soon',
			th: 'leaving-soon',
			tn: 'leaving-soon',
			tr: 'yayından-kalkacaklar',
			tt: 'leaving-soon',
			tw: 'leaving-soon',
			tz: 'leaving-soon',
			ua: 'leaving-soon',
			ug: 'leaving-soon',
			uk: 'leaving-soon',
			us: 'leaving-soon',
			uy: 'leaving-soon',
			va: 'leaving-soon',
			ve: 'leaving-soon',
			xk: 'leaving-soon',
			ye: 'leaving-soon',
			za: 'leaving-soon',
			zm: 'leaving-soon',
			zw: 'leaving-soon',
		},
		redirect: {
			dk: 'leaving-soon',
			id: 'leaving-soon',
			lt: 'netrukus-nebeliks',
			lv: 'pedeja-iespeja',
			my: 'leaving-soon',
			no: 'blir-snart-borte',
			se: 'leaving-soon',
			th: 'leaving-soon',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.LeavingSoon,
			contexts: ['filter'],
			tab: 'leaving-soon',
		},
	},
	'app.titles.leaving-soon.provider': {
		component: New,
		urls: {
			ad: 'plataforma/:provider/leaving-soon',
			ae: 'provider/:provider/leaving-soon',
			ag: 'provider/:provider/leaving-soon',
			al: 'ofruesi/:provider/leaving-soon',
			az: 'provayder/:provider/leaving-soon',
			ao: 'provedor/:provider/leaving-soon',
			ar: 'proveedor/:provider/leaving-soon',
			at: 'Anbieter/:provider/letzte-chance',
			au: 'provider/:provider/leaving-soon',
			ba: 'provajder/:provider/leaving-soon',
			bb: 'provider/:provider/leaving-soon',
			be: 'plateforme/:provider/leaving-soon',
			bf: 'plateforme/:provider/leaving-soon',
			bg: 'доставчик/:provider/отпадащи-скоро',
			bh: 'provider/:provider/leaving-soon',
			bm: 'provider/:provider/leaving-soon',
			bo: 'proveedor/:provider/leaving-soon',
			br: 'provedor/:provider/leaving-soon',
			bs: 'provider/:provider/leaving-soon',
			by: 'правайдэр/:provider/leaving-soon',
			bz: 'provider/:provider/leaving-soon',
			ca: 'provider/:provider/leaving-soon',
			cd: 'plateforme/:provider/leaving-soon',
			ch: 'Anbieter/:provider/leaving-soon',
			ci: 'plateforme/:provider/leaving-soon',
			cl: 'proveedor/:provider/leaving-soon',
			cm: 'provider/:provider/leaving-soon',
			co: 'proveedor/:provider/leaving-soon',
			cr: 'proveedor/:provider/leaving-soon',
			cu: 'proveedor/:provider/leaving-soon',
			cv: 'provedor/:provider/leaving-soon',
			cy: 'πάροχος/:provider/leaving-soon',
			cz: 'poskytovatel/:provider/leaving-soon',
			de: 'Anbieter/:provider/letzte-chance',
			dk: 'provider/:provider/leaving-soon',
			do: 'proveedor/:provider/leaving-soon',
			dz: 'provider/:provider/leaving-soon',
			ec: 'proveedor/:provider/leaving-soon',
			ee: 'teenusepakkuja/:provider/leaving-soon',
			eg: 'provider/:provider/leaving-soon',
			es: 'proveedor/:provider/ultimos-dias',
			fi: 'palvelu/:provider/poistumassa',
			fj: 'provider/:provider/leaving-soon',
			fr: 'plateforme/:provider/bientot-retire',
			gf: 'plateforme/:provider/leaving-soon',
			gg: 'provider/:provider/leaving-soon',
			gh: 'provider/:provider/leaving-soon',
			gi: 'provider/:provider/leaving-soon',
			gq: 'proveedor/:provider/leaving-soon',
			gr: 'πάροχος/:provider/leaving-soon',
			gt: 'proveedor/:provider/leaving-soon',
			gy: 'provider/:provider/leaving-soon',
			hk: '供應商/:provider/leaving-soon',
			hn: 'proveedor/:provider/leaving-soon',
			hr: 'pružatelj-usluge/:provider/jos-kratko-u-ponudi',
			hu: 'szolgaltato/:provider/hamarosan-kifut',
			id: 'provider/:provider/leaving-soon',
			ie: 'provider/:provider/leaving-soon',
			il: 'provider/:provider/leaving-soon',
			in: 'provider/:provider/leaving-soon',
			iq: 'provider/:provider/leaving-soon',
			is: 'veita/:provider/haettir-bratt',
			it: 'provider/:provider/in-scadenza',
			jm: 'provider/:provider/leaving-soon',
			jo: 'provider/:provider/leaving-soon',
			jp: '動画配信サービス/:provider/leaving-soon',
			ke: 'provider/:provider/leaving-soon',
			kr: '동영상서비스/:provider/leaving-soon',
			kw: 'provider/:provider/leaving-soon',
			lb: 'provider/:provider/leaving-soon',
			lc: 'provider/:provider/leaving-soon',
			li: 'Anbieter/:provider/leaving-soon',
			lt: 'tiekėjas/:provider/netrukus-nebeliks',
			lu: 'plateforme/:provider/leaving-soon',
			lv: 'apgādātājs/:provider/pedeja-iespeja',
			ly: 'provider/:provider/leaving-soon',
			ma: 'provider/:provider/leaving-soon',
			mc: 'plateforme/:provider/leaving-soon',
			md: 'furnizor/:provider/leaving-soon',
			me: 'provajder/:provider/leaving-soon',
			mg: 'plateforme/:provider/leaving-soon',
			mk: 'провајдер/:provider/leaving-soon',
			ml: 'plateforme/:provider/leaving-soon',
			mt: 'fornitur/:provider/leaving-soon',
			mu: 'plateforme/:provider/leaving-soon',
			mw: 'provider/:provider/leaving-soon',
			mx: 'proveedor/:provider/leaving-soon',
			my: 'provider/:provider/leaving-soon',
			mz: 'provedor/:provider/leaving-soon',
			ne: 'plateforme/:provider/leaving-soon',
			ng: 'provider/:provider/leaving-soon',
			ni: 'proveedor/:provider/leaving-soon',
			nl: 'provider/:provider/binnenkort-verwijderd',
			no: 'provider/:provider/blir-snart-borte',
			nz: 'provider/:provider/leaving-soon',
			om: 'provider/:provider/leaving-soon',
			pa: 'proveedor/:provider/leaving-soon',
			pe: 'proveedor/:provider/leaving-soon',
			pf: 'plateforme/:provider/leaving-soon',
			pg: 'provider/:provider/leaving-soon',
			ph: 'provider/:provider/leaving-soon',
			pk: 'provider/:provider/leaving-soon',
			pl: 'serwis-streamingowy/:provider/wkrotce-znikna',
			ps: 'provider/:provider/leaving-soon',
			pt: 'provedor/:provider/de-saida',
			py: 'proveedor/:provider/leaving-soon',
			qa: 'provider/:provider/leaving-soon',
			ro: 'furnizor/:provider/nu-vor-mai-fi-disponibile-in-curand',
			rs: 'provajder/:provider/leaving-soon',
			ru: 'провайдер/:provider/скоро-пропадет',
			sa: 'provider/:provider/leaving-soon',
			sc: 'plateforme/:provider/leaving-soon',
			se: 'leverantör/:provider/leaving-soon',
			sg: 'provider/:provider/leaving-soon',
			sk: 'poskytovateľ/:provider/coskoro-odide',
			si: 'ponudnik/:provider/leaving-soon',
			sm: 'provider/:provider/leaving-soon',
			sn: 'plateforme/:provider/leaving-soon',
			sv: 'proveedor/:provider/utgår-snart',
			tt: 'provider/:provider/leaving-soon',
			tc: 'provider/:provider/leaving-soon',
			td: 'provider/:provider/leaving-soon',
			th: 'provider/:provider/leaving-soon',
			tn: 'provider/:provider/leaving-soon',
			tr: 'saglayici/:provider/yayından-kalkacaklar',
			tw: '平台/:provider/leaving-soon',
			tz: 'mtoa-huduma/:provider/leaving-soon',
			ua: 'провайдер/:provider/leaving-soon',
			ug: 'provider/:provider/leaving-soon',
			uk: 'provider/:provider/leaving-soon',
			us: 'provider/:provider/leaving-soon',
			uy: 'proveedor/:provider/leaving-soon',
			va: 'provider/:provider/leaving-soon',
			ve: 'proveedor/:provider/leaving-soon',
			xk: 'ofruesi/:provider/leaving-soon',
			ye: 'provider/:provider/leaving-soon',
			za: 'provider/:provider/leaving-soon',
			zm: 'provider/:provider/leaving-soon',
			zw: 'provider/:provider/leaving-soon',
		},
		redirect: {
			dk: 'udbyder/:provider/leaving-soon',
			id: 'penyedia/:provider/leaving-soon',
			lt: 'tiekėjas/:provider/netrukus-nebeliks',
			lv: 'apgādātājs/:provider/pedeja-iespeja',
			my: 'pemberi/:provider/leaving-soon',
			no: 'tjeneste/:provider/blir-snart-borte',
			se: 'leverantör/:provider/leaving-soon',
			th: 'ผู้ให้บริการ/:provider/leaving-soon',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.LeavingSoon,
			contexts: ['filter'],
			tab: 'leaving-soon',
		},
	},

	// --- NEW / COMING SOON ---
	'app.titles.coming-soon.list': {
		component: New,
		urls: {
			ad: 'coming-soon',
			ae: 'coming-soon',
			ag: 'coming-soon',
			al: 'coming-soon',
			az: 'coming-soon',
			ao: 'coming-soon',
			ar: 'coming-soon',
			at: 'demnaechst-verfuegbar',
			au: 'coming-soon',
			ba: 'coming-soon',
			bb: 'coming-soon',
			be: 'coming-soon',
			bf: 'coming-soon',
			bg: 'налични-скоро',
			bh: 'coming-soon',
			bm: 'coming-soon',
			bo: 'coming-soon',
			br: 'coming-soon',
			bs: 'coming-soon',
			by: 'coming-soon',
			bz: 'coming-soon',
			ca: 'coming-soon',
			cd: 'coming-soon',
			ch: 'coming-soon',
			ci: 'coming-soon',
			cl: 'coming-soon',
			cm: 'coming-soon',
			co: 'coming-soon',
			cr: 'coming-soon',
			cu: 'coming-soon',
			cv: 'coming-soon',
			cy: 'coming-soon',
			cz: 'coming-soon',
			de: 'demnaechst-verfuegbar',
			dk: 'coming-soon',
			do: 'coming-soon',
			dz: 'coming-soon',
			ec: 'coming-soon',
			ee: 'coming-soon',
			eg: 'coming-soon',
			es: 'llegaran-pronto',
			fi: 'tulossa-pian',
			fj: 'coming-soon',
			fr: 'bientot-disponible',
			gf: 'coming-soon',
			gg: 'coming-soon',
			gh: 'coming-soon',
			gi: 'coming-soon',
			gq: 'coming-soon',
			gr: 'coming-soon',
			gt: 'coming-soon',
			gy: 'coming-soon',
			hk: 'coming-soon',
			hn: 'coming-soon',
			hr: 'uskoro-u-ponudi',
			hu: 'hamarosan-erkezik',
			id: 'coming-soon',
			ie: 'coming-soon',
			il: 'coming-soon',
			in: 'coming-soon',
			iq: 'coming-soon',
			is: 'vaentanlegt',
			it: 'in-arrivo',
			jm: 'coming-soon',
			jo: 'coming-soon',
			jp: 'coming-soon',
			ke: 'coming-soon',
			kr: 'coming-soon',
			kw: 'coming-soon',
			lb: 'coming-soon',
			lc: 'coming-soon',
			li: 'coming-soon',
			lt: 'jau-greitai',
			lu: 'coming-soon',
			lv: 'drizuma',
			ly: 'coming-soon',
			ma: 'coming-soon',
			mc: 'coming-soon',
			md: 'coming-soon',
			me: 'coming-soon',
			mg: 'coming-soon',
			mk: 'coming-soon',
			ml: 'coming-soon',
			mt: 'coming-soon',
			mu: 'coming-soon',
			mw: 'coming-soon',
			mx: 'coming-soon',
			my: 'coming-soon',
			mz: 'coming-soon',
			ne: 'coming-soon',
			ng: 'coming-soon',
			ni: 'coming-soon',
			nl: 'binnenkort-beschikbaar',
			no: 'kommer-snart',
			nz: 'coming-soon',
			om: 'coming-soon',
			pa: 'coming-soon',
			pe: 'coming-soon',
			pf: 'coming-soon',
			pg: 'coming-soon',
			ph: 'coming-soon',
			pk: 'coming-soon',
			pl: 'juz-wkrotce',
			ps: 'coming-soon',
			pt: 'brevemente',
			py: 'coming-soon',
			qa: 'coming-soon',
			ro: 'in-curand',
			rs: 'coming-soon',
			ru: 'скоро-появится',
			sa: 'coming-soon',
			sc: 'coming-soon',
			se: 'coming-soon',
			sg: 'coming-soon',
			sk: 'coskoro-príde',
			si: 'coming-soon',
			sm: 'coming-soon',
			sn: 'coming-soon',
			sv: 'kommer-snart',
			tc: 'coming-soon',
			td: 'coming-soon',
			th: 'coming-soon',
			tn: 'coming-soon',
			tr: 'yayina-girecekler',
			tt: 'coming-soon',
			tw: 'coming-soon',
			tz: 'coming-soon',
			ua: 'coming-soon',
			ug: 'coming-soon',
			uk: 'coming-soon',
			us: 'coming-soon',
			uy: 'coming-soon',
			va: 'coming-soon',
			ve: 'coming-soon',
			xk: 'coming-soon',
			ye: 'coming-soon',
			za: 'coming-soon',
			zm: 'coming-soon',
			zw: 'coming-soon',
		},
		redirect: {
			dk: 'coming-soon',
			id: 'coming-soon',
			lt: 'jau-greitai',
			lv: 'drizuma',
			my: 'coming-soon',
			no: 'kommer-snart',
			se: 'coming-soon',
			th: 'coming-soon',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.Upcoming,
			contexts: ['filter'],
			tab: 'coming-soon',
		},
	},
	'app.titles.coming-soon.provider': {
		component: New,
		urls: {
			ad: 'plataforma/:provider/coming-soon',
			ae: 'provider/:provider/coming-soon',
			ag: 'provider/:provider/coming-soon',
			al: 'ofruesi/:provider/coming-soon',
			az: 'provayder/:provider/coming-soon',
			ao: 'provedor/:provider/coming-soon',
			ar: 'proveedor/:provider/coming-soon',
			at: 'Anbieter/:provider/demnaechst-verfuegbar',
			au: 'provider/:provider/coming-soon',
			ba: 'provajder/:provider/coming-soon',
			bb: 'provider/:provider/coming-soon',
			be: 'plateforme/:provider/coming-soon',
			bf: 'plateforme/:provider/coming-soon',
			bg: 'доставчик/:provider/налични-скоро',
			bh: 'provider/:provider/coming-soon',
			bm: 'provider/:provider/coming-soon',
			bo: 'proveedor/:provider/coming-soon',
			br: 'provedor/:provider/coming-soon',
			bs: 'provider/:provider/coming-soon',
			by: 'правайдэр/:provider/coming-soon',
			bz: 'provider/:provider/coming-soon',
			ca: 'provider/:provider/coming-soon',
			cd: 'plateforme/:provider/coming-soon',
			ch: 'Anbieter/:provider/coming-soon',
			ci: 'plateforme/:provider/coming-soon',
			cl: 'proveedor/:provider/coming-soon',
			cm: 'provider/:provider/coming-soon',
			co: 'proveedor/:provider/coming-soon',
			cr: 'proveedor/:provider/coming-soon',
			cu: 'proveedor/:provider/coming-soon',
			cv: 'provedor/:provider/coming-soon',
			cy: 'πάροχος/:provider/coming-soon',
			cz: 'poskytovatel/:provider/coming-soon',
			de: 'Anbieter/:provider/demnaechst-verfuegbar',
			dk: 'provider/:provider/coming-soon',
			do: 'proveedor/:provider/coming-soon',
			dz: 'provider/:provider/coming-soon',
			ec: 'proveedor/:provider/coming-soon',
			ee: 'teenusepakkuja/:provider/coming-soon',
			eg: 'provider/:provider/coming-soon',
			es: 'proveedor/:provider/llegaran-pronto',
			fi: 'palvelu/:provider/tulossa-pian',
			fj: 'provider/:provider/coming-soon',
			fr: 'plateforme/:provider/bientot-disponible',
			gf: 'plateforme/:provider/coming-soon',
			gg: 'provider/:provider/coming-soon',
			gh: 'provider/:provider/coming-soon',
			gi: 'provider/:provider/coming-soon',
			gq: 'proveedor/:provider/coming-soon',
			gr: 'πάροχος/:provider/coming-soon',
			gt: 'proveedor/:provider/coming-soon',
			gy: 'provider/:provider/coming-soon',
			hk: '供應商/:provider/coming-soon',
			hn: 'proveedor/:provider/coming-soon',
			hr: 'pružatelj-usluge/:provider/uskoro-u-ponudi',
			hu: 'szolgaltato/:provider/hamarosan-erkezik',
			id: 'provider/:provider/coming-soon',
			ie: 'provider/:provider/coming-soon',
			il: 'provider/:provider/coming-soon',
			in: 'provider/:provider/coming-soon',
			iq: 'provider/:provider/coming-soon',
			is: 'veita/:provider/vaentanlegt',
			it: 'provider/:provider/in-arrivo',
			jm: 'provider/:provider/coming-soon',
			jo: 'provider/:provider/coming-soon',
			jp: '動画配信サービス/:provider/coming-soon',
			ke: 'provider/:provider/coming-soon',
			kr: '동영상서비스/:provider/coming-soon',
			kw: 'provider/:provider/coming-soon',
			lb: 'provider/:provider/coming-soon',
			lc: 'provider/:provider/coming-soon',
			li: 'Anbieter/:provider/coming-soon',
			lt: 'tiekėjas/:provider/jau-greitai',
			lu: 'plateforme/:provider/coming-soon',
			lv: 'apgādātājs/:provider/drizuma',
			ly: 'provider/:provider/coming-soon',
			ma: 'provider/:provider/coming-soon',
			mc: 'plateforme/:provider/coming-soon',
			md: 'furnizor/:provider/coming-soon',
			me: 'provajder/:provider/coming-soon',
			mg: 'plateforme/:provider/coming-soon',
			mk: 'провајдер/:provider/coming-soon',
			ml: 'plateforme/:provider/coming-soon',
			mt: 'fornitur/:provider/coming-soon',
			mu: 'plateforme/:provider/coming-soon',
			mw: 'provider/:provider/coming-soon',
			mx: 'proveedor/:provider/coming-soon',
			my: 'provider/:provider/coming-soon',
			mz: 'provedor/:provider/coming-soon',
			ne: 'plateforme/:provider/coming-soon',
			ng: 'provider/:provider/coming-soon',
			ni: 'proveedor/:provider/coming-soon',
			nl: 'provider/:provider/binnenkort-beschikbaar',
			no: 'provider/:provider/kommer-snart',
			nz: 'provider/:provider/coming-soon',
			om: 'provider/:provider/coming-soon',
			pa: 'proveedor/:provider/coming-soon',
			pe: 'proveedor/:provider/coming-soon',
			pf: 'plateforme/:provider/coming-soon',
			pg: 'provider/:provider/coming-soon',
			ph: 'provider/:provider/coming-soon',
			pk: 'provider/:provider/coming-soon',
			pl: 'serwis-streamingowy/:provider/juz-wkrotce',
			ps: 'provider/:provider/coming-soon',
			pt: 'provedor/:provider/brevemente',
			py: 'proveedor/:provider/coming-soon',
			qa: 'provider/:provider/coming-soon',
			ro: 'furnizor/:provider/in-curand',
			rs: 'provajder/:provider/coming-soon',
			ru: 'провайдер/:provider/скоро-появится',
			sa: 'provider/:provider/coming-soon',
			sc: 'plateforme/:provider/coming-soon',
			se: 'leverantör/:provider/coming-soon',
			sg: 'provider/:provider/coming-soon',
			sk: 'poskytovateľ/:provider/coskoro-príde',
			si: 'ponudnik/:provider/coming-soon',
			sm: 'provider/:provider/coming-soon',
			sn: 'plateforme/:provider/coming-soon',
			sv: 'proveedor/:provider/kommer-snart',
			tt: 'provider/:provider/coming-soon',
			tc: 'provider/:provider/coming-soon',
			td: 'provider/:provider/coming-soon',
			th: 'provider/:provider/coming-soon',
			tn: 'provider/:provider/coming-soon',
			tr: 'saglayici/:provider/yayina-girecekler',
			tw: '平台/:provider/coming-soon',
			tz: 'mtoa-huduma/:provider/coming-soon',
			ua: 'провайдер/:provider/coming-soon',
			ug: 'provider/:provider/coming-soon',
			uk: 'provider/:provider/coming-soon',
			us: 'provider/:provider/coming-soon',
			uy: 'proveedor/:provider/coming-soon',
			va: 'provider/:provider/coming-soon',
			ve: 'proveedor/:provider/coming-soon',
			xk: 'ofruesi/:provider/coming-soon',
			ye: 'provider/:provider/coming-soon',
			za: 'provider/:provider/coming-soon',
			zm: 'provider/:provider/coming-soon',
			zw: 'provider/:provider/coming-soon',
		},
		redirect: {
			dk: 'udbyder/:provider/coming-soon',
			id: 'penyedia/:provider/coming-soon',
			lt: 'tiekėjas/:provider/jau-greitai',
			lv: 'apgādātājs/:provider/drizuma',
			my: 'pemberi/:provider/coming-soon',
			no: 'tjeneste/:provider/kommer-snart',
			se: 'leverantör/:provider/coming-soon',
			th: 'ผู้ให้บริการ/:provider/coming-soon',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.NEW,
			newPageType: NewPageType.Upcoming,
			contexts: ['filter'],
			tab: 'coming-soon',
		},
	},

	// --- UPCOMING ---
	'app.titles.upcoming.list': {
		component: Upcoming,
		urls: {
			de: 'demnaechst',
			es: 'proximamente',
			fr: 'prochainement',
			uk: 'upcoming',
			us: 'upcoming',
		},
		meta: { hasFilterBar: true, collectionType: CollectionType.UPCOMING, contexts: ['filter'], tab: 'upcoming' },
	},
	'app.titles.upcoming.movie': {
		component: Upcoming,
		urls: {
			de: 'Filme/demnaechst',
			es: 'peliculas/proximamente',
			fr: 'films/prochainement',
			uk: 'movies/upcoming',
			us: 'movies/upcoming',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.UPCOMING,
			initialRouteState: { content_types: [TitleObjectType.MOVIE] },
			contexts: ['filter'],
			tab: 'upcoming',
		},
	},
	'app.titles.upcoming.show': {
		component: Upcoming,
		urls: {
			de: 'Serien/demnaechst',
			es: 'series/proximamente',
			fr: 'series/prochainement',
			uk: 'tv-series/upcoming',
			us: 'tv-shows/upcoming',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.UPCOMING,
			initialRouteState: { content_types: [TitleObjectType.SHOW, TitleObjectType.SEASON] },
			contexts: ['filter'],
			tab: 'upcoming',
		},
	},
	'app.titles.upcoming.provider': {
		component: Upcoming,
		urls: {
			de: 'Anbieter/:provider/demnaechst',
			es: 'proveedor/:provider/proximamente',
			fr: 'plateforme/:provider/prochainement',
			uk: 'provider/:provider/upcoming',
			us: 'provider/:provider/upcoming',
		},
		meta: { hasFilterBar: true, collectionType: CollectionType.UPCOMING, contexts: ['filter'], tab: 'upcoming' },
	},
	'app.titles.upcoming.provider-movie': {
		component: Upcoming,
		urls: {
			de: 'Anbieter/:provider/demnaechst/Filme',
			es: 'proveedor/:provider/proximamente/peliculas',
			fr: 'plateforme/:provider/prochainement/films',
			uk: 'provider/:provider/upcoming/movies',
			us: 'provider/:provider/upcoming/movies',
		},
		meta: { hasFilterBar: true, collectionType: CollectionType.UPCOMING, contexts: ['filter'], tab: 'upcoming' },
	},
	'app.titles.upcoming.provider-show': {
		component: Upcoming,
		urls: {
			de: 'Anbieter/:provider/demnaechst/Serien',
			es: 'proveedor/:provider/proximamente/series',
			fr: 'plateforme/:provider/prochainement/series',
			uk: 'provider/:provider/upcoming/tv-series',
			us: 'provider/:provider/upcoming/tv-shows',
		},
		meta: { hasFilterBar: true, collectionType: CollectionType.UPCOMING, contexts: ['filter'], tab: 'upcoming' },
	},

	// --- TITLE DETAIL ---
	'app.detail.movies': {
		component: TitleDetail,
		urls: {
			ad: 'pellicula/:title',
			ae: 'movie/:title',
			ag: 'movie/:title',
			al: 'filmi/:title',
			az: 'film/:title',
			ao: 'filme/:title',
			ar: 'pelicula/:title',
			at: 'Film/:title',
			au: 'movie/:title',
			ba: 'film/:title',
			bb: 'movie/:title',
			be: 'film/:title',
			bf: 'film/:title',
			bg: 'филм/:title',
			bh: 'movie/:title',
			bm: 'movie/:title',
			bo: 'pelicula/:title',
			br: 'filme/:title',
			bs: 'movie/:title',
			by: 'фільм/:title',
			bz: 'movie/:title',
			ca: 'movie/:title',
			cd: 'film/:title',
			ch: 'Film/:title',
			ci: 'film/:title',
			cl: 'pelicula/:title',
			cm: 'movie/:title',
			co: 'pelicula/:title',
			cr: 'pelicula/:title',
			cu: 'pelicula/:title',
			cv: 'filme/:title',
			cy: 'ταινία/:title',
			cz: 'film/:title',
			de: 'Film/:title',
			dk: 'movie/:title',
			do: 'pelicula/:title',
			dz: 'movie/:title',
			ec: 'pelicula/:title',
			ee: 'filmi/:title',
			eg: 'movie/:title',
			es: 'pelicula/:title',
			fi: 'elokuva/:title',
			fj: 'movie/:title',
			fr: 'film/:title',
			gf: 'film/:title',
			gg: 'movie/:title',
			gh: 'movie/:title',
			gi: 'movie/:title',
			gq: 'pelicula/:title',
			gr: 'ταινία/:title',
			gt: 'pelicula/:title',
			gy: 'movie/:title',
			hk: '電影/:title',
			hn: 'pelicula/:title',
			hr: 'film/:title',
			hu: 'film/:title',
			id: 'movie/:title',
			ie: 'movie/:title',
			il: 'movie/:title',
			in: 'movie/:title',
			iq: 'movie/:title',
			is: 'kvikmynd/:title',
			it: 'film/:title',
			jm: 'movie/:title',
			jo: 'movie/:title',
			jp: '映画/:title',
			ke: 'movie/:title',
			kr: '영화/:title',
			kw: 'movie/:title',
			lb: 'movie/:title',
			lc: 'movie/:title',
			li: 'Film/:title',
			lt: 'filmas/:title',
			lu: 'film/:title',
			lv: 'filma/:title',
			ly: 'movie/:title',
			ma: 'movie/:title',
			mc: 'film/:title',
			md: 'film/:title',
			me: 'filmovi/:title',
			mg: 'film/:title',
			mk: 'филм/:title',
			ml: 'film/:title',
			mt: 'film/:title',
			mu: 'film/:title',
			mw: 'movie/:title',
			mx: 'pelicula/:title',
			my: 'movie/:title',
			mz: 'filme/:title',
			ne: 'film/:title',
			ng: 'movie/:title',
			ni: 'pelicula/:title',
			nl: 'movie/:title',
			no: 'movie/:title',
			nz: 'movie/:title',
			om: 'movie/:title',
			pa: 'pelicula/:title',
			pf: 'film/:title',
			pg: 'movie/:title',
			pe: 'pelicula/:title',
			ph: 'movie/:title',
			pk: 'movie/:title',
			pl: 'film/:title',
			ps: 'movie/:title',
			pt: 'filme/:title',
			py: 'pelicula/:title',
			qa: 'movie/:title',
			ro: 'film/:title',
			rs: 'filmovi/:title',
			ru: 'фильм/:title',
			sa: 'movie/:title',
			sc: 'film/:title',
			se: 'film/:title',
			sg: 'movie/:title',
			sk: 'film/:title',
			si: 'film/:title',
			sm: 'film/:title',
			sn: 'film/:title',
			sv: 'pelicula/:title',
			tc: 'movie/:title',
			td: 'movie/:title',
			th: 'movie/:title',
			tn: 'movie/:title',
			tr: 'film/:title',
			tt: 'movie/:title',
			tw: '電影/:title',
			tz: 'filamu/:title',
			ua: 'фільм/:title',
			ug: 'movie/:title',
			uk: 'movie/:title',
			us: 'movie/:title',
			uy: 'pelicula/:title',
			va: 'film/:title',
			ve: 'pelicula/:title',
			xk: 'filmi/:title',
			ye: 'movie/:title',
			za: 'movie/:title',
			zm: 'movie/:title',
			zw: 'movie/:title',
		},
		redirect: {
			dk: 'film/:title',
			id: 'film/:title',
			lt: 'filmas/:title',
			lv: 'filma/:title',
			my: 'filem/:title',
			no: 'film/:title',
			se: 'film/:title',
			th: 'ภาพยนต์/:title',
		},
		meta: {
			contexts: ['title'],
			tab: 'detail',
		},
	},
	'app.detail.show': {
		component: TitleDetail,
		urls: {
			ad: 'serie/:title',
			ae: 'tv-show/:title',
			ag: 'tv-show/:title',
			al: 'serial-televiziv/:title',
			az: 'televiziya-şousu/:title',
			ao: 'series/:title',
			ar: 'serie/:title',
			at: 'Serie/:title',
			au: 'tv-show/:title',
			ba: 'tv-serija/:title',
			bb: 'tv-show/:title',
			be: 'serie/:title',
			bf: 'serie/:title',
			bg: 'сериал/:title',
			bh: 'tv-show/:title',
			bm: 'tv-show/:title',
			bo: 'serie/:title',
			br: 'serie/:title',
			bs: 'tv-show/:title',
			by: 'серыял/:title',
			bz: 'tv-show/:title',
			ca: 'tv-show/:title',
			cd: 'serie/:title',
			ch: 'Serie/:title',
			ci: 'serie/:title',
			cl: 'serie/:title',
			cm: 'tv-show/:title',
			co: 'serie/:title',
			cr: 'serie/:title',
			cu: 'serie/:title',
			cv: 'serie/:title',
			cy: 'τηλεοπτική-σειρά/:title',
			cz: 'serial/:title',
			de: 'Serie/:title',
			dk: 'tv-series/:title',
			do: 'serie/:title',
			dz: 'tv-show/:title',
			ec: 'serie/:title',
			ee: 'tv-saated/:title',
			eg: 'tv-show/:title',
			es: 'serie/:title',
			fi: 'sarja/:title',
			fj: 'tv-show/:title',
			fr: 'serie/:title',
			gf: 'serie/:title',
			gg: 'tv-series/:title',
			gh: 'tv-show/:title',
			gi: 'tv-show/:title',
			gq: 'serie/:title',
			gr: 'τηλεοπτική-σειρά/:title',
			gt: 'serie/:title',
			gy: 'tv-show/:title',
			hk: '節目/:title',
			hn: 'serie/:title',
			hr: 'serija/:title',
			hu: 'tv-sorozat/:title',
			id: 'tv-show/:title',
			ie: 'tv-series/:title',
			il: 'tv-show/:title',
			in: 'tv-show/:title',
			iq: 'tv-show/:title',
			is: 'þáttur/:title',
			it: 'serie-tv/:title',
			jm: 'tv-show/:title',
			jo: 'tv-show/:title',
			jp: 'テレビ番組/:title',
			ke: 'tv-show/:title',
			kr: 'TV-프로그램/:title',
			kw: 'tv-show/:title',
			lb: 'tv-show/:title',
			lc: 'tv-show/:title',
			li: 'Serie/:title',
			lt: 'tv-laidos/:title',
			lu: 'serie/:title',
			lv: 'tv-šova/:title',
			ly: 'tv-show/:title',
			ma: 'tv-show/:title',
			mc: 'serie/:title',
			md: 'seriale/:title',
			me: 'tv-program/:title',
			mg: 'serie/:title',
			mk: 'тв-серија/:title',
			ml: 'serie/:title',
			mt: 'serje-televiżiva/:title',
			mu: 'serie/:title',
			mw: 'tv-show/:title',
			mx: 'serie/:title',
			my: 'tv-show/:title',
			mz: 'serie/:title',
			ne: 'serie/:title',
			ng: 'tv-show/:title',
			ni: 'serie/:title',
			nl: 'tv-series/:title',
			no: 'tv-series/:title',
			nz: 'tv-show/:title',
			om: 'tv-show/:title',
			pa: 'serie/:title',
			pe: 'serie/:title',
			pf: 'serie/:title',
			pg: 'tv-show/:title',
			ph: 'tv-show/:title',
			pk: 'tv-show/:title',
			pl: 'serial/:title',
			ps: 'tv-show/:title',
			pt: 'serie/:title',
			py: 'serie/:title',
			qa: 'tv-show/:title',
			ro: 'seriale/:title',
			rs: 'tv-program/:title',
			ru: 'сериал/:title',
			sa: 'tv-show/:title',
			sc: 'serie/:title',
			se: 'tv-serie/:title',
			sg: 'tv-show/:title',
			sk: 'seriál/:title',
			si: 'serija/:title',
			sm: 'serie-tv/:title',
			sn: 'serie/:title',
			sv: 'serie/:title',
			tc: 'tv-show/:title',
			td: 'tv-show/:title',
			th: 'tv-show/:title',
			tn: 'tv-show/:title',
			tr: 'tv-sovu/:title',
			tt: 'tv-show/:title',
			tw: '節目/:title',
			tz: 'onyesho-la-tv/:title',
			ua: 'телеcеріал/:title',
			ug: 'tv-show/:title',
			uk: 'tv-series/:title',
			us: 'tv-show/:title',
			uy: 'serie/:title',
			va: 'serie-tv/:title',
			ve: 'serie/:title',
			xk: 'serial-televiziv/:title',
			ye: 'tv-show/:title',
			za: 'tv-series/:title',
			zm: 'tv-series/:title',
			zw: 'tv-show/:title',
		},
		redirect: {
			dk: 'tv-serie/:title',
			id: 'acara-tv/:title',
			lt: 'tv-laidos/:title',
			lv: 'tv-šova/:title',
			my: 'rancangan-tv/:title',
			no: 'tv-serien/:title',
			se: 'tv-serie/:title',
			th: 'รายการทีวี/:title',
		},
		meta: {
			contexts: ['title'],
			tab: 'detail',
		},
	},
	'app.detail.show.season': {
		component: TitleDetail,
		urls: {
			ad: 'serie/:title/temporada-:season',
			ae: 'tv-show/:title/season-:season',
			ag: 'tv-show/:title/season-:season',
			al: 'serial-televiziv/:title/sezoni-:season',
			az: 'televiziya-şousu/:title/mövsüm-:season',
			ao: 'serie/:title/temporada-:season',
			ar: 'serie/:title/temporada-:season',
			at: 'Serie/:title/Staffel-:season',
			au: 'tv-show/:title/season-:season',
			ba: 'tv-serija/:title/sezona-:season',
			bb: 'tv-show/:title/season-:season',
			be: 'serie/:title/saison-:season',
			bf: 'serie/:title/saison-:season',
			bg: 'сериал/:title/сезон-:season',
			bh: 'tv-show/:title/season-:season',
			bm: 'tv-show/:title/season-:season',
			bo: 'serie/:title/temporada-:season',
			br: 'serie/:title/temporada-:season',
			bs: 'tv-show/:title/season-:season',
			by: 'серыял/:title/сезон-:season',
			bz: 'tv-show/:title/season-:season',
			ca: 'tv-show/:title/season-:season',
			cd: 'serie/:title/saison-:season',
			ch: 'Serie/:title/Staffel-:season',
			ci: 'serie/:title/saison-:season',
			cl: 'serie/:title/temporada-:season',
			cm: 'tv-show/:title/season-:season',
			co: 'serie/:title/temporada-:season',
			cr: 'serie/:title/temporada-:season',
			cu: 'serie/:title/temporada-:season',
			cv: 'serie/:title/temporada-:season',
			cy: 'τηλεοπτική-σειρά/:title/σεζόν-:season',
			cz: 'serial/:title/rada-:season',
			de: 'Serie/:title/Staffel-:season',
			dk: 'tv-series/:title/season-:season',
			do: 'serie/:title/temporada-:season',
			dz: 'tv-show/:title/season-:season',
			ec: 'serie/:title/temporada-:season',
			ee: 'tv-saated/:title/hooaeg-:season',
			eg: 'tv-show/:title/season-:season',
			es: 'serie/:title/temporada-:season',
			fi: 'sarja/:title/kausi-:season',
			fj: 'tv-show/:title/season-:season',
			fr: 'serie/:title/saison-:season',
			gf: 'serie/:title/saison-:season',
			gg: 'tv-series/:title/season-:season',
			gh: 'tv-show/:title/season-:season',
			gi: 'tv-show/:title/season-:season',
			gq: 'serie/:title/temporada-:season',
			gr: 'τηλεοπτική-σειρά/:title/σεζόν-:season',
			gt: 'serie/:title/temporada-:season',
			gy: 'tv-show/:title/season-:season',
			hk: '節目/:title/季-:season',
			hn: 'serie/:title/temporada-:season',
			hr: 'serija/:title/sezona-:season',
			hu: 'tv-sorozat/:title/evad-:season',
			id: 'tv-show/:title/season-:season',
			ie: 'tv-series/:title/season-:season',
			il: 'tv-show/:title/season-:season',
			in: 'tv-show/:title/season-:season',
			iq: 'tv-show/:title/season-:season',
			is: 'þáttur/:title/þáttaröð-:season',
			it: 'serie-tv/:title/stagione-:season',
			jm: 'tv-show/:title/season-:season',
			jo: 'tv-show/:title/season-:season',
			jp: 'テレビ番組/:title/シーズン-:season',
			ke: 'tv-show/:title/season-:season',
			kr: 'TV-프로그램/:title/시즌-:season',
			kw: 'tv-show/:title/season-:season',
			lb: 'tv-show/:title/season-:season',
			lc: 'tv-show/:title/season-:season',
			li: 'Serie/:title/Staffel-:season',
			lt: 'tv-laidos/:title/sezonas-:season',
			lu: 'serie/:title/saison-:season',
			lv: 'tv-šova/:title/sezonu-:season',
			ly: 'tv-show/:title/season-:season',
			ma: 'tv-show/:title/season-:season',
			mc: 'serie/:title/saison-:season',
			md: 'seriale/:title/sezon-:season',
			me: 'tv-programi/:title/sezona-:season',
			mg: 'serie/:title/saison-:season',
			mk: 'тв-серија/:title/сезона-:season',
			ml: 'serie/:title/saison-:season',
			mt: 'serje-televiżiva/:title/staġun-:season',
			mu: 'serie/:title/saison-:season',
			mw: 'tv-show/:title/season-:season',
			mx: 'serie/:title/temporada-:season',
			my: 'tv-show/:title/season-:season',
			mz: 'serie/:title/temporada-:season',
			ne: 'serie/:title/saison-:season',
			ng: 'tv-show/:title/season-:season',
			ni: 'serie/:title/temporada-:season',
			nl: 'tv-series/:title/season-:season',
			no: 'tv-series/:title/season-:season',
			nz: 'tv-show/:title/season-:season',
			om: 'tv-show/:title/season-:season',
			pa: 'serie/:title/temporada-:season',
			pe: 'serie/:title/temporada-:season',
			pf: 'serie/:title/saison-:season',
			pg: 'tv-show/:title/season-:season',
			ph: 'tv-show/:title/season-:season',
			pk: 'tv-show/:title/season-:season',
			pl: 'serial/:title/sezon-:season',
			ps: 'tv-show/:title/season-:season',
			pt: 'serie/:title/temporada-:season',
			py: 'serie/:title/temporada-:season',
			qa: 'tv-show/:title/season-:season',
			ro: 'seriale/:title/sezon-:season',
			rs: 'tv-programi/:title/sezona-:season',
			ru: 'сериал/:title/сезон-:season',
			sa: 'tv-show/:title/season-:season',
			sc: 'serie/:title/saison-:season',
			se: 'tv-serie/:title/säsong-:season',
			sg: 'tv-show/:title/season-:season',
			sk: 'seriál/:title/sezóna-:season',
			si: 'serija/:title/sezona-:season',
			sm: 'serie-tv/:title/stagione-:season',
			sn: 'serie/:title/saison-:season',
			sv: 'serie/:title/temporada-:season',
			tc: 'tv-show/:title/season-:season',
			td: 'tv-show/:title/season-:season',
			th: 'tv-show/:title/season-:season',
			tn: 'tv-show/:title/season-:season',
			tr: 'tv-sovu/:title/sezon-:season',
			tt: 'tv-show/:title/season-:season',
			tw: '節目/:title/季-:season',
			tz: 'onyesho-la-tv/:title/msimu-:season',
			ua: 'телеcеріал/:title/сезон-:season',
			ug: 'tv-show/:title/season-:season',
			uk: 'tv-series/:title/season-:season',
			us: 'tv-show/:title/season-:season',
			uy: 'serie/:title/temporada-:season',
			va: 'serie-tv/:title/stagione-:season',
			ve: 'serie/:title/temporada-:season',
			xk: 'serial-televiziv/:title/sezoni-:season',
			ye: 'tv-show/:title/season-:season',
			za: 'tv-series/:title/season-:season',
			zm: 'tv-series/:title/season-:season',
			zw: 'tv-show/:title/season-:season',
		},
		redirect: {
			dk: 'tv-serie/:title/sæson-:season',
			id: 'acara-tv/:title/musim-:season',
			lt: 'tv-laidos/:title/sezonas-:season',
			lv: 'tv-šova/:title/sezonu-:season',
			my: 'rancangan-tv/:title/siri-:season',
			no: 'tv-serien/:title/sesonger-:season',
			se: 'tv-serie/:title/säsong-:season',
			th: 'รายการทีวี/:title/ซีซั่น-:season',
		},
		meta: {
			contexts: ['title'],
			tab: 'detail',
		},
	},

	// SEARCH
	'app.search.list': {
		component: Search,
		urls: {
			ad: 'cerca',
			ae: 'search',
			ag: 'search',
			al: 'kërko',
			az: 'axtarış',
			ao: 'busca',
			ar: 'buscar',
			at: 'Suche',
			au: 'search',
			ba: 'traži',
			bb: 'search',
			be: 'recherche',
			bf: 'recherche',
			bg: 'search',
			bh: 'search',
			bm: 'search',
			bo: 'buscar',
			br: 'busca',
			bs: 'search',
			by: 'пошук',
			bz: 'search',
			ca: 'search',
			cd: 'recherche',
			ch: 'Suche',
			ci: 'recherche',
			cl: 'buscar',
			cm: 'search',
			co: 'buscar',
			cr: 'buscar',
			cu: 'buscar',
			cv: 'busca',
			cy: 'search',
			cz: 'vyhledání',
			de: 'Suche',
			dk: 'search',
			do: 'buscar',
			dz: 'search',
			ec: 'buscar',
			ee: 'otsing',
			eg: 'search',
			es: 'buscar',
			fi: 'etsi',
			fj: 'search',
			fr: 'recherche',
			gf: 'recherche',
			gg: 'search',
			gh: 'search',
			gi: 'search',
			gq: 'buscar',
			gr: 'search',
			gt: 'buscar',
			gy: 'search',
			hk: 'search',
			hn: 'buscar',
			hr: 'pretraživanje',
			hu: 'search',
			id: 'search',
			ie: 'search',
			il: 'search',
			in: 'search',
			iq: 'search',
			is: 'leita',
			it: 'cerca',
			jm: 'search',
			jo: 'search',
			jp: '検索',
			ke: 'search',
			kr: '검색',
			kw: 'search',
			lb: 'search',
			lc: 'search',
			li: 'Suche',
			lt: 'search',
			lu: 'recherche',
			lv: 'search',
			ly: 'search',
			ma: 'search',
			mc: 'recherche',
			md: 'search',
			me: 'pretraga',
			mg: 'recherche',
			mk: 'пребарување',
			ml: 'recherche',
			mt: 'fittex',
			mu: 'recherche',
			mw: 'search',
			mx: 'buscar',
			my: 'search',
			mz: 'busca',
			ne: 'recherche',
			ng: 'search',
			ni: 'buscar',
			nl: 'search',
			no: 'search',
			nz: 'search',
			om: 'search',
			pa: 'buscar',
			pe: 'buscar',
			pf: 'recherche',
			pg: 'search',
			ph: 'search',
			pk: 'search',
			pl: 'search',
			ps: 'search',
			pt: 'busca',
			py: 'buscar',
			qa: 'search',
			ro: 'search',
			rs: 'pretraga',
			ru: 'поиск',
			sa: 'search',
			sc: 'recherche',
			se: 'search',
			sg: 'search',
			sk: 'vyhľadávať',
			si: 'iskanje',
			sm: 'cerca',
			sn: 'recherche',
			sv: 'buscar',
			tc: 'search',
			td: 'search',
			th: 'search',
			tn: 'search',
			tr: 'arama',
			tt: 'search',
			tw: 'search',
			tz: 'tafuta',
			ua: 'пошук',
			ug: 'search',
			uk: 'search',
			us: 'search',
			uy: 'buscar',
			va: 'cerca',
			ve: 'buscar',
			xk: 'kërko',
			ye: 'search',
			za: 'search',
			zm: 'search',
			zw: 'search',
		},
		meta: { hasFilterBar: true, collectionType: CollectionType.SEARCH, contexts: ['filter'], tab: 'search' },
	},
	'app.shareable-lists': {
		component: ShareableLists,
		urls: {
			ad: 'lists',
			ae: 'lists',
			ag: 'lists',
			al: 'lists',
			ar: 'lists',
			at: 'lists',
			au: 'lists',
			ba: 'lists',
			bb: 'lists',
			be: 'lists',
			bg: 'lists',
			bh: 'lists',
			bm: 'lists',
			bo: 'lists',
			br: 'lists',
			bs: 'lists',
			ca: 'lists',
			ch: 'lists',
			ci: 'lists',
			cl: 'lists',
			co: 'lists',
			cr: 'lists',
			cu: 'lists',
			cv: 'lists',
			cz: 'lists',
			de: 'lists',
			dk: 'lists',
			do: 'lists',
			dz: 'lists',
			ec: 'lists',
			ee: 'lists',
			eg: 'lists',
			es: 'lists',
			fi: 'lists',
			fj: 'lists',
			fr: 'lists',
			gf: 'lists',
			gg: 'lists',
			gh: 'lists',
			gi: 'lists',
			gq: 'lists',
			gr: 'lists',
			gt: 'lists',
			hk: 'lists',
			hn: 'lists',
			hr: 'lists',
			hu: 'lists',
			id: 'lists',
			ie: 'lists',
			il: 'lists',
			in: 'lists',
			iq: 'lists',
			is: 'lists',
			it: 'lists',
			jm: 'lists',
			jo: 'lists',
			jp: 'lists',
			ke: 'lists',
			kr: 'lists',
			kw: 'lists',
			lb: 'lists',
			lc: 'lists',
			li: 'lists',
			lt: 'lists',
			lv: 'lists',
			ly: 'lists',
			ma: 'lists',
			mc: 'lists',
			md: 'lists',
			mk: 'lists',
			mt: 'lists',
			mu: 'lists',
			mx: 'lists',
			my: 'lists',
			mz: 'lists',
			ne: 'lists',
			ng: 'lists',
			nl: 'lists',
			no: 'lists',
			nz: 'lists',
			om: 'lists',
			pa: 'lists',
			pe: 'lists',
			pf: 'lists',
			ph: 'lists',
			pk: 'lists',
			pl: 'lists',
			ps: 'lists',
			pt: 'lists',
			py: 'lists',
			qa: 'lists',
			ro: 'lists',
			rs: 'lists',
			ru: 'lists',
			sa: 'lists',
			sc: 'lists',
			se: 'lists',
			sg: 'lists',
			sk: 'lists',
			si: 'lists',
			sm: 'lists',
			sn: 'lists',
			sv: 'lists',
			tc: 'lists',
			th: 'lists',
			tn: 'lists',
			tr: 'lists',
			tt: 'lists',
			tw: 'lists',
			ug: 'lists',
			uk: 'lists',
			us: 'lists',
			uy: 'lists',
			va: 'lists',
			ve: 'lists',
			xk: 'lists',
			ye: 'lists',
			za: 'lists',
			zm: 'lists',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.TITLELIST,
			contexts: ['filter'],
			tab: 'lists',
			initialRouteState: { content_types: [] },
		},
	},

	// WATCHLIST
	'app.watchlist.list': {
		component: Watchlist,
		urls: {
			ad: 'llista',
			ae: 'watchlist',
			ag: 'watchlist',
			al: 'lista-e-shikimit',
			az: 'baxış-siyahısı',
			ao: 'watchlist',
			ar: 'watchlist',
			at: 'WatchList',
			au: 'watchlist',
			ba: 'lista-za-gledanje',
			bb: 'watchlist',
			be: 'watchlist',
			bf: 'watchlist',
			bg: 'watchlist',
			bh: 'watchlist',
			bm: 'watchlist',
			bo: 'watchlist',
			br: 'watchlist',
			bs: 'watchlist',
			by: 'спіс-для-прагляду',
			bz: 'watchlist',
			ca: 'watchlist',
			cd: 'watchlist',
			ch: 'WatchList',
			ci: 'watchlist',
			cl: 'watchlist',
			cm: 'watchlist',
			co: 'watchlist',
			cr: 'watchlist',
			cu: 'watchlist',
			cv: 'watchlist',
			cy: 'watchlist',
			cz: 'watchlist',
			de: 'WatchList',
			dk: 'watchlist',
			do: 'watchlist',
			dz: 'watchlist',
			ec: 'watchlist',
			ee: 'watchlist',
			eg: 'watchlist',
			es: 'watchlist',
			fi: 'omalista',
			fj: 'watchlist',
			fr: 'watchlist',
			gf: 'watchlist',
			gg: 'watchlist',
			gh: 'watchlist',
			gi: 'watchlist',
			gq: 'watchlist',
			gr: 'watchlist',
			gt: 'watchlist',
			gy: 'watchlist',
			hk: '觀看片單',
			hn: 'watchlist',
			hr: 'watchlist',
			hu: 'watchlist',
			id: 'watchlist',
			ie: 'watchlist',
			il: 'watchlist',
			in: 'watchlist',
			iq: 'watchlist',
			is: 'watchlist',
			it: 'watchlist',
			jm: 'watchlist',
			jo: 'watchlist',
			jp: '視聴リスト',
			ke: 'watchlist',
			kr: '시청목록',
			kw: 'watchlist',
			lb: 'watchlist',
			lc: 'watchlist',
			li: 'WatchList',
			lt: 'watchlist',
			lu: 'watchlist',
			lv: 'watchlist',
			ly: 'watchlist',
			ma: 'watchlist',
			mc: 'watchlist',
			md: 'watchlist',
			me: 'spisak-za-gledanje',
			mg: 'watchlist',
			mk: 'листа-на-гледање',
			ml: 'watchlist',
			mt: 'lista-ta-viżjoni',
			mu: 'watchlist',
			mw: 'watchlist',
			mx: 'watchlist',
			my: 'watchlist',
			mz: 'watchlist',
			ne: 'watchlist',
			ng: 'watchlist',
			ni: 'watchlist',
			nl: 'watchlist',
			no: 'watchlist',
			nz: 'watchlist',
			om: 'watchlist',
			pa: 'watchlist',
			pe: 'watchlist',
			pf: 'watchlist',
			pg: 'watchlist',
			ph: 'watchlist',
			pk: 'watchlist',
			pl: 'watchlist',
			ps: 'watchlist',
			pt: 'watchlist',
			py: 'watchlist',
			qa: 'watchlist',
			ro: 'watchlist',
			rs: 'spisak-za-gledanje',
			ru: 'Избранное',
			sa: 'watchlist',
			sc: 'watchlist',
			se: 'watchlist',
			sg: 'watchlist',
			sk: 'watchlist',
			si: 'seznam',
			sm: 'watchlist',
			sn: 'watchlist',
			sv: 'watchlist',
			tc: 'watchlist',
			td: 'watchlist',
			th: 'watchlist',
			tn: 'watchlist',
			tr: 'watchlist',
			tt: 'watchlist',
			tw: '觀看清單',
			tz: 'orodha-ya-kutazama',
			ua: 'список-перегляду',
			ug: 'watchlist',
			uk: 'watchlist',
			us: 'watchlist',
			uy: 'watchlist',
			va: 'watchlist',
			ve: 'watchlist',
			xk: 'lista-e-shikimit',
			ye: 'watchlist',
			za: 'watchlist',
			zm: 'watchlist',
			zw: 'watchlist',
		},
		meta: {
			hasFilterBar: true,
			collectionType: CollectionType.WATCHLIST,
			contexts: ['filter'],
			tab: 'watchlist',
			initialRouteState: { content_types: [] },
		},
	},

	// TV LOGIN
	'app.tv.locale': {
		component: TvRegistration,
		urls: {
			ad: 'tv',
			ae: 'tv',
			ag: 'tv',
			al: 'tv',
			az: 'tv',
			ao: 'tv',
			ar: 'tv',
			at: 'tv',
			au: 'tv',
			ba: 'tv',
			bb: 'tv',
			be: 'tv',
			bf: 'tv',
			bg: 'tv',
			bh: 'tv',
			bm: 'tv',
			bo: 'tv',
			br: 'tv',
			bs: 'tv',
			by: 'tv',
			bz: 'tv',
			ca: 'tv',
			cd: 'tv',
			ch: 'tv',
			ci: 'tv',
			cl: 'tv',
			cm: 'tv',
			co: 'tv',
			cr: 'tv',
			cu: 'tv',
			cv: 'tv',
			cy: 'tv',
			cz: 'tv',
			de: 'tv',
			dk: 'tv',
			do: 'tv',
			dz: 'tv',
			ec: 'tv',
			ee: 'tv',
			eg: 'tv',
			es: 'tv',
			fi: 'tv',
			fj: 'tv',
			fr: 'tv',
			gf: 'tv',
			gg: 'tv',
			gh: 'tv',
			gi: 'tv',
			gq: 'tv',
			gr: 'tv',
			gt: 'tv',
			gy: 'tv',
			hk: 'tv',
			hn: 'tv',
			hr: 'tv',
			hu: 'tv',
			id: 'tv',
			ie: 'tv',
			il: 'tv',
			in: 'tv',
			iq: 'tv',
			is: 'tv',
			it: 'tv',
			jm: 'tv',
			jo: 'tv',
			jp: 'tv',
			ke: 'tv',
			kr: 'tv',
			kw: 'tv',
			lb: 'tv',
			lc: 'tv',
			li: 'tv',
			lt: 'tv',
			lu: 'tv',
			lv: 'tv',
			ly: 'tv',
			ma: 'tv',
			mc: 'tv',
			md: 'tv',
			me: 'tv',
			mg: 'tv',
			mk: 'тв',
			ml: 'tv',
			mt: 'tv',
			mu: 'tv',
			mw: 'tv',
			mx: 'tv',
			my: 'tv',
			mz: 'tv',
			ne: 'tv',
			ng: 'tv',
			ni: 'tv',
			nl: 'tv',
			no: 'tv',
			nz: 'tv',
			om: 'tv',
			pa: 'tv',
			pe: 'tv',
			pf: 'tv',
			pg: 'tv',
			ph: 'tv',
			pk: 'tv',
			pl: 'tv',
			ps: 'tv',
			pt: 'tv',
			py: 'tv',
			qa: 'tv',
			ro: 'tv',
			rs: 'tv',
			ru: 'tv',
			sa: 'tv',
			sc: 'tv',
			se: 'tv',
			sg: 'tv',
			sk: 'tv',
			si: 'tv',
			sm: 'tv',
			sn: 'tv',
			sv: 'tv',
			tc: 'tv',
			td: 'tv',
			th: 'tv',
			tn: 'tv',
			tr: 'tv',
			tt: 'tv',
			tw: 'tv',
			tz: 'tv',
			ua: 'tv',
			ug: 'tv',
			uk: 'tv',
			us: 'tv',
			uy: 'tv',
			va: 'tv',
			ve: 'tv',
			xk: 'tv',
			ye: 'tv',
			za: 'tv',
			zm: 'tv',
			zw: 'tv',
		},
		meta: {
			hasFilterBar: false,
			collectionType: CollectionType.GLOBAL,
			contexts: [],
			tab: 'tv',
		},
	},

	// TV LOGIN
	'app.tv.code': {
		component: TvRegistration,
		urls: {
			ad: 'tv/:code',
			ae: 'tv/:code',
			ag: 'tv/:code',
			al: 'tv/:code',
			az: 'tv/:code',
			ao: 'tv/:code',
			ar: 'tv/:code',
			at: 'tv/:code',
			au: 'tv/:code',
			ba: 'tv/:code',
			bb: 'tv/:code',
			be: 'tv/:code',
			bf: 'tv/:code',
			bg: 'tv/:code',
			bh: 'tv/:code',
			bm: 'tv/:code',
			bo: 'tv/:code',
			br: 'tv/:code',
			bs: 'tv/:code',
			by: 'tv/:code',
			bz: 'tv/:code',
			ca: 'tv/:code',
			cd: 'tv/:code',
			ch: 'tv/:code',
			ci: 'tv/:code',
			cl: 'tv/:code',
			cm: 'tv/:code',
			co: 'tv/:code',
			cr: 'tv/:code',
			cu: 'tv/:code',
			cv: 'tv/:code',
			cy: 'tv/:code',
			cz: 'tv/:code',
			de: 'tv/:code',
			dk: 'tv/:code',
			do: 'tv/:code',
			dz: 'tv/:code',
			ec: 'tv/:code',
			ee: 'tv/:code',
			eg: 'tv/:code',
			es: 'tv/:code',
			fi: 'tv/:code',
			fj: 'tv/:code',
			fr: 'tv/:code',
			gf: 'tv/:code',
			gg: 'tv/:code',
			gh: 'tv/:code',
			gi: 'tv/:code',
			gq: 'tv/:code',
			gr: 'tv/:code',
			gt: 'tv/:code',
			gy: 'tv/:code',
			hk: 'tv/:code',
			hn: 'tv/:code',
			hr: 'tv/:code',
			hu: 'tv/:code',
			id: 'tv/:code',
			ie: 'tv/:code',
			il: 'tv/:code',
			in: 'tv/:code',
			iq: 'tv/:code',
			is: 'tv/:code',
			it: 'tv/:code',
			jm: 'tv/:code',
			jo: 'tv/:code',
			jp: 'tv/:code',
			ke: 'tv/:code',
			kr: 'tv/:code',
			kw: 'tv/:code',
			lb: 'tv/:code',
			lc: 'tv/:code',
			li: 'tv/:code',
			lt: 'tv/:code',
			lu: 'tv/:code',
			lv: 'tv/:code',
			ly: 'tv/:code',
			ma: 'tv/:code',
			mc: 'tv/:code',
			md: 'tv/:code',
			me: 'tv/:code',
			mg: 'tv/:code',
			mk: 'tv/:code',
			ml: 'tv/:code',
			mt: 'tv/:code',
			mu: 'tv/:code',
			mw: 'tv/:code',
			mx: 'tv/:code',
			my: 'tv/:code',
			mz: 'tv/:code',
			ne: 'tv/:code',
			ng: 'tv/:code',
			ni: 'tv/:code',
			nl: 'tv/:code',
			no: 'tv/:code',
			nz: 'tv/:code',
			om: 'tv/:code',
			pa: 'tv/:code',
			pe: 'tv/:code',
			pf: 'tv/:code',
			pg: 'tv/:code',
			ph: 'tv/:code',
			pk: 'tv/:code',
			pl: 'tv/:code',
			ps: 'tv/:code',
			pt: 'tv/:code',
			py: 'tv/:code',
			qa: 'tv/:code',
			ro: 'tv/:code',
			rs: 'tv/:code',
			ru: 'tv/:code',
			sa: 'tv/:code',
			sc: 'tv/:code',
			se: 'tv/:code',
			sg: 'tv/:code',
			sk: 'tv/:code',
			si: 'tv/:code',
			sm: 'tv/:code',
			sn: 'tv/:code',
			sv: 'tv/:code',
			tc: 'tv/:code',
			td: 'tv/:code',
			th: 'tv/:code',
			tn: 'tv/:code',
			tr: 'tv/:code',
			tt: 'tv/:code',
			tw: 'tv/:code',
			tz: 'tv/:code',
			ua: 'tv/:code',
			ug: 'tv/:code',
			uk: 'tv/:code',
			us: 'tv/:code',
			uy: 'tv/:code',
			va: 'tv/:code',
			ve: 'tv/:code',
			xk: 'tv/:code',
			ye: 'tv/:code',
			za: 'tv/:code',
			zm: 'tv/:code',
			zw: 'tv/:code',
		},
		meta: {
			hasFilterBar: false,
			collectionType: CollectionType.GLOBAL,
			contexts: [],
			tab: 'tv',
		},
	},

	// LANDING PAGES
	'app.landingpage.talent': {
		component: Talent,
		urls: {
			ad: 'oportunitats',
			ae: 'talent',
			ag: 'talent',
			al: 'talenti',
			az: 'əməkdaşlar',
			ao: 'talent',
			ar: 'talent',
			at: 'talent',
			au: 'talent',
			ba: 'talenat',
			bb: 'talent',
			be: 'talent',
			bf: 'talent',
			bg: 'talent',
			bh: 'talent',
			bm: 'talent',
			bo: 'talent',
			br: 'talent',
			bs: 'talent',
			by: 'таленты',
			bz: 'talent',
			ca: 'talent',
			cd: 'talent',
			ch: 'talent',
			ci: 'talent',
			cl: 'talent',
			cm: 'talent',
			co: 'talent',
			cr: 'talent',
			cu: 'talent',
			cv: 'talent',
			cy: 'talent',
			cz: 'talent',
			de: 'talent',
			dk: 'talent',
			do: 'talent',
			dz: 'talent',
			ec: 'talent',
			ee: 'talent',
			eg: 'talent',
			es: 'talent',
			fi: 'talent',
			fj: 'talent',
			fr: 'talent',
			gf: 'talent',
			gg: 'talent',
			gh: 'talent',
			gi: 'talent',
			gq: 'talent',
			gr: 'talent',
			gt: 'talent',
			gy: 'talent',
			hk: 'talent',
			hn: 'talent',
			hr: 'talent',
			hu: 'talent',
			id: 'talent',
			ie: 'talent',
			il: 'talent',
			in: 'talent',
			iq: 'talent',
			is: 'talent',
			it: 'talent',
			jm: 'talent',
			jo: 'talent',
			jp: 'talent',
			ke: 'talent',
			kr: 'talent',
			kw: 'talent',
			lb: 'talent',
			lc: 'talent',
			li: 'talent',
			lt: 'talent',
			lu: 'talent',
			lv: 'talent',
			ly: 'talent',
			ma: 'talent',
			mc: 'talent',
			md: 'talent',
			me: 'talenat',
			mg: 'talent',
			mk: 'талент',
			ml: 'talent',
			si: 'ustvarjalec',
			mt: 'talent',
			mu: 'talent',
			mw: 'talent',
			mx: 'talent',
			my: 'talent',
			mz: 'talent',
			ne: 'talent',
			ng: 'talent',
			ni: 'talent',
			nl: 'talent',
			no: 'talent',
			nz: 'talent',
			om: 'talent',
			pa: 'talent',
			pe: 'talent',
			pf: 'talent',
			pg: 'talent',
			ph: 'talent',
			pk: 'talent',
			pl: 'talent',
			ps: 'talent',
			pt: 'talent',
			py: 'talent',
			qa: 'talent',
			ro: 'talent',
			rs: 'talenat',
			ru: 'talent',
			sa: 'talent',
			sc: 'talent',
			se: 'talent',
			sg: 'talent',
			sk: 'talent',
			sm: 'talent',
			sn: 'talent',
			sv: 'talent',
			tc: 'talent',
			td: 'talent',
			th: 'talent',
			tn: 'talent',
			tr: 'talent',
			tt: 'talent',
			tw: 'talent',
			tz: 'kipaji',
			ua: 'таланти',
			ug: 'talent',
			uk: 'talent',
			us: 'talent',
			uy: 'talent',
			va: 'talent',
			ve: 'talent',
			xk: 'talenti',
			ye: 'talent',
			za: 'talent',
			zm: 'talent',
			zw: 'talent',
		},
		meta: { tab: 'landingpage', data: 'talent' },
	},
	'app.landingpage.streamgreen': {
		component: StreamGreen,
		urls: {
			ad: 'co2-calculadora-streaming',
			ag: 'co2-streaming-calculator',
			al: 'co2-streaming-calculator',
			az: 'co2-streaming-calculator',
			ao: 'co2-streaming-calculadora',
			ba: 'co2-streaming-calculator',
			bb: 'co2-streaming-calculator',
			bm: 'co2-streaming-calculator',
			br: 'co2-streaming-calculadora',
			bf: 'co2-calculateur-streaming',
			bs: 'co2-streaming-calculator',
			by: 'co2-streaming-калькулятар',
			bz: 'co2-streaming-calculator',
			cd: 'co2-calculateur-streaming',
			ci: 'co2-calculateur-streaming',
			cm: 'co2-streaming-calculator',
			cu: 'co2-calculadora-streaming',
			cv: 'co2-streaming-calculadora',
			cy: 'co2-streaming-αριθμομηχανή',
			de: 'co2-streaming-rechner',
			do: 'co2-calculadora-streaming',
			es: 'co2-calculadora-streaming',
			fj: 'co2-streaming-calculator',
			fr: 'co2-calculateur-streaming',
			gf: 'co2-calculateur-streaming',
			gg: 'co2-streaming-calculator',
			gh: 'co2-streaming-calculator',
			gi: 'co2-streaming-calculator',
			gq: 'co2-calculadora-streaming',
			gy: 'co2-streaming-calculator',
			il: 'co2-streaming-calculator',
			iq: 'co2-streaming-calculator',
			it: 'co2-calcolatore-streaming',
			jm: 'co2-streaming-calculator',
			ke: 'co2-streaming-calculator',
			lb: 'co2-streaming-calculator',
			lc: 'co2-streaming-calculator',
			li: 'co2-streaming-rechner',
			lu: 'co2-calculateur-streaming',
			mc: 'co2-calculateur-streaming',
			me: 'co2-streaming-calculator',
			mg: 'co2-calculateur-streaming',
			mk: 'co2-streaming-calculator',
			ml: 'co2-calculateur-streaming',
			mt: 'co2-streaming-calculator',
			mu: 'co2-calculateur-streaming',
			mw: 'co2-streaming-calculator',
			mx: 'co2-calculadora-streaming',
			mz: 'co2-streaming-calculadora',
			ng: 'co2-streaming-calculator',
			ni: 'co2-calculadora-streaming',
			pa: 'co2-calculadora-streaming',
			pf: 'co2-calculateur-streaming',
			pg: 'co2-streaming-calculator',
			ps: 'co2-streaming-calculator',
			pt: 'co2-streaming-calculadora',
			rs: 'co2-streaming-calculator',
			sc: 'co2-calculateur-streaming',
			si: 'co2-streaming-calculator',
			sm: 'co2-calcolatore-streaming',
			sn: 'co2-calculateur-streaming',
			sv: 'co2-calculadora-streaming',
			tc: 'co2-streaming-calculator',
			td: 'co2-streaming-calculator',
			tt: 'co2-streaming-calculator',
			tz: 'co2-streaming-kikokotoo',
			ua: 'co2-streaming-калькулятор',
			ug: 'co2-streaming-calculator',
			us: 'co2-streaming-calculator',
			uy: 'co2-calculadora-streaming',
			va: 'co2-calcolatore-streaming',
			xk: 'co2-streaming-calculator',
			zm: 'co2-streaming-calculator',
			zw: 'co2-streaming-calculator',
		},
		meta: { tab: 'landingpage', data: 'streamgreen' },
	},
	'app.landingpage.plotrecommender': {
		component: PlotRecommender,
		urls: {
			ad: 'recomendador-de-peliculas-series',
			ag: 'tv-show-movie-generator',
			al: 'plot-recommender-movies-tv-shows',
			az: 'plot-recommender-movies-tv-shows',
			ao: 'recomendacao-filmes-programas',
			au: 'tv-show-movie-generator',
			ba: 'tv-show-movie-generator',
			bb: 'plot-recommender-movies-tv-shows',
			bf: 'intrigue-recommandation-films-series-tv',
			bm: 'plot-recommender-movies-tv-shows',
			br: 'recomendacao-filmes-programas',
			bs: 'plot-recommender-movies-tv-shows',
			by: 'сюжэт-рэкаменд-фільмы-сезон',
			bz: 'plot-recommender-movies-tv-shows',
			ca: 'tv-show-movie-finder',
			cd: 'intrigue-recommandation-films-series-tv',
			ci: 'intrigue-recommandation-films-series-tv',
			cm: 'tv-show-movie-finder',
			cu: 'recomendador-de-peliculas-series',
			cv: 'recomendacao-filmes-programas',
			cy: 'συντάκτης-πλοκής-ταινίες-τηλεοπτικές-σειρές',
			de: 'empfohlene-handlung-filme-und-serien',
			es: 'recomendador-de-peliculas-series',
			fj: 'tv-show-movie-finder',
			fr: 'intrigue-recommandation-films-series-tv',
			gf: 'intrigue-recommandation-films-series-tv',
			gg: 'tv-series-movie-generator',
			gh: 'plot-recommender-movies-tv-shows',
			gi: 'plot-recommender-movies-tv-shows',
			gq: 'recomendador-de-peliculas-series',
			gy: 'tv-show-movie-finder',
			ie: 'tv-series-movie-finder',
			il: 'plot-recommender-movies-tv-shows',
			in: 'tv-show-movie-finder',
			iq: 'tv-show-movie-finder',
			it: 'consigli-trama-film-serie-tv',
			jm: 'plot-recommender-movies-tv-shows',
			ke: 'plot-recommender-movies-tv-shows',
			lb: 'tv-show-movie-finder',
			lc: 'plot-recommender-movies-tv-shows',
			li: 'empfohlene-handlung-filme-und-serien',
			lu: 'intrigue-recommandation-films-series-tv',
			mc: 'intrigue-recommandation-films-series-tv',
			me: 'plot-recommender-movies-tv-shows',
			mg: 'intrigue-recommandation-films-series-tv',
			mk: 'plot-recommender-movies-tv-shows',
			ml: 'intrigue-recommandation-films-series-tv',
			mt: 'plot-recommender-movies-tv-shows',
			mu: 'intrigue-recommandation-films-series-tv',
			mw: 'plot-recommender-movies-tv-shows',
			mz: 'recomendacao-filmes-programas',
			ne: 'intrigue-recommandation-films-series-tv',
			ng: 'plot-recommender-movies-tv-shows',
			ni: 'recomendador-de-peliculas-series',
			nz: 'tv-show-movie-finder',
			pf: 'intrigue-recommandation-films-series-tv',
			pg: 'plot-recommender-movies-tv-shows',
			ps: 'tv-show-movie-finder',
			pt: 'recomendacao-filmes-programas',
			rs: 'plot-recommender-movies-tv-shows',
			sc: 'intrigue-recommandation-films-series-tv',
			si: 'plot-recommender-movies-tv-shows',
			sm: 'consigli-trama-film-serie-tv',
			sn: 'intrigue-recommandation-films-series-tv',
			tc: 'plot-recommender-movies-tv-shows',
			td: 'tv-show-movie-generator',
			tt: 'plot-recommender-movies-tv-shows',
			tz: 'mshauri-wa-njama-filamu-maonyesho-ya-tv',
			ua: 'рекомендувач-сюжету-фільми-телесеріали',
			ug: 'plot-recommender-movies-tv-shows',
			uk: 'tv-series-movie-generator',
			us: 'plot-recommender-movies-tv-shows',
			va: 'consigli-trama-film-serie-tv',
			xk: 'plot-recommender-movies-tv-shows',
			za: 'tv-series-movie-finder',
			zm: 'plot-recommender-movies-tv-shows',
			zw: 'plot-recommender-movies-tv-shows',
		},
		meta: { tab: 'landingpage', data: 'plotrecommender' },
	},
	'app.landingpage.contentoverlap': {
		component: ContentOverlapLp,
		urls: {
			us: 'compare-streaming-catalogs',
		},
		meta: { tab: 'landingpage', data: 'contentoverlap' },
	},
	'app.landingpage.tastyads': {
		component: TastyAds,

		urls: {
			us: 'tasty-ads/:genre',
			de: 'genre/:genre',
		},
		meta: { tab: 'landingpage', data: 'tastyads' },
	},
	'app.landingpage.tesla': {
		component: Tesla,
		urls: {
			ad: 'tesla',
			ag: 'tesla',
			au: 'tesla',
			al: 'tesla',
			az: 'tesla',
			ao: 'tesla',
			ba: 'tesla',
			bb: 'tesla',
			bf: 'tesla',
			bm: 'tesla',
			br: 'tesla',
			bs: 'tesla',
			by: 'tesla',
			bz: 'tesla',
			ca: 'tesla',
			cd: 'tesla',
			ci: 'tesla',
			cm: 'tesla',
			cu: 'tesla',
			cv: 'tesla',
			cy: 'tesla',
			de: 'tesla',
			es: 'tesla',
			fj: 'tesla',
			fr: 'tesla',
			gf: 'tesla',
			gg: 'tesla',
			gh: 'tesla',
			gi: 'tesla',
			gq: 'tesla',
			gy: 'tesla',
			ie: 'tesla',
			il: 'tesla',
			in: 'tesla',
			iq: 'tesla',
			it: 'tesla',
			jm: 'tesla',
			ke: 'tesla',
			lb: 'tesla',
			lc: 'tesla',
			li: 'tesla',
			lu: 'tesla',
			mc: 'tesla',
			me: 'tesla',
			mg: 'tesla',
			mk: 'tesla',
			ml: 'tesla',
			mt: 'tesla',
			mu: 'tesla',
			mw: 'tesla',
			mz: 'tesla',
			ne: 'tesla',
			ng: 'tesla',
			ni: 'tesla',
			nz: 'tesla',
			pf: 'tesla',
			pg: 'tesla',
			ps: 'tesla',
			pt: 'tesla',
			rs: 'tesla',
			sc: 'tesla',
			si: 'tesla',
			sm: 'tesla',
			sn: 'tesla',
			tc: 'tesla',
			td: 'tesla',
			tt: 'tesla',
			tz: 'tesla',
			ua: 'tesla',
			ug: 'tesla',
			uk: 'tesla',
			us: 'tesla',
			va: 'tesla',
			xk: 'tesla',
			za: 'tesla',
			zm: 'tesla',
			zw: 'tesla',
		},
		meta: { tab: 'landingpage', data: 'tesla' },
	},
	'app.landingpage.whatculture': {
		component: WhatCulture,
		urls: {
			au: 'whatculture',
			ca: 'whatculture',
			ie: 'whatculture',
			uk: 'whatculture',
			us: 'whatculture',
		},
		meta: { tab: 'landingpage', collectionType: CollectionType.TITLELIST },
	},
	'app.landingpage.oscars2023': {
		component: Oscars2023,
		urls: {
			ad: 'oscars-2023',
			ae: 'oscars-2023',
			ag: 'oscars-2023',
			ao: 'oscars-2023',
			ar: 'oscars-2023',
			at: 'oscars-2023',
			au: 'oscars-2023',
			al: 'oscars-2023',
			az: 'oscars-2023',
			ba: 'oscars-2023',
			bb: 'oscars-2023',
			be: 'oscars-2023',
			bf: 'oscars-2023',
			bg: 'oscars-2023',
			bh: 'oscars-2023',
			bm: 'oscars-2023',
			bo: 'oscars-2023',
			br: 'oscars-2023',
			bs: 'oscars-2023',
			by: 'oscars-2023',
			bz: 'oscars-2023',
			ca: 'oscars-2023',
			cd: 'oscars-2023',
			ch: 'oscars-2023',
			ci: 'oscars-2023',
			cl: 'oscars-2023',
			cm: 'oscars-2023',
			co: 'oscars-2023',
			cr: 'oscars-2023',
			cu: 'oscars-2023',
			cv: 'oscars-2023',
			cy: 'oscars-2023',
			cz: 'oscars-2023',
			de: 'oscars-2023',
			dk: 'oscars-2023',
			do: 'oscars-2023',
			dz: 'oscars-2023',
			ec: 'oscars-2023',
			ee: 'oscars-2023',
			eg: 'oscars-2023',
			es: 'oscars-2023',
			fi: 'oscars-2023',
			fj: 'oscars-2023',
			fr: 'oscars-2023',
			gf: 'oscars-2023',
			gg: 'oscars-2023',
			gh: 'oscars-2023',
			gi: 'oscars-2023',
			gq: 'oscars-2023',
			gr: 'oscars-2023',
			gt: 'oscars-2023',
			gy: 'oscars-2023',
			hk: 'oscars-2023',
			hn: 'oscars-2023',
			hr: 'oscars-2023',
			hu: 'oscars-2023',
			id: 'oscars-2023',
			ie: 'oscars-2023',
			il: 'oscars-2023',
			in: 'oscars-2023',
			iq: 'oscars-2023',
			is: 'oscars-2023',
			it: 'oscars-2023',
			jm: 'oscars-2023',
			jo: 'oscars-2023',
			jp: 'oscars-2023',
			ke: 'oscars-2023',
			kr: 'oscars-2023',
			kw: 'oscars-2023',
			lb: 'oscars-2023',
			lc: 'oscars-2023',
			li: 'oscars-2023',
			lt: 'oscars-2023',
			lu: 'oscars-2023',
			lv: 'oscars-2023',
			ly: 'oscars-2023',
			ma: 'oscars-2023',
			mc: 'oscars-2023',
			md: 'oscars-2023',
			me: 'oscars-2023',
			mg: 'oscars-2023',
			mk: 'oscars-2023',
			ml: 'oscars-2023',
			mt: 'oscars-2023',
			mu: 'oscars-2023',
			mw: 'oscars-2023',
			mx: 'oscars-2023',
			my: 'oscars-2023',
			mz: 'oscars-2023',
			ne: 'oscars-2023',
			ng: 'oscars-2023',
			ni: 'oscars-2023',
			nl: 'oscars-2023',
			no: 'oscars-2023',
			nz: 'oscars-2023',
			om: 'oscars-2023',
			pa: 'oscars-2023',
			pe: 'oscars-2023',
			pf: 'oscars-2023',
			pg: 'oscars-2023',
			ph: 'oscars-2023',
			pk: 'oscars-2023',
			pl: 'oscars-2023',
			ps: 'oscars-2023',
			pt: 'oscars-2023',
			py: 'oscars-2023',
			qa: 'oscars-2023',
			ro: 'oscars-2023',
			rs: 'oscars-2023',
			ru: 'oscars-2023',
			sa: 'oscars-2023',
			sc: 'oscars-2023',
			se: 'oscars-2023',
			sg: 'oscars-2023',
			si: 'oscars-2023',
			sk: 'oscars-2023',
			sm: 'oscars-2023',
			sn: 'oscars-2023',
			sv: 'oscars-2023',
			tc: 'oscars-2023',
			td: 'oscars-2023',
			th: 'oscars-2023',
			tn: 'oscars-2023',
			tr: 'oscars-2023',
			tt: 'oscars-2023',
			tw: 'oscars-2023',
			tz: 'oscars-2023',
			ua: 'oscars-2023',
			ug: 'oscars-2023',
			uk: 'oscars-2023',
			us: 'oscars-2023',
			uy: 'oscars-2023',
			va: 'oscars-2023',
			ve: 'oscars-2023',
			xk: 'oscars-2023',
			ye: 'oscars-2023',
			za: 'oscars-2023',
			zm: 'oscars-2023',
			zw: 'oscars-2023',
		},
		meta: { tab: 'landingpage', collectionType: CollectionType.TITLELIST },
	},
	'app.landingpage.valentine2023': {
		component: Valentine2023,
		urls: {
			ad: 'valentine-2023',
			ae: 'valentine-2023',
			ag: 'valentine-2023',
			ar: 'valentine-2023',
			at: 'valentine-2023',
			au: 'valentine-2023',
			al: 'valentine-2023',
			az: 'valentine-2023',
			ao: 'valentine-2023',
			ba: 'valentine-2023',
			bb: 'valentine-2023',
			bf: 'valentine-2023',
			be: 'valentine-2023',
			bg: 'valentine-2023',
			bh: 'valentine-2023',
			bm: 'valentine-2023',
			bo: 'valentine-2023',
			br: 'valentine-2023',
			bs: 'valentine-2023',
			by: 'valentine-2023',
			bz: 'valentine-2023',
			ca: 'valentine-2023',
			cd: 'valentine-2023',
			ch: 'valentine-2023',
			ci: 'valentine-2023',
			cm: 'valentine-2023',
			cl: 'valentine-2023',
			co: 'valentine-2023',
			cr: 'valentine-2023',
			cu: 'valentine-2023',
			cv: 'valentine-2023',
			cy: 'valentine-2023',
			cz: 'valentine-2023',
			de: 'valentine-2023',
			dk: 'valentine-2023',
			do: 'valentine-2023',
			dz: 'valentine-2023',
			ec: 'valentine-2023',
			ee: 'valentine-2023',
			eg: 'valentine-2023',
			es: 'valentine-2023',
			fi: 'valentine-2023',
			fj: 'valentine-2023',
			fr: 'valentine-2023',
			gf: 'valentine-2023',
			gg: 'valentine-2023',
			gh: 'valentine-2023',
			gi: 'valentine-2023',
			gq: 'valentine-2023',
			gy: 'valentine-2023',
			gr: 'valentine-2023',
			gt: 'valentine-2023',
			hk: 'valentine-2023',
			hn: 'valentine-2023',
			hr: 'valentine-2023',
			hu: 'valentine-2023',
			id: 'valentine-2023',
			ie: 'valentine-2023',
			il: 'valentine-2023',
			in: 'valentine-2023',
			iq: 'valentine-2023',
			is: 'valentine-2023',
			it: 'valentine-2023',
			jm: 'valentine-2023',
			jo: 'valentine-2023',
			jp: 'valentine-2023',
			ke: 'valentine-2023',
			kr: 'valentine-2023',
			kw: 'valentine-2023',
			lb: 'valentine-2023',
			lc: 'valentine-2023',
			li: 'valentine-2023',
			lu: 'valentine-2023',
			lt: 'valentine-2023',
			lv: 'valentine-2023',
			ly: 'valentine-2023',
			ma: 'valentine-2023',
			mc: 'valentine-2023',
			me: 'valentine-2023',
			mg: 'valentine-2023',
			md: 'valentine-2023',
			mk: 'valentine-2023',
			ml: 'valentine-2023',
			mt: 'valentine-2023',
			mu: 'valentine-2023',
			mw: 'valentine-2023',
			mx: 'valentine-2023',
			my: 'valentine-2023',
			mz: 'valentine-2023',
			ne: 'valentine-2023',
			ng: 'valentine-2023',
			ni: 'valentine-2023',
			nl: 'valentine-2023',
			no: 'valentine-2023',
			nz: 'valentine-2023',
			om: 'valentine-2023',
			pa: 'valentine-2023',
			pe: 'valentine-2023',
			pf: 'valentine-2023',
			pg: 'valentine-2023',
			ph: 'valentine-2023',
			pk: 'valentine-2023',
			pl: 'valentine-2023',
			ps: 'valentine-2023',
			pt: 'valentine-2023',
			py: 'valentine-2023',
			qa: 'valentine-2023',
			ro: 'valentine-2023',
			rs: 'valentine-2023',
			ru: 'valentine-2023',
			sa: 'valentine-2023',
			sc: 'valentine-2023',
			se: 'valentine-2023',
			sg: 'valentine-2023',
			si: 'valentine-2023',
			sk: 'valentine-2023',
			sm: 'valentine-2023',
			sn: 'valentine-2023',
			sv: 'valentine-2023',
			tc: 'valentine-2023',
			td: 'valentine-2023',
			th: 'valentine-2023',
			tn: 'valentine-2023',
			tr: 'valentine-2023',
			tt: 'valentine-2023',
			tz: 'valentine-2023',
			ua: 'valentine-2023',
			tw: 'valentine-2023',
			ug: 'valentine-2023',
			uk: 'valentine-2023',
			us: 'valentine-2023',
			uy: 'valentine-2023',
			va: 'valentine-2023',
			ve: 'valentine-2023',
			xk: 'valentine-2023',
			ye: 'valentine-2023',
			za: 'valentine-2023',
			zm: 'valentine-2023',
			zw: 'valentine-2023',
		},
		meta: { tab: 'landingpage', collectionType: CollectionType.TITLELIST },
	},
	'app.landingpage.collegesmostsuperbowlplayers': {
		component: CollegesMostSuperBowlPlayers,
		urls: {
			ad: 'sports/most-superbowl-players-by-college',
			ae: 'sports/most-superbowl-players-by-college',
			ag: 'sports/most-superbowl-players-by-college',
			ar: 'sports/most-superbowl-players-by-college',
			at: 'sports/most-superbowl-players-by-college',
			au: 'sports/most-superbowl-players-by-college',
			al: 'sports/most-superbowl-players-by-college',
			az: 'sports/most-superbowl-players-by-college',
			ba: 'sports/most-superbowl-players-by-college',
			bb: 'sports/most-superbowl-players-by-college',
			be: 'sports/most-superbowl-players-by-college',
			bg: 'sports/most-superbowl-players-by-college',
			bh: 'sports/most-superbowl-players-by-college',
			bm: 'sports/most-superbowl-players-by-college',
			bo: 'sports/most-superbowl-players-by-college',
			br: 'sports/most-superbowl-players-by-college',
			bs: 'sports/most-superbowl-players-by-college',
			ca: 'sports/most-superbowl-players-by-college',
			ch: 'sports/most-superbowl-players-by-college',
			ci: 'sports/most-superbowl-players-by-college',
			cl: 'sports/most-superbowl-players-by-college',
			co: 'sports/most-superbowl-players-by-college',
			cr: 'sports/most-superbowl-players-by-college',
			cu: 'sports/most-superbowl-players-by-college',
			cv: 'sports/most-superbowl-players-by-college',
			cz: 'sports/most-superbowl-players-by-college',
			de: 'sports/most-superbowl-players-by-college',
			dk: 'sports/most-superbowl-players-by-college',
			do: 'sports/most-superbowl-players-by-college',
			dz: 'sports/most-superbowl-players-by-college',
			ec: 'sports/most-superbowl-players-by-college',
			ee: 'sports/most-superbowl-players-by-college',
			eg: 'sports/most-superbowl-players-by-college',
			es: 'sports/most-superbowl-players-by-college',
			fi: 'sports/most-superbowl-players-by-college',
			fj: 'sports/most-superbowl-players-by-college',
			fr: 'sports/most-superbowl-players-by-college',
			gf: 'sports/most-superbowl-players-by-college',
			gg: 'sports/most-superbowl-players-by-college',
			gh: 'sports/most-superbowl-players-by-college',
			gi: 'sports/most-superbowl-players-by-college',
			gq: 'sports/most-superbowl-players-by-college',
			gr: 'sports/most-superbowl-players-by-college',
			gt: 'sports/most-superbowl-players-by-college',
			hk: 'sports/most-superbowl-players-by-college',
			hn: 'sports/most-superbowl-players-by-college',
			hr: 'sports/most-superbowl-players-by-college',
			hu: 'sports/most-superbowl-players-by-college',
			id: 'sports/most-superbowl-players-by-college',
			ie: 'sports/most-superbowl-players-by-college',
			il: 'sports/most-superbowl-players-by-college',
			in: 'sports/most-superbowl-players-by-college',
			iq: 'sports/most-superbowl-players-by-college',
			is: 'sports/most-superbowl-players-by-college',
			it: 'sports/most-superbowl-players-by-college',
			jm: 'sports/most-superbowl-players-by-college',
			jo: 'sports/most-superbowl-players-by-college',
			jp: 'sports/most-superbowl-players-by-college',
			ke: 'sports/most-superbowl-players-by-college',
			kr: 'sports/most-superbowl-players-by-college',
			kw: 'sports/most-superbowl-players-by-college',
			lb: 'sports/most-superbowl-players-by-college',
			lc: 'sports/most-superbowl-players-by-college',
			li: 'sports/most-superbowl-players-by-college',
			lt: 'sports/most-superbowl-players-by-college',
			lv: 'sports/most-superbowl-players-by-college',
			ly: 'sports/most-superbowl-players-by-college',
			ma: 'sports/most-superbowl-players-by-college',
			mc: 'sports/most-superbowl-players-by-college',
			md: 'sports/most-superbowl-players-by-college',
			mk: 'sports/most-superbowl-players-by-college',
			mt: 'sports/most-superbowl-players-by-college',
			mu: 'sports/most-superbowl-players-by-college',
			mx: 'sports/most-superbowl-players-by-college',
			my: 'sports/most-superbowl-players-by-college',
			mz: 'sports/most-superbowl-players-by-college',
			ne: 'sports/most-superbowl-players-by-college',
			ng: 'sports/most-superbowl-players-by-college',
			nl: 'sports/most-superbowl-players-by-college',
			no: 'sports/most-superbowl-players-by-college',
			nz: 'sports/most-superbowl-players-by-college',
			om: 'sports/most-superbowl-players-by-college',
			pa: 'sports/most-superbowl-players-by-college',
			pe: 'sports/most-superbowl-players-by-college',
			pf: 'sports/most-superbowl-players-by-college',
			ph: 'sports/most-superbowl-players-by-college',
			pk: 'sports/most-superbowl-players-by-college',
			pl: 'sports/most-superbowl-players-by-college',
			ps: 'sports/most-superbowl-players-by-college',
			pt: 'sports/most-superbowl-players-by-college',
			py: 'sports/most-superbowl-players-by-college',
			qa: 'sports/most-superbowl-players-by-college',
			ro: 'sports/most-superbowl-players-by-college',
			rs: 'sports/most-superbowl-players-by-college',
			ru: 'sports/most-superbowl-players-by-college',
			sa: 'sports/most-superbowl-players-by-college',
			sc: 'sports/most-superbowl-players-by-college',
			se: 'sports/most-superbowl-players-by-college',
			sg: 'sports/most-superbowl-players-by-college',
			si: 'sports/most-superbowl-players-by-college',
			sk: 'sports/most-superbowl-players-by-college',
			sm: 'sports/most-superbowl-players-by-college',
			sn: 'sports/most-superbowl-players-by-college',
			sv: 'sports/most-superbowl-players-by-college',
			tc: 'sports/most-superbowl-players-by-college',
			th: 'sports/most-superbowl-players-by-college',
			tn: 'sports/most-superbowl-players-by-college',
			tr: 'sports/most-superbowl-players-by-college',
			tt: 'sports/most-superbowl-players-by-college',
			tw: 'sports/most-superbowl-players-by-college',
			ug: 'sports/most-superbowl-players-by-college',
			uk: 'sports/most-superbowl-players-by-college',
			us: 'sports/most-superbowl-players-by-college',
			uy: 'sports/most-superbowl-players-by-college',
			va: 'sports/most-superbowl-players-by-college',
			ve: 'sports/most-superbowl-players-by-college',
			xk: 'sports/most-superbowl-players-by-college',
			ye: 'sports/most-superbowl-players-by-college',
			za: 'sports/most-superbowl-players-by-college',
			zm: 'most-superbowl-players-by-college',
		},
		meta: { tab: 'landingpage', collectionType: CollectionType.SPORTS },
	},
	'app.landingpage.expansionseasonsmls': {
		component: ExpansionSeasonsMLS,
		urls: {
			us: 'sports/best-expansion-season-mls',
		},
		meta: { tab: 'landingpage', collectionType: CollectionType.SPORTS },
	},
	'app.landingpage.nbaplayoffs': {
		component: NBAPlayoffs,
		urls: {
			us: 'sports/nba-players-most-games-not-making-playoffs',
		},
		meta: { tab: 'landingpage', collectionType: CollectionType.SPORTS },
	},
	'app.landingpage.subscriberform': {
		component: SubscriberForm,
		urls: {
			bb: 'insight-mails',
			bm: 'insight-mails',
			bs: 'insight-mails',
			gi: 'insight-mails',
			jm: 'insight-mails',
			us: 'insight-mails',
		},
		meta: { tab: 'landingpage', data: 'subscriberform' },
	},
	'app.landingpage.curatedlist': {
		component: CuratedList,
		urls: {
			li: 'DavidHain',
			de: 'DavidHain',
		},
		meta: { tab: 'landingpage', collectionType: CollectionType.TITLELIST },
	},

	// INDEXABLE GENRE PAGES
	// 'app.titles.popular.provider.genre': {
	// 	component: Popular,
	// 	urls: {
	// 		de: 'Anbieter/:provider/:genre',
	// 		es: 'proveedor/:provider/:genre',
	// 		fr: 'plateforme/:provider/:genre',
	// 		it: 'provider/:provider/:genre',
	// 		us: 'provider/:provider/:genre',
	// 	},
	// 	meta: { hasFilterBar: true, collectionType: CollectionType.POPULAR, contexts: ['filter'], tab: 'popular' },
	// },
	// 'app.titles.popular.provider-movie.genre': {
	// 	component: Popular,
	// 	urls: {
	// 		de: 'Anbieter/:provider/Filme/:genre',
	// 		es: 'proveedor/:provider/peliculas/:genre',
	// 		fr: 'plateforme/:provider/films/:genre',
	// 		it: 'provider/:provider/film/:genre',
	// 		us: 'provider/:provider/movies/:genre',
	// 	},
	// 	meta: {
	// 		hasFilterBar: true,
	// 		collectionType: CollectionType.POPULAR,
	// 		initialRouteState: { content_types: [TitleObjectType.MOVIE] },
	// 		contexts: ['filter'],
	// 		tab: 'popular',
	// 	},
	// },
	// 'app.titles.popular.provider-show.genre': {
	// 	component: Popular,
	// 	urls: {
	// 		de: 'Anbieter/:provider/Serien/:genre',
	// 		es: 'proveedor/:provider/series/:genre',
	// 		fr: 'plateforme/:provider/series/:genre',
	// 		it: 'provider/:provider/serie-tv/:genre',
	// 		us: 'provider/:provider/tv-shows/:genre',
	// 	},
	// 	meta: {
	// 		hasFilterBar: true,
	// 		collectionType: CollectionType.POPULAR,
	// 		initialRouteState: { content_types: [TitleObjectType.SHOW] },
	// 		contexts: ['filter'],
	// 		tab: 'popular',
	// 	},
	// },
};

export function makeAppRoutes(webLocale: WebLocale) {
	const routes: VueRouteConfig[] = [];

	for (const name in routeConfig) {
		const rawRoute = (<ResolvedRouteConfig>routeConfig)[name as RouteNames];

		// skip the route config item if it doesn't have an url for the current webLocale
		if (rawRoute.urls[webLocale] != null) {
			routes.push({
				name,
				path: `/${webLocale}/${encodePath(rawRoute.urls[webLocale] || '')}`,
				alias: `/${webLocale}/${rawRoute.urls[webLocale] || ''}`,
				component: rawRoute.component,
				meta: { ...rawRoute.meta },
			});
		}

		if (rawRoute.redirect?.[webLocale] != null) {
			routes.push({
				path: `/${webLocale}/${encodePath(rawRoute.redirect[webLocale] || '')}`,
				alias: `/${webLocale}/${rawRoute.redirect[webLocale] || ''}`,
				redirect: `/${webLocale}/${encodePath(rawRoute.urls[webLocale] || '')}`,
			});
		}
	}

	return routes;
}

/**
 * used to determine the initial routing state (FilterCollection) by its routeName alone, without parameters.
 * d.g. app.titles.popular.movie => { content_types: ['movie'] }
 */
export const initialRouteState = Object.keys(routeConfig).reduce((root, key) => {
	root[key as RouteNames] = (<ResolvedRouteConfig>routeConfig)[key as RouteNames]?.meta?.initialRouteState ?? {};
	return root;
}, {} as Record<RouteNames, Partial<FilterCollection>>);

// encodes path with encodeURI but skips ":" that is used for parameters
function encodePath(path: string) {
	return path
		.split(':')
		.map(part => encodeURI(part))
		.join(':');
}
